
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8ThhQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<8eb8584484c039944b7ca7e9b6f28d2e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1a9d70ad6034bafd$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "PageContentRendererFabricReadFragment",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$1a9d70ad6034bafd$var$node.hash = "637c5a5de1c828d584889d0d0b4f34f3";
var $1a9d70ad6034bafd$export$2e2bcd8739ae039 = $1a9d70ad6034bafd$var$node;


/**
 * @generated SignedSource<<d42bcd6ea35b1a1e3ffcb555feada77e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f892729dfaf9dece$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "PageContentRendererFabricReadFragmentWithAppKey",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$f892729dfaf9dece$var$node.hash = "dc90bc769cff734dcfc8a48b9327b946";
var $f892729dfaf9dece$export$2e2bcd8739ae039 = $f892729dfaf9dece$var$node;



var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $8C5kA = parcelRequire("8C5kA");


var $T1bCI = parcelRequire("T1bCI");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $kYvrE = parcelRequire("kYvrE");


var $f7lNm = parcelRequire("f7lNm");

var $eVM9z = parcelRequire("eVM9z");


var $le4yZ = parcelRequire("le4yZ");

var $kNfRw = parcelRequire("kNfRw");


var $h0UOA = parcelRequire("h0UOA");


var $kdOv6 = parcelRequire("kdOv6");


var $hEeUR = parcelRequire("hEeUR");


var $7mpOv = parcelRequire("7mpOv");


var $8Ij3v = parcelRequire("8Ij3v");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $hrAmX = parcelRequire("hrAmX");


var $7d2Nc = parcelRequire("7d2Nc");


var $1YPul = parcelRequire("1YPul");


var $brNvA = parcelRequire("brNvA");


var $8i27m = parcelRequire("8i27m");


var $WheoQ = parcelRequire("WheoQ");


var $dANtQ = parcelRequire("dANtQ");


var $6mKj3 = parcelRequire("6mKj3");


var $isEtk = parcelRequire("isEtk");


var $gw4Eo = parcelRequire("gw4Eo");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $eToX6 = parcelRequire("eToX6");


var $jmjWc = parcelRequire("jmjWc");


const $a2898f6304bad9ac$export$4f87e2b96269dff7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YX9dT",
    name: "InvisibleLoadingContainer",
    loader: async ()=>(await (parcelRequire("8tGpb"))).InvisibleLoadingContainer
});


/* RendererTextHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $kyKWe = parcelRequire("kyKWe");





var $9pwVP = parcelRequire("9pwVP");

var $jWDKZ = parcelRequire("jWDKZ");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $9oxdN = parcelRequire("9oxdN");


var $9wGTI = parcelRequire("9wGTI");


var $fovJE = parcelRequire("fovJE");


var $bjVRl = parcelRequire("bjVRl");

const $f632232661ebd6b0$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rkb99z": (0, $7sObp.default)(!!__cmplp.active ? 'linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1))' : 'none')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7y4f7 _5pioz8co _189e1dm9 _n3tdv77o _1il9nqa1 _19lc184f _d0altlke",
            __cmplp.className
        ])
    });
});
const $f632232661ebd6b0$var$RendererTextHighlighterComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ category: category, children: children })=>{
    const readingAidsSessionId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()).current;
    const [active, setActive] = (0, $42omo.useState)(false);
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showAutohighlightPopup: showAutohighlightPopup, hideAutohighlightPopup: hideAutohighlightPopup, showAutohighlightSpotlight: showAutohighlightSpotlight, setAutohighlightHovered: setAutohighlightHovered } = (0, $bjVRl.useReadingAidsActions)();
    const { showPopup: showPopup, popupLoading: popupLoading, portalContainerRef: portalContainerRef, defineDefinitionOpen: defineDefinitionOpen } = (0, $bjVRl.useReadingAidsState)();
    const [spotlightEnabled] = (0, $9oxdN.useFeatureDiscovery)((0, $fovJE.READING_AIDS_ACRONYM_SPOTLIGHT_MESSAGE_ID));
    let onHighlightClickWrapper;
    const handleAcronymMouseOver = (0, $42omo.useCallback)(async (e)=>{
        if (!spotlightEnabled) return;
        const eventTarget = e.target;
        if (!portalContainerRef?.current || !eventTarget) return;
        const portalRect = portalContainerRef.current.getBoundingClientRect();
        const rect = eventTarget.getBoundingClientRect();
        const selectedRect = {
            top: rect.top - portalRect.top,
            left: rect.left - portalRect.left,
            width: rect.width,
            height: rect.height
        };
        await showAutohighlightSpotlight({
            autohighlightSelectionRect: selectedRect
        });
    }, [
        portalContainerRef,
        showAutohighlightSpotlight,
        spotlightEnabled
    ]);
    const handleAcronymMouseIn = (0, $42omo.useCallback)(()=>{
        setAutohighlightHovered({
            autohighlightHovered: true
        });
    }, [
        setAutohighlightHovered
    ]);
    const handleAcronymMouseOut = (0, $42omo.useCallback)(()=>{
        setAutohighlightHovered({
            autohighlightHovered: false
        });
    }, [
        setAutohighlightHovered
    ]);
    const handleAcronymClick = (0, $42omo.useCallback)(async (e)=>{
        if (showPopup || defineDefinitionOpen) {
            if (popupLoading) return;
            hideAutohighlightPopup();
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const eventTarget = e.target;
        if (!portalContainerRef?.current || !eventTarget) return;
        const selectedContext = eventTarget.parentElement;
        const additionalContext = selectedContext ? selectedContext.textContent || selectedContext.innerText : '';
        const portalRect = portalContainerRef.current.getBoundingClientRect();
        const rect = eventTarget.getBoundingClientRect();
        const selectedRect = {
            top: rect.top - portalRect.top,
            left: rect.left - portalRect.left,
            width: rect.width,
            height: rect.height
        };
        setActive(true);
        showAutohighlightPopup({
            autohighlightText: eventTarget.textContent || eventTarget.innerText || '',
            autohighlightContext: additionalContext,
            autohighlightSelectionRect: selectedRect,
            lastAcronymReset: ()=>setActive(false),
            sessionId: readingAidsSessionId
        });
        experienceTracker.start({
            name: (0, $irVI7.READING_AIDS_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: 'acronymHighlight'
            }
        });
        if ((0, $9wGTI.fg)('kd_definitions_click_and_show_event_product_parity')) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: (0, $9pwVP.onClickAutoDefinitionHighlights)({
                contentId: contentId,
                sessionId: readingAidsSessionId,
                keyPhraseCategory: category
            })
        }).fire();
        else createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'readingAidsAcronymHighlight',
                source: 'viewPageScreen',
                attributes: {
                    contentId: contentId,
                    readingAidsSessionId: readingAidsSessionId,
                    keyPhraseCategory: category
                }
            }
        }).fire();
    }, [
        category,
        readingAidsSessionId,
        contentId,
        createAnalyticsEvent,
        experienceTracker,
        hideAutohighlightPopup,
        portalContainerRef,
        showAutohighlightPopup,
        showPopup,
        popupLoading,
        defineDefinitionOpen
    ]);
    if ((0, $9wGTI.fg)('kd_definitions_handle_double_click_confluence')) // eslint-disable-next-line react-hooks/rules-of-hooks
    onHighlightClickWrapper = (0, $jWDKZ.useTextHighlighterClick)({
        singleClickCallback: handleAcronymClick,
        doubleClickCallback: ()=>{} // do nothing, actions menu takes over
    });
    else onHighlightClickWrapper = handleAcronymClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f632232661ebd6b0$var$Wrapper, {
        active: (0, $9wGTI.fg)('kd_definitions_loading_state_confluence') ? undefined : active,
        style: active && (0, $9wGTI.fg)('kd_definitions_loading_state_confluence') ? {
            borderBottomStyle: 'none'
        } : {},
        className: "acronym-highlight",
        onClick: onHighlightClickWrapper,
        onMouseOver: handleAcronymMouseOver,
        onMouseEnter: handleAcronymMouseIn,
        onMouseLeave: handleAcronymMouseOut,
        "data-testid": "acronym-highlight"
    }, children);
});
const $f632232661ebd6b0$var$existingMap = new Map();
const $f632232661ebd6b0$var$RendererTextHighlighterWithoutErrorHandling = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, match: match, marks: marks, startPos: startPos, keyPhrases: keyPhrases = [] })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const autoHighlightedPhrases = keyPhrases ? keyPhrases.map((node)=>({
            phrase: node.keyPhrase,
            category: node.category
        })) : [];
    if (!$f632232661ebd6b0$var$existingMap.has(`${contentId}-${match}`)) $f632232661ebd6b0$var$existingMap.set(`${contentId}-${match}`, startPos);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $f632232661ebd6b0$var$existingMap.delete(`${contentId}-${match}`);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!(marks.has('annotation') || marks.has('link'))) {
        const nodeMatch = autoHighlightedPhrases.find((node)=>node.phrase === match);
        if (!!nodeMatch && $f632232661ebd6b0$var$existingMap.get(`${contentId}-${match}`) === startPos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f632232661ebd6b0$var$RendererTextHighlighterComponent, {
            category: nodeMatch.category
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
});
const $f632232661ebd6b0$export$524ca09d83a1460f = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($f632232661ebd6b0$var$RendererTextHighlighterWithoutErrorHandling);



var $gKMkU = parcelRequire("gKMkU");


var $7rLBD = parcelRequire("7rLBD");


var $97Szk = parcelRequire("97Szk");


var $ayQVU = parcelRequire("ayQVU");


var $b3j2Y = parcelRequire("b3j2Y");





var $4PPzL = parcelRequire("4PPzL");











const $fef48aa9e4834ddc$export$908769aa3104966 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "6h_q3",
    name: "InlineCommentNudge",
    loader: async ()=>(await (parcelRequire("h9CEi"))).InlineCommentNudge
});



var $h8C1D = parcelRequire("h8C1D");


var $iKSlH = parcelRequire("iKSlH");





var $fFmJj = parcelRequire("fFmJj");


var $1ITQ3 = parcelRequire("1ITQ3");


var $gKr8t = parcelRequire("gKr8t");


var $k8e76 = parcelRequire("k8e76");


var $iVane = parcelRequire("iVane");





const $7d721eb932133019$export$b905eb318829d354 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Ply1f",
    name: "ReattachCommentPanelLoader",
    loader: async ()=>(await (parcelRequire("1wUq9"))).ReattachCommentPanel
});















var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $78QFu = parcelRequire("78QFu");


var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $875dea1a5468a6c1$export$1385b034c137348a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.MEDIA_SEGMENT_KEY)
});


const $72e3a5d49a76ae4e$var$mediaAnalyticsRefDefault = {
    succeededSPAMedia: 0,
    waitingSPAMedia: 0,
    failedSPAMedia: 0,
    succeededSSRMedia: 0,
    waitingSSRMedia: 0,
    failedSSRMedia: 0,
    mediaFileIds: null,
    ssrFmpStarted: false,
    spaFmpStarted: false,
    longestTTIDuration: null,
    longestSSRMediaLoadTime: null,
    pageLoadInfo: null
};
const $72e3a5d49a76ae4e$var$clearMediaSourcesAndRef = (mediaAnalyticsRef)=>{
    if (window._contentMediaSources) window._contentMediaSources = null;
    mediaAnalyticsRef.current = $72e3a5d49a76ae4e$var$mediaAnalyticsRefDefault;
};
const $72e3a5d49a76ae4e$var$handleMediaMetricStop = (mediaAnalyticsRef)=>{
    const { succeededSPAMedia: succeededSPAMedia, waitingSPAMedia: waitingSPAMedia, failedSPAMedia: failedSPAMedia, succeededSSRMedia: succeededSSRMedia, waitingSSRMedia: waitingSSRMedia, failedSSRMedia: failedSSRMedia, spaFmpStarted: spaFmpStarted, longestTTIDuration: longestTTIDuration } = mediaAnalyticsRef.current;
    (0, $875dea1a5468a6c1$export$1385b034c137348a).stop({
        stopTime: longestTTIDuration || undefined,
        customData: {
            succeededSPAMedia: succeededSPAMedia,
            waitingSPAMedia: waitingSPAMedia,
            failedSPAMedia: failedSPAMedia,
            succeededSSRMedia: succeededSSRMedia,
            waitingSSRMedia: waitingSSRMedia,
            failedSSRMedia: failedSSRMedia,
            spaRenderedBeforeSSRMedia: spaFmpStarted,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        }
    });
    $72e3a5d49a76ae4e$var$clearMediaSourcesAndRef(mediaAnalyticsRef);
};
const $72e3a5d49a76ae4e$var$updateSPAMetricsAndFileIds = (duration, isSucceededEvent, fileIdIndex, mediaAnalyticsRef)=>{
    const { mediaFileIds: mediaFileIds, succeededSPAMedia: succeededSPAMedia, failedSPAMedia: failedSPAMedia, longestTTIDuration: longestTTIDuration } = mediaAnalyticsRef.current;
    const tempMediaFileIds = [
        ...mediaFileIds || []
    ];
    tempMediaFileIds.splice(fileIdIndex, 1);
    mediaAnalyticsRef.current = {
        ...mediaAnalyticsRef.current,
        mediaFileIds: tempMediaFileIds,
        succeededSPAMedia: isSucceededEvent ? succeededSPAMedia + 1 : succeededSPAMedia,
        waitingSPAMedia: tempMediaFileIds.length,
        failedSPAMedia: !isSucceededEvent ? failedSPAMedia + 1 : failedSPAMedia,
        longestTTIDuration: longestTTIDuration && longestTTIDuration > duration ? longestTTIDuration : duration
    };
    if (tempMediaFileIds.length === 0) $72e3a5d49a76ae4e$var$handleMediaMetricStop(mediaAnalyticsRef);
};
const $72e3a5d49a76ae4e$var$incrementSuccessOrFailureValue = (entryName, value)=>{
    window._contentMediaSources.forEach((source)=>{
        if (source === entryName) value++;
    });
    return value;
};
const $72e3a5d49a76ae4e$var$captureSSRMediaResourceTimings = ()=>{
    let succeededSSRMedia = 0;
    let failedSSRMedia = 0;
    let waitingSSRMedia = 0;
    let longestSSRMediaLoadTime = 0;
    if (window?._contentMediaSources?.length) {
        const resourceEntries = performance.getEntriesByType('resource');
        if (resourceEntries && resourceEntries.length > 0) resourceEntries.forEach((entry)=>{
            const value = 'initiatorType' in entry;
            if (value && entry?.initiatorType === 'img' && window._contentMediaSources.indexOf(entry?.name) > -1) {
                // Duration will be 0 in some failure cases so we want to check for that,
                // and we also want to make sure responseEnd is available and non-zero.
                if (entry.duration && entry.responseEnd) {
                    succeededSSRMedia = $72e3a5d49a76ae4e$var$incrementSuccessOrFailureValue(entry.name, succeededSSRMedia);
                    longestSSRMediaLoadTime = entry.responseEnd > longestSSRMediaLoadTime ? entry.responseEnd : longestSSRMediaLoadTime;
                } else failedSSRMedia = $72e3a5d49a76ae4e$var$incrementSuccessOrFailureValue(entry.name, failedSSRMedia);
            }
        });
        waitingSSRMedia = window._contentMediaSources.length - (succeededSSRMedia + failedSSRMedia);
    }
    return {
        succeededSSRMedia: succeededSSRMedia,
        failedSSRMedia: failedSSRMedia,
        waitingSSRMedia: waitingSSRMedia,
        longestSSRMediaLoadTime: longestSSRMediaLoadTime
    };
};
const $72e3a5d49a76ae4e$var$startMediaMetric = (mediaAnalyticsRef)=>{
    const { succeededSSRMedia: succeededSSRMedia, failedSSRMedia: failedSSRMedia, waitingSSRMedia: waitingSSRMedia, longestSSRMediaLoadTime: longestSSRMediaLoadTime } = $72e3a5d49a76ae4e$var$captureSSRMediaResourceTimings();
    (0, $875dea1a5468a6c1$export$1385b034c137348a).startFromPageLoad();
    if (succeededSSRMedia && !waitingSSRMedia && !failedSSRMedia) {
        // Mark FMP as longest SSR media load time if all media successfully SSR'd
        (0, $875dea1a5468a6c1$export$1385b034c137348a).markFMP(longestSSRMediaLoadTime);
        mediaAnalyticsRef.current.ssrFmpStarted = true;
    } else mediaAnalyticsRef.current.spaFmpStarted = true;
    mediaAnalyticsRef.current = {
        ...mediaAnalyticsRef.current,
        succeededSSRMedia: succeededSSRMedia,
        failedSSRMedia: failedSSRMedia,
        waitingSSRMedia: waitingSSRMedia,
        longestSSRMediaLoadTime: longestSSRMediaLoadTime
    };
};
const $72e3a5d49a76ae4e$var$handleSucceededOrFailedEvent = (duration, isSucceededEvent, fileIdIndex, mediaAnalyticsRef)=>{
    if (!mediaAnalyticsRef.current.ssrFmpStarted && !mediaAnalyticsRef.current.spaFmpStarted) $72e3a5d49a76ae4e$var$startMediaMetric(mediaAnalyticsRef);
    $72e3a5d49a76ae4e$var$updateSPAMetricsAndFileIds(duration, isSucceededEvent, fileIdIndex, mediaAnalyticsRef);
};
// Convert undefined values to number (-1) when doing index lookup.
const $72e3a5d49a76ae4e$var$safeGetFileIdIndex = (event, mediaAnalyticsRef)=>{
    const fileIdIndex = mediaAnalyticsRef.current.mediaFileIds?.indexOf(event.payload?.attributes?.fileAttributes?.fileId);
    return typeof fileIdIndex === 'undefined' ? -1 : fileIdIndex;
};
const $72e3a5d49a76ae4e$var$handleMediaEvent = (event, mediaAnalyticsRef)=>{
    const fileIdIndex = $72e3a5d49a76ae4e$var$safeGetFileIdIndex(event, mediaAnalyticsRef);
    if (window.__SSR_RENDERED__ && event.payload.actionSubject === 'mediaCardRender' && fileIdIndex > -1) {
        const isSucceededEvent = event.payload?.action === 'succeeded';
        const duration = event.payload?.attributes?.performanceAttributes?.overall?.durationSincePageStart;
        if (isSucceededEvent || event.payload.action === 'failed') {
            const succeededOrFailedDuration = isSucceededEvent ? duration : 0;
            $72e3a5d49a76ae4e$var$handleSucceededOrFailedEvent(succeededOrFailedDuration, isSucceededEvent, fileIdIndex, mediaAnalyticsRef);
        }
    }
};
const $72e3a5d49a76ae4e$var$parseAndUpdateMediaFileIds = (mediaAnalyticsRef)=>{
    const FILE_SEARCH_TERM = 'file/';
    const IMAGE_SEARCH_TERM = '/image';
    const mediaFileIds = window._contentMediaSources.map((source)=>{
        const fileIndex = source.indexOf(FILE_SEARCH_TERM);
        const imageIndex = source.indexOf(IMAGE_SEARCH_TERM);
        if (fileIndex > -1 && imageIndex > -1) // Return the fileId that will be between keywords 'file/' and '/image' in the url.
        return source.substring(fileIndex + FILE_SEARCH_TERM.length, imageIndex);
        else return null;
    }).filter((id)=>id);
    mediaAnalyticsRef.current = {
        ...mediaAnalyticsRef.current,
        mediaFileIds: mediaFileIds
    };
};
const $72e3a5d49a76ae4e$export$52c9562a5d07c846 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { contentId: contentId, children: children } = t0;
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isViewPage = match?.name === (0, $1NBp8.VIEW_PAGE).name;
    const mediaAnalyticsRef = (0, $42omo.useRef)($72e3a5d49a76ae4e$var$mediaAnalyticsRefDefault);
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== isViewPage) {
        t1 = ()=>{
            const isTransition = contentId && !window.__SSR_RENDERED__;
            if (isViewPage && window.__SSR_RENDERED__ && window?._contentMediaSources?.length > 0 && mediaAnalyticsRef.current.mediaFileIds === null) $72e3a5d49a76ae4e$var$parseAndUpdateMediaFileIds(mediaAnalyticsRef);
            else if (isViewPage && isTransition) $72e3a5d49a76ae4e$var$clearMediaSourcesAndRef(mediaAnalyticsRef);
        };
        t2 = [
            isViewPage,
            contentId
        ];
        $[0] = contentId;
        $[1] = isViewPage;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>$72e3a5d49a76ae4e$var$clearMediaSourcesAndRef(mediaAnalyticsRef);
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (e)=>{
            $72e3a5d49a76ae4e$var$handleMediaEvent(e, mediaAnalyticsRef);
        };
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "media",
            onEvent: t5
        }, children);
        $[7] = children;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ contentId: contentId, children: children })=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isViewPage = match?.name === (0, $1NBp8.VIEW_PAGE).name;
    const mediaAnalyticsRef = (0, $42omo.useRef)($72e3a5d49a76ae4e$var$mediaAnalyticsRefDefault);
    // This useEffect handles media analytics on initial load (SSR'd content)
    // as well as cleaning up state on page to page transitions.
    (0, $42omo.useEffect)(()=>{
        const isTransition = contentId && !window.__SSR_RENDERED__;
        if (isViewPage && window.__SSR_RENDERED__ && window?._contentMediaSources?.length > 0 && mediaAnalyticsRef.current.mediaFileIds === null) $72e3a5d49a76ae4e$var$parseAndUpdateMediaFileIds(mediaAnalyticsRef);
        else if (isViewPage && isTransition) $72e3a5d49a76ae4e$var$clearMediaSourcesAndRef(mediaAnalyticsRef);
    }, [
        isViewPage,
        contentId
    ]);
    // This useEffect handles clearing media sources on unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>$72e3a5d49a76ae4e$var$clearMediaSourcesAndRef(mediaAnalyticsRef);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: "media",
        onEvent: (e)=>{
            $72e3a5d49a76ae4e$var$handleMediaEvent(e, mediaAnalyticsRef);
        }
    }, children);
});



var $dPJCf = parcelRequire("dPJCf");

const $7b81bdbe8e487e80$var$useFocusedMentionIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedMentionId');
const $7b81bdbe8e487e80$export$43aecdc489234c30 = ()=>{
    const focusedMentionId = $7b81bdbe8e487e80$var$useFocusedMentionIdQueryParam();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    if (focusedMentionId) {
        const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
        if (mentionElement) {
            mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
            // Remove the query param immediately after mention scroll is complete
            setQueryParams({
                focusedMentionId: undefined
            });
        }
    }
    return null;
};



var $8HrX3 = parcelRequire("8HrX3");





var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $5YLPl = parcelRequire("5YLPl");


var $kEvSd = parcelRequire("kEvSd");


var $gGHFp = parcelRequire("gGHFp");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");

/**
 * Separating Connect/Legacy extension height reservation from useExtensionNodeParams. Forge
 * related improvements already exist and will be formalized to achieve complete CLS reduction
 * for UI kit and Custom UI.
 */ /**
 * Currently, very few legacy (Connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the rendered height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be mirrored in content-renderer-legacy-macros/src/useConnectExtensionViewportSize.ts
 * and ./useExtensionNodeParams.ts
 */ const $5b52ab5d3548d3f7$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $5b52ab5d3548d3f7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $5b52ab5d3548d3f7$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $5b52ab5d3548d3f7$var$MIRO_EMBED_DEFAULT_HEIGHT = 570;
const $5b52ab5d3548d3f7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $5b52ab5d3548d3f7$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $5b52ab5d3548d3f7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $5b52ab5d3548d3f7$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $5b52ab5d3548d3f7$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $5b52ab5d3548d3f7$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $5b52ab5d3548d3f7$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $5b52ab5d3548d3f7$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $5b52ab5d3548d3f7$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $5b52ab5d3548d3f7$var$getHeightFromNode = (node)=>{
    if (!node) return;
    const extensionKey = node.attrs.extensionKey;
    const params = node.attrs.parameters?.macroParams;
    if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        /**
		 * Zoom can also change the desired dimensions of the diagram meaning we'll have to exclude diagrams with a zoom
		 * parameter not equal to 1
		 */ const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        /**
		 * Extension nodes in the editor can range between 556px and 760px wide depending on the browser width.
		 * For smaller viewport sizes (i.e. 500px), Draw.io will resize the height of the content based
		 * on its ratio for widths above 530px. To simplify the exclusion of diagrams that Draw.io would resize,
		 * we will exclude any diagrams that could be resized by Draw.io.
		 */ if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $5b52ab5d3548d3f7$export$b6e5804201dbc820 = (node)=>{
    const extensionKey = node.attrs.extensionKey;
    const nodeHeight = $5b52ab5d3548d3f7$var$getHeightFromNode(node);
    let height = Number(nodeHeight);
    if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
    switch(extensionKey){
        case 'drawio':
        case 'inc-drawio':
        case 'drawio-sketch':
            height += $5b52ab5d3548d3f7$var$DRAW_IO_HEIGHT_OFFSET;
            break;
        case 'lref-gdrive-embedded-file':
            height += $5b52ab5d3548d3f7$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
            break;
        case 'plantumlcloud':
            height += $5b52ab5d3548d3f7$var$PLANTUML_OFFSET_HEIGHT;
            break;
        default:
            break;
    }
    else // for extensions that don't resize based on their content, we can set a default height
    switch(extensionKey){
        case 'gliffy':
            height = $5b52ab5d3548d3f7$var$GLIFFY_DEFAULT_HEIGHT;
            break;
        case 'aura-divider':
            height = $5b52ab5d3548d3f7$var$AURA_DIVIDER_DEFAULT_HEIGHT;
            break;
        case 'aura-cards':
            height = $5b52ab5d3548d3f7$var$AURA_CARDS_DEFAULT_HEIGHT;
            break;
        case 'miro-macro-resizing':
            height = $5b52ab5d3548d3f7$var$MIRO_EMBED_DEFAULT_HEIGHT;
            break;
        case 'easy-math-block':
            height = $5b52ab5d3548d3f7$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'mathblock':
            height = $5b52ab5d3548d3f7$var$MATH_BLOCK_DEFAULT_HEIGHT;
            break;
        case 'page-signatures':
            height = $5b52ab5d3548d3f7$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
            break;
        case 'questionslist-macro':
            height = $5b52ab5d3548d3f7$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
            break;
        case 'jiraroadmap':
            height = $5b52ab5d3548d3f7$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
            break;
        case 'lucidchart':
            height = $5b52ab5d3548d3f7$var$LUCID_CHART_DEFAULT_HEIGHT;
            break;
        default:
            height = undefined;
            break;
    }
    return height?.toString();
};



var $88Nzy = parcelRequire("88Nzy");


var $7oCdN = parcelRequire("7oCdN");


var $habRv = parcelRequire("habRv");

function $03a558b37ccdab2e$export$ad07f58b79e98b10(objectId) {
    return (event)=>{
        event.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    objectId: objectId
                }
            }));
    };
}


/**
 * @generated SignedSource<<79a29756ed2086a757c0584a72f94f80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a6e533ef53695ee$var$node = function() {
    var v0 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useReadAndWriteContentQueryDataCacheWriteContentFragment",
        "selections": [
            {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "dynamic",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "representation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "WebResourceDependencies",
                                "kind": "LinkedField",
                                "name": "webresource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "SuperBatchWebResources",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    },
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$9a6e533ef53695ee$var$node.hash = "0070fa1f6967d8f3323abe02720a0286";
var $9a6e533ef53695ee$export$2e2bcd8739ae039 = $9a6e533ef53695ee$var$node;


/**
 * @generated SignedSource<<54bc5c89c6b093b807e13c9d308b583e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $36712898c6b581cd$var$node = function() {
    var v0 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useReadAndWriteContentQueryDataCacheReadContentFragment",
        "selections": [
            {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "dynamic",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "representation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "WebResourceDependencies",
                                "kind": "LinkedField",
                                "name": "webresource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "SuperBatchWebResources",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ 
                                        ]
                                    },
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$36712898c6b581cd$var$node.hash = "efb80ee4b9c32439a7531e49de8bf64e";
var $36712898c6b581cd$export$2e2bcd8739ae039 = $36712898c6b581cd$var$node;






var $diswb = parcelRequire("diswb");


var $ij4CE = parcelRequire("ij4CE");







const $a04de01f0d2a7d21$export$2f6929c1438cd284 = ({ query: query, contentId: contentId, spaceKey: spaceKey })=>{
    const client = (0, $diswb.useApolloClient)();
    const readQueryInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $36712898c6b581cd$export$2e2bcd8739ae039)
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $9a6e533ef53695ee$export$2e2bcd8739ae039)
    });
    const readAndWriteQueryCache = (0, $42omo.useCallback)((newAdfDoc)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(window.__SSR_RENDERED__);
        const contentUnifiedQueryVariables = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            isSSR: isSSR,
            useNewContentTopper: true
        };
        let contentQueryResultCache;
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) contentQueryResultCache = readQueryInterop({
            id: `Content:${contentId}`
        });
        else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        contentQueryResultCache = client.readQuery({
            query: query,
            variables: contentUnifiedQueryVariables
        });
        const content = (0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true) ? contentQueryResultCache : contentQueryResultCache?.content?.nodes?.[0] || null;
        const contentBody = content?.body?.dynamic || null;
        if (contentBody) {
            contentBody.value = JSON.stringify(newAdfDoc);
            if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeFragmentInterop({
                fragmentId: `Content:${contentId}`,
                data: contentQueryResultCache
            });
            else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            client.writeQuery({
                query: query,
                variables: contentUnifiedQueryVariables,
                data: contentQueryResultCache
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        query,
        contentId,
        spaceKey,
        readQueryInterop,
        writeFragmentInterop
    ]);
    return readAndWriteQueryCache;
};



var $gnAk8 = parcelRequire("gnAk8");
















const $e1eb2588da6dd9c8$export$136dd42e3a5ac40a = (0, $3u0dr.isReactCompilerActiveV1)() ? (adf, isFabric)=>{
    const $ = (0, $frIzR.c)(10);
    const { documentUpdated: documentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            version: 1,
            type: "doc",
            content: []
        };
        $[0] = t1;
    } else t1 = $[0];
    let documentParsed = t1;
    if (adf && isFabric) try {
        let t2;
        if ($[1] !== adf) {
            t2 = JSON.parse(adf);
            $[1] = adf;
            $[2] = t2;
        } else t2 = $[2];
        documentParsed = t2;
    } catch  {
        let errorString = "Failed to parse ADF";
        if (adf.startsWith("<div class=\"error fatal-render-error\">") && (0, $9wGTI.fg)("confluence_include_error_in_adf_parse_failure")) errorString = "Failed to parse ADF" + `: ${adf}`;
        throw Error(errorString);
    }
    t0 = documentParsed;
    const docParsed = t0;
    const [document, setDocument] = (0, $42omo.useState)(docParsed);
    let t2;
    if ($[3] !== docParsed) {
        t2 = ()=>{
            setDocument(docParsed);
        };
        $[3] = docParsed;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== docParsed || $[6] !== documentUpdated) {
        t3 = [
            docParsed,
            documentUpdated
        ];
        $[5] = docParsed;
        $[6] = documentUpdated;
        $[7] = t3;
    } else t3 = $[7];
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[8] !== document) {
        t4 = [
            document
        ];
        $[8] = document;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (adf, isFabric)=>{
    const { documentUpdated: documentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const docParsed = (0, $42omo.useMemo)(()=>{
        let documentParsed = {
            version: 1,
            type: 'doc',
            content: []
        };
        if (adf && isFabric) try {
            documentParsed = JSON.parse(adf);
        } catch  {
            let errorString = 'Failed to parse ADF';
            if (adf.startsWith('<div class="error fatal-render-error">') && (0, $9wGTI.fg)('confluence_include_error_in_adf_parse_failure')) errorString += `: ${adf}`;
            throw Error(errorString);
        }
        return documentParsed;
    }, [
        adf,
        isFabric
    ]);
    const [document, setDocument] = (0, $42omo.useState)(docParsed);
    (0, $42omo.useEffect)(()=>{
        setDocument(docParsed);
    }, [
        docParsed,
        documentUpdated
    ]);
    return [
        document
    ];
};






var $6jPem = parcelRequire("6jPem");


var $7r2px = parcelRequire("7r2px");

function $9d71800faf33d82e$export$6b8ad6aa37e0cff2(adfDocument, customPerfData) {
    const shouldRetrieveContentExtensionMetrics = Boolean(customPerfData);
    const adfStats = (0, $42omo.useMemo)(()=>{
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const nodeCountByType = {};
        let totalNodeCount = 0;
        (0, $6jPem.traverse)(adfDocument, {
            any: (node)=>{
                nodeCountByType[node.type] = (nodeCountByType[node.type] || 0) + 1;
                totalNodeCount++;
                // This is the alternative to `retrieveContentExtensionMetrics` which avoids one more parsing of the ADF string into JSON.
                // Note: Unlike the old `retrieveContentExtensionMetrics` which only considers the top-level content of the document,
                // this considers the whole document.
                if (shouldRetrieveContentExtensionMetrics) (0, $7r2px.retrieveContentExtensionMetricsFromNode)(node, contentExtensionMetrics);
            }
        });
        return {
            contentExtensionMetrics: contentExtensionMetrics,
            nodeCountByType: nodeCountByType,
            totalNodeCount: totalNodeCount
        };
    }, [
        adfDocument,
        shouldRetrieveContentExtensionMetrics
    ]);
    if (shouldRetrieveContentExtensionMetrics) customPerfData.contentExtensionMetrics = adfStats.contentExtensionMetrics;
    return adfStats;
}





















var $aUnCJ = parcelRequire("aUnCJ");

const $cf9c399abc72dd00$var$NODES_WITH_NO_CHILDREN = {
    blockCard: {
        height: 114
    },
    caption: {
        height: 32
    },
    date: {
        height: 20
    },
    emoji: {
        height: 28
    },
    inlineCard: {
        height: 26
    },
    mediaInline: {
        height: 28
    },
    mention: {
        height: 24
    },
    placeholder: {
        height: 28
    },
    rule: {
        height: 30
    },
    status: {
        height: 16
    },
    // expand + nestedExpand have children, but they are collapsed by default. So, we treat them as having no children for height estimation.
    expand: {
        height: 40
    },
    nestedExpand: {
        height: 40
    }
};
const $cf9c399abc72dd00$var$NODES_WITH_TEXT_CHILDREN = {
    decisionItem: {
        contentHeight: 36
    },
    paragraph: {
        contentHeight: 28
    },
    taskItem: {
        contentHeight: 28
    }
};
const $cf9c399abc72dd00$var$NODES_WITH_INLINE_CHILDREN = {
    layoutSection: {
        additionalHeight: 44,
        minimumHeight: 72
    },
    tableRow: {
        additionalHeight: 0,
        minimumHeight: 48
    }
};
const $cf9c399abc72dd00$var$NODES_WITH_BLOCK_CHILDREN = {
    blockquote: {
        additionalHeight: 20,
        minimumHeight: 48
    },
    bulletList: {
        additionalHeight: 0,
        minimumHeight: 0
    },
    decisionList: {
        additionalHeight: 0,
        minimumHeight: 0
    },
    layoutColumn: {
        additionalHeight: 0,
        minimumHeight: 28
    },
    listItem: {
        additionalHeight: 0,
        minimumHeight: 28
    },
    orderedList: {
        additionalHeight: 0,
        minimumHeight: 0
    },
    panel: {
        additionalHeight: 20,
        minimumHeight: 48
    },
    table: {
        additionalHeight: 60,
        minimumHeight: 108
    },
    tableCell: {
        additionalHeight: 20,
        minimumHeight: 48
    },
    tableHeader: {
        additionalHeight: 20,
        minimumHeight: 48
    },
    taskList: {
        additionalHeight: 0,
        minimumHeight: 0
    }
};
const $cf9c399abc72dd00$var$MEDIA_SINGLE_MINIMUM_WIDTH = 620;
const $cf9c399abc72dd00$export$295ba2e20e51e007 = (node, nodeChildInfoOutput)=>{
    const nodeTypeName = node?.type?.name || '';
    if ($cf9c399abc72dd00$var$NODES_WITH_NO_CHILDREN[nodeTypeName]) return $cf9c399abc72dd00$var$NODES_WITH_NO_CHILDREN[nodeTypeName].height || 0;
    else if ($cf9c399abc72dd00$var$NODES_WITH_INLINE_CHILDREN[nodeTypeName]) {
        const additionalHeight = $cf9c399abc72dd00$var$NODES_WITH_INLINE_CHILDREN[nodeTypeName].additionalHeight || 0;
        const minimumHeight = $cf9c399abc72dd00$var$NODES_WITH_INLINE_CHILDREN[nodeTypeName].minimumHeight || 0;
        const childrenHeight = Math.max(...nodeChildInfoOutput.estimatedChildHeights.map((height)=>height || 0), // 0 is added in case there are no entries in estimatedChildHeights.
        0);
        return Math.max(childrenHeight + additionalHeight, minimumHeight);
    } else if ($cf9c399abc72dd00$var$NODES_WITH_BLOCK_CHILDREN[nodeTypeName]) {
        const additionalHeight = $cf9c399abc72dd00$var$NODES_WITH_BLOCK_CHILDREN[nodeTypeName].additionalHeight || 0;
        const minimumHeight = $cf9c399abc72dd00$var$NODES_WITH_BLOCK_CHILDREN[nodeTypeName].minimumHeight || 0;
        const childrenHeight = nodeChildInfoOutput.estimatedChildHeights.reduce((acc, height)=>acc + (height || 0), 0);
        return Math.max(childrenHeight + additionalHeight, minimumHeight);
    } else if ($cf9c399abc72dd00$var$NODES_WITH_TEXT_CHILDREN[nodeTypeName]) {
        const contentHeight = $cf9c399abc72dd00$var$NODES_WITH_TEXT_CHILDREN[nodeTypeName].contentHeight || 0;
        const lineCount = node.content?.content?.reduce((acc, child)=>child?.type?.name === 'hardBreak' ? acc + 1 : acc, 1) || 1;
        return lineCount * contentHeight;
    } else if (nodeTypeName === 'heading') {
        const HEADING_HEIGHTS = {
            1: 32,
            2: 28,
            3: 28,
            4: 24,
            5: 18,
            6: 18
        };
        const contentHeight = HEADING_HEIGHTS[node?.attrs?.level] || 0;
        const lineCount = node.content?.content?.reduce((acc, child)=>child?.type?.name === 'hardBreak' ? acc + 1 : acc, 1) || 1;
        return lineCount * contentHeight;
    } else if (nodeTypeName === 'mediaSingle' && [
        'align-start',
        'center',
        'align-end',
        'wide',
        'full-width'
    ].includes(node?.attrs?.layout)) {
        const mediaSingleAttrsWidth = node?.attrs?.width;
        const media = node?.content?.[0]; // 'media' node type
        const mediaAttrsWidth = media?.attrs?.width;
        const mediaAttrsHeight = media?.attrs?.height;
        if (!mediaSingleAttrsWidth || !mediaAttrsWidth || !mediaAttrsHeight) return 0; // If media attributes are not available, return 0
        const minMediaWidth = Math.min(mediaSingleAttrsWidth, $cf9c399abc72dd00$var$MEDIA_SINGLE_MINIMUM_WIDTH);
        const minMediaHeight = minMediaWidth / mediaAttrsWidth * mediaAttrsHeight;
        const caption = node?.content?.[1]; // 'caption' node type
        const captionHeight = caption ? 32 : 0;
        return minMediaHeight + captionHeight;
    } else if (nodeTypeName === 'mediaGroup') // mediaGroup is similar to mediaSingle, but it can contain multiple media nodes.
    // Unfortunately, testing this case has proven difficult, so we return 0 for now.
    // This may be improved in the future.
    return 0;
    else if (nodeTypeName === 'embedCard' && [
        'align-start',
        'center',
        'align-end',
        'wide',
        'full-width'
    ].includes(node?.attrs?.layout)) // The height of embedCards is likely much larger than 58, but it depends on a number of factors.
    // This is used as a safe simple value which may be improved upon in the future.
    return 58;
    else if (nodeTypeName === 'codeBlock') {
        const additionalHeight = 16;
        const minimumHeight = 40;
        // Text takes up at least 24px per line, so we multiply the number of lines by 24.
        const contentHeight = (node?.content?.content?.length || 0) * 24;
        return Math.max(contentHeight + additionalHeight, minimumHeight);
    } else if ([
        'bodiedExtension',
        'extension',
        'extensionFrame',
        'inlineExtension',
        'multiBodiedExtension'
    ].includes(nodeTypeName)) // Extensions likely take up significant height, but it depends on the content. For now, we return 0 to avoid
    // overestimating their height, but this may be improved in the future.
    return 0;
    else return 0; // Default case for unrecognized node types
};


// NullRenderer renders nothing, but is a valid React element. This component is useful for
// progressive serialization where returning null directly is dangerous.
const $fae811aa45d5a9ce$export$cde9bcf44483dbe5 = ()=>null;
$fae811aa45d5a9ce$export$cde9bcf44483dbe5.displayName = 'NullRenderer';


// 99% of users have a window height of 2160px or less.
// Confluence has 300px of content before page content starts.
// Therefore, we set the minimum rendered height to 1860px.
const $71fea19cc22d532b$var$MINIMUM_RENDERED_HEIGHT = 1860;
class $71fea19cc22d532b$export$96066f3459dc24dc extends (0, $aUnCJ.default) {
    /**
   * Like {@link ReactSerializer.resetState}. Named differently because a class cannot have a separate declaration of a private property of its base class.
   */ resetProgressiveState() {
        this.estimatedHeight = 0;
        this.childInfoOutputStack = [];
    }
    /**
   * @override
   */ serializeFragment(_fragment, _props, _target, key, parentInfo) {
        const isRoot = key === undefined; // Like ReactSerializer.serializeFragment
        if (isRoot) this.resetProgressiveState();
        const shouldSkipNodeSerialization = this.onlySerializeFirstBatch && // Skip serialization of anything estimated to be below the fold.
        // Please note that a statically defined minimum rendered height is used
        // in part because the actual window height is not known during SSR. We must
        // render the same content during SSR and the initial render on the client in
        // order to avoid hydration issues.
        this.estimatedHeight > $71fea19cc22d532b$var$MINIMUM_RENDERED_HEIGHT;
        if (shouldSkipNodeSerialization) // Returning a component, as opposed to null, is important to avoid breaking existing logic
        // within ADF node components that assume their children are React elements. NullRenderer
        // renders nothing, but is still a valid React element.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fae811aa45d5a9ce$export$cde9bcf44483dbe5), null);
        if (this.onlySerializeFirstBatch) this.preSerializeFragment();
        const nodeElement = super.serializeFragment.apply(this, arguments);
        if (this.onlySerializeFirstBatch) this.postSerializeFragment(parentInfo);
        if (isRoot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71fea19cc22d532b$var$OnBatchRenderedComponent, {
            onBatchRendered: this.onBatchRendered,
            onlySerializeFirstBatch: this.onlySerializeFirstBatch
        }, nodeElement);
        else return nodeElement;
    }
    constructor(init, onlySerializeFirstBatch = false, onBatchRendered){
        super(init);
        this.onlySerializeFirstBatch = void 0;
        this.onBatchRendered = void 0;
        this.estimatedHeight = void 0;
        // This stack is used to keep track of the estimated heights of child nodes as they are recursively
        // serialized depth first. The last index is the top of the stack.
        this.childInfoOutputStack = void 0;
        this.preSerializeFragment = ()=>{
            // Adds a new object onto childInfoOutputStack for this node. This allows children to report their
            // estimated heights when they are serialized.
            this.childInfoOutputStack.push({
                estimatedChildHeights: []
            });
        };
        this.postSerializeFragment = (parentInfo)=>{
            // Removes the new object from childInfoOutputStack for this node.
            const thisNodesChildInfoOutput = this.childInfoOutputStack.pop() || {
                estimatedChildHeights: []
            };
            // Get the estimated height of this node based on its type and the heights of its children.
            const thisNode = parentInfo?.path?.[parentInfo.path.length - 1];
            const thisNodeEstimatedHeight = thisNode ? (0, $cf9c399abc72dd00$export$295ba2e20e51e007)(thisNode, thisNodesChildInfoOutput) : 0;
            // Reports the estimated height of this node to its parent, if it has one.
            if (this.childInfoOutputStack.length > 0) this.childInfoOutputStack[this.childInfoOutputStack.length - 1].estimatedChildHeights.push(thisNodeEstimatedHeight);
            // For top-level nodes, we add the estimated height to the total estimated height.
            // This is used to determine if the node is above or below the fold and whether
            // it should be serialized.
            if (parentInfo?.path?.length === 1) this.estimatedHeight += thisNodeEstimatedHeight || 0;
        };
        this.onlySerializeFirstBatch = onlySerializeFirstBatch;
        this.onBatchRendered = onBatchRendered;
        this.estimatedHeight = 0;
        this.childInfoOutputStack = [];
    }
}
const $71fea19cc22d532b$var$OnBatchRenderedComponent = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children, onBatchRendered: onBatchRendered, onlySerializeFirstBatch: onlySerializeFirstBatch } = t0;
    let t1;
    let t2;
    if ($[0] !== onBatchRendered || $[1] !== onlySerializeFirstBatch) {
        t1 = ()=>{
            const requestIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
            const cancelHandle = requestIdleCallback(()=>{
                onBatchRendered?.(!onlySerializeFirstBatch);
            });
            return ()=>{
                const cancelIdleCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
                cancelIdleCallback(cancelHandle);
            };
        };
        t2 = [
            onBatchRendered,
            onlySerializeFirstBatch
        ];
        $[0] = onBatchRendered;
        $[1] = onlySerializeFirstBatch;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    return children;
} : ({ children: children, onBatchRendered: onBatchRendered, onlySerializeFirstBatch: onlySerializeFirstBatch })=>{
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line compat/compat
        const requestIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
        const cancelHandle = requestIdleCallback(()=>{
            onBatchRendered?.(!onlySerializeFirstBatch);
        });
        return ()=>{
            const cancelIdleCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
            cancelIdleCallback(cancelHandle);
        };
    }, [
        onBatchRendered,
        onlySerializeFirstBatch
    ]);
    return children;
};

































var $cgtv4 = parcelRequire("cgtv4");




var $1s5hv = parcelRequire("1s5hv");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");

const $72d061d1057a17fb$export$7c20be4c1d342248 = (0, $3u0dr.isReactCompilerActiveV1)() ? function LoadingIndicator() {
    const $ = (0, $frIzR.c)(5);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($72d061d1057a17fb$var$messages.label);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "loading-indicator"
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t0
        }, t1));
        $[3] = t0;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function LoadingIndicator() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($72d061d1057a17fb$var$messages.label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        testId: "loading-indicator"
    })));
};
const $72d061d1057a17fb$var$messages = (0, $cgtv4.defineMessages)({
    label: {
        id: "content-renderer.progressive-react-serializer.loading-indicator.label",
        defaultMessage: "Loading..."
    }
});


const $c7a529f20a4a6151$export$3f4991e1389b4978 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(19);
    const { batchSize: batchSize, children: children, maxRenderIndex: maxRenderIndex, onBatchRendered: onBatchRendered } = props;
    const seq = $c7a529f20a4a6151$var$useBatchSequence(props);
    const [seqIndex, setSeqIndex] = (0, $42omo.useState)(0);
    const lastSeqIndex = (seq?.length ?? Math.max(Math.ceil(maxRenderIndex / batchSize), 1)) - 1;
    let t0;
    let t1;
    if ($[0] !== lastSeqIndex || $[1] !== onBatchRendered || $[2] !== seqIndex) {
        t0 = ()=>{
            const requestIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
            const cancelHandle = requestIdleCallback(()=>{
                const done = seqIndex >= lastSeqIndex;
                onBatchRendered?.(done);
                if (!done) setSeqIndex((pendingState)=>pendingState < lastSeqIndex ? pendingState + 1 : pendingState);
            });
            return ()=>{
                const cancelIdleCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
                cancelIdleCallback(cancelHandle);
            };
        };
        t1 = [
            seqIndex,
            lastSeqIndex,
            onBatchRendered,
            setSeqIndex
        ];
        $[0] = lastSeqIndex;
        $[1] = onBatchRendered;
        $[2] = seqIndex;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $42omo.useEffect)(t0, t1);
    const maxBatchRenderIndex = (seqIndex + 1) * batchSize;
    let t2;
    if ($[5] !== batchSize || $[6] !== maxBatchRenderIndex || $[7] !== seq || $[8] !== seqIndex) {
        t2 = (renderIndex)=>{
            if (seq) {
                const batchIndex = Math.floor(renderIndex / batchSize);
                if (batchIndex < seq.length) return seq[batchIndex] <= seqIndex;
            } else return !maxBatchRenderIndex || renderIndex < maxBatchRenderIndex;
        };
        $[5] = batchSize;
        $[6] = maxBatchRenderIndex;
        $[7] = seq;
        $[8] = seqIndex;
        $[9] = t2;
    } else t2 = $[9];
    const shouldRenderNode = t2;
    let t3;
    if ($[10] !== seq || $[11] !== shouldRenderNode) {
        t3 = seq && seq.length > 0 && !shouldRenderNode(1) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72d061d1057a17fb$export$7c20be4c1d342248), null) : null;
        $[10] = seq;
        $[11] = shouldRenderNode;
        $[12] = t3;
    } else t3 = $[12];
    const loadingIndicator = t3;
    let t4;
    if ($[13] !== children || $[14] !== shouldRenderNode) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c7a529f20a4a6151$export$2f629ae1087ae9db.Provider, {
            value: shouldRenderNode
        }, children);
        $[13] = children;
        $[14] = shouldRenderNode;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== loadingIndicator || $[17] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingIndicator, t4);
        $[16] = loadingIndicator;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (props)=>{
    const { batchSize: batchSize, children: children, maxRenderIndex: maxRenderIndex, onBatchRendered: onBatchRendered } = props;
    const seq = $c7a529f20a4a6151$var$useBatchSequence(props);
    const [seqIndex, setSeqIndex] = (0, $42omo.useState)(0);
    const lastSeqIndex = (seq?.length ?? Math.max(Math.ceil(maxRenderIndex / batchSize), 1)) - 1; // The last valid sequence index
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line compat/compat
        const requestIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
        const cancelHandle = requestIdleCallback(()=>{
            const done = seqIndex >= lastSeqIndex;
            onBatchRendered?.(done);
            if (!done) setSeqIndex((pendingState)=>pendingState < lastSeqIndex ? pendingState + 1 : pendingState);
        });
        return ()=>{
            const cancelIdleCallback = window.cancelIdleCallback || window.cancelAnimationFrame;
            cancelIdleCallback(cancelHandle);
        };
    }, [
        seqIndex,
        lastSeqIndex,
        onBatchRendered,
        setSeqIndex
    ]);
    const maxBatchRenderIndex = (seqIndex + 1) * batchSize;
    const shouldRenderNode = (0, $42omo.useCallback)((renderIndex)=>{
        if (seq) {
            // Alternating sequence:
            const batchIndex = Math.floor(renderIndex / batchSize);
            if (batchIndex < seq.length) return seq[batchIndex] <= seqIndex;
        } else // Linear sequence:
        return !maxBatchRenderIndex || renderIndex < maxBatchRenderIndex;
    }, [
        batchSize,
        maxBatchRenderIndex,
        seq,
        seqIndex
    ]);
    // The first version of progressive rendering of ADF that went into production used the linear sequence and did not have a loading indicator.
    // But the alternating sequence renders from a linked anchor that's not in the first batch and is not a generally well-known user experience on the Web.
    // That's why we'll start with a loading indicator at the top in the case of the alternating sequence for now.
    const loadingIndicator = seq && seq.length > 0 && // The node at `renderIndex` 0 is the `doc`, which is never visualized, so the loading indicator is not necessary as soon as the node at `renderIndex` 1 is rendered:
    !shouldRenderNode(1) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72d061d1057a17fb$export$7c20be4c1d342248), null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingIndicator, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c7a529f20a4a6151$export$2f629ae1087ae9db.Provider, {
        value: shouldRenderNode
    }, children));
});
$c7a529f20a4a6151$export$3f4991e1389b4978.displayName = 'RootRenderer';
const $c7a529f20a4a6151$export$2f629ae1087ae9db = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $c7a529f20a4a6151$var$useBatchSequence({ batchSize: batchSize, maxRenderIndex: maxRenderIndex, targetBatchIndex: targetBatchIndex = 0 }) {
    const ref = (0, $42omo.useRef)();
    if (ref.current?.batchSize !== batchSize || ref.current?.maxRenderIndex !== maxRenderIndex) {
        let batches = ref.current?.batches;
        if (targetBatchIndex) {
            // Alternating sequence:
            const batchCount = Math.max(Math.ceil(maxRenderIndex / batchSize), 1);
            if (batches?.length !== batchCount) {
                // Generate the sequence of batches to render, starting from `targetBatchIndex`:
                batches = new Array(batchCount);
                let seq = 0;
                batches[targetBatchIndex] = seq++;
                let above = targetBatchIndex - 1;
                let below = targetBatchIndex + 1;
                let yieldAbove = false;
                while(above >= 0 || below < batchCount){
                    if (yieldAbove) {
                        if (above >= 0) {
                            batches[above] = seq++;
                            above--;
                        }
                    } else if (below < batchCount) {
                        batches[below] = seq++;
                        below++;
                    }
                    yieldAbove = !yieldAbove;
                }
            }
        } else // Linear sequence:
        batches = undefined;
        ref.current = {
            batchSize: batchSize,
            maxRenderIndex: maxRenderIndex,
            batches: batches
        };
    }
    return ref.current.batches;
}


const $d004621fe7df67bd$export$d7ce3a514583bac = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const { children: children, renderIndex: renderIndex, ...props } = t0;
    const shouldRenderNode = (0, $42omo.useContext)((0, $c7a529f20a4a6151$export$2f629ae1087ae9db));
    const shouldRender = shouldRenderNode?.(renderIndex) ?? true;
    if (!shouldRender) return null;
    if (Object.keys(props).length) return (0, $42omo.Children).map(children, (child)=>/*#__PURE__*/ (0, $42omo.isValidElement)(child) ? /*#__PURE__*/ (0, $42omo.cloneElement)(child, props) : child);
    return children;
} : ({ children: children, renderIndex: renderIndex, ...props })=>{
    const shouldRenderNode = (0, $42omo.useContext)((0, $c7a529f20a4a6151$export$2f629ae1087ae9db));
    const shouldRender = shouldRenderNode?.(renderIndex) ?? true;
    if (!shouldRender) return null;
    // Some node components add props to their children, outside of `serializeFragment`. Pass such props through:
    if (Object.keys(props).length) return (0, $42omo.Children).map(children, (child)=>/*#__PURE__*/ (0, $42omo.isValidElement)(child) ? /*#__PURE__*/ (0, $42omo.cloneElement)(child, props) : child);
    return children;
});
$d004621fe7df67bd$export$d7ce3a514583bac.displayName = 'NodeRenderer';




class $2eea383c18bc2e17$export$63b7ba093b5cd770 extends (0, $aUnCJ.default) {
    /**
   * Like {@link ReactSerializer.resetState}. Named differently because a class cannot have a separate declaration of a private property of its base class.
   */ resetProgressiveState() {
        this.activeHeadingBatchIndex = undefined;
        this.maxRenderIndex = 0;
    }
    /**
   * @override
   */ serializeFragment(fragment, props, _target, key, parentInfo) {
        const isRoot = key === undefined; // Like ReactSerializer.serializeFragment
        if (isRoot) this.resetProgressiveState();
        const renderIndex = this.maxRenderIndex++;
        const shouldRenderNodeProgressively = !$2eea383c18bc2e17$var$shouldSkipForWorkaround(fragment, props, parentInfo);
        const shouldSkipNodeSerialization = shouldRenderNodeProgressively && this.onlySerializeFirstBatch && // Skip serialization of anything beyond the first batch:
        renderIndex >= this.batchSize && // This optimization cannot be used when rendering from a linked anchor that's not in the first batch:
        (!this.activeHeadingId || this.activeHeadingBatchIndex === 0);
        if (shouldSkipNodeSerialization) // Returning a component, as opposed to null, is important to avoid breaking existing logic
        // within ADF node components that assume their children are React elements. NullRenderer
        // renders nothing, but is still a valid React element.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fae811aa45d5a9ce$export$cde9bcf44483dbe5), null);
        const nodeElement = super.serializeFragment.apply(this, arguments);
        if (!nodeElement) return nodeElement;
        if (this.activeHeadingId && this.activeHeadingBatchIndex === undefined) this.maybeSetActiveHeadingBatchIndex(props, renderIndex);
        if (!shouldRenderNodeProgressively) return nodeElement;
        return this.renderNodeProgressively(nodeElement, isRoot, key, renderIndex);
    }
    /**
   * {@link RootRenderer} builds render batches based on {@link maxRenderIndex}, but {@link serializeFragment} does not visit `textWrapper` nodes and, therefore, does not count `text` nodes.
   * Since `text` nodes are used by most pages and the average number of `text` nodes appears to increase as Time to Visually Complete (TTVC) increases (e.g. https://docs.google.com/spreadsheets/d/1SlRKS3BdASJFABu75t4lb7I57zagPtWUBnRZ88Vfw0E),
   * counting `text` modes may effectively produce smaller batches which in turm may lead to improved TTVC90.
   */ maybeCountTextNodes() {
        // TODO Make `serializeTextWrapper` protected in `ReactSerializer` to improve the reliability and maintainability of this solution.
        const superSerializeTextWrapper = this[$2eea383c18bc2e17$var$SERIALIZE_TEXT_WRAPPER_PNAME];
        if (typeof superSerializeTextWrapper === 'function') this[$2eea383c18bc2e17$var$SERIALIZE_TEXT_WRAPPER_PNAME] = function serializeTextWrapper(content) {
            const nodeElement = superSerializeTextWrapper.apply(this, arguments);
            if (Array.isArray(content)) this.maxRenderIndex += content.length;
            return nodeElement;
        };
    }
    maybeSetActiveHeadingBatchIndex(props, renderIndex) {
        if (props?.nodeType === 'heading') {
            const { headingId: headingId } = props;
            if (headingId && headingId === this.activeHeadingId) this.activeHeadingBatchIndex = Math.floor(renderIndex / this.batchSize);
        }
    }
    renderNodeProgressively(nodeElement, isRoot, key, renderIndex) {
        if (isRoot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c7a529f20a4a6151$export$3f4991e1389b4978), {
            batchSize: this.batchSize,
            maxRenderIndex: this.maxRenderIndex,
            onBatchRendered: this.onBatchRendered,
            targetBatchIndex: this.activeHeadingBatchIndex
        }, nodeElement);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d004621fe7df67bd$export$d7ce3a514583bac), {
            key: key,
            renderIndex: renderIndex
        }, nodeElement);
    }
    constructor(init, batchSize, onlySerializeFirstBatch = false, onBatchRendered){
        const activeHeadingId = $2eea383c18bc2e17$var$getActiveHeadingId(init.allowHeadingAnchorLinks);
        // If rendering from a linked anchor, the heading IDs are necessary to start the first render from the linked anchor:
        if (activeHeadingId && init.disableHeadingIDs) init = {
            ...init,
            disableHeadingIDs: false
        };
        super(init);
        /**
     * The index of the batch in which {@link activeHeadingId} is (to be) rendered.
     */ this.activeHeadingBatchIndex = undefined;
        this.activeHeadingId = void 0;
        this.batchSize = void 0;
        /**
     * The first invalid index (after a sequence of valid indices) of a node to batch render.
     * After `serializeFragment` completes for the root node, this will be the number of nodes to batch render.
     */ this.maxRenderIndex = 0;
        this.onlySerializeFirstBatch = void 0;
        this.onBatchRendered = void 0;
        this.activeHeadingId = activeHeadingId;
        this.batchSize = batchSize;
        this.onlySerializeFirstBatch = onlySerializeFirstBatch;
        this.onBatchRendered = onBatchRendered;
        this.maybeCountTextNodes();
    }
}
function $2eea383c18bc2e17$var$getActiveHeadingId(allowHeadingAnchorLinks) {
    if (allowHeadingAnchorLinks && typeof allowHeadingAnchorLinks === 'object') return allowHeadingAnchorLinks.activeHeadingId;
}
function $2eea383c18bc2e17$var$isHeaderTableRow(fragment, props, parentInfo) {
    try {
        if (props?.nodeType === 'tableRow' && parentInfo) {
            const parentPath = parentInfo?.path;
            if (parentPath?.length > 1) {
                const tableNode = parentPath[parentPath.length - 2];
                if (tableNode?.type?.name === 'table' && parentPath[parentPath.length - 1]?.type?.name === 'tableRow' && tableNode.maybeChild(0)?.content === fragment) return true;
            }
        }
    } catch (e) {}
    return false;
}
/**
 * The name of the {@link ReactSerializer} method/property which serializes `textWrapper` and, therefore, `text` nodes.
 */ const $2eea383c18bc2e17$var$SERIALIZE_TEXT_WRAPPER_PNAME = 'serializeTextWrapper';
/**
 * Cases in which node elements created by the super `ReactSerializer` should not be preogressively rendered
 * in order to avoid breakages of functionality.
 */ function $2eea383c18bc2e17$var$shouldSkipForWorkaround(fragment, props, parentInfo) {
    return(// Some node components rely on the type of children. Do not wrap such children.
    // For example, there is an expectation in the table component(s) in `isHeaderRowEnabled` of `TableHeader`.
    // There is an expectation in the table component(s) in `isHeaderRowEnabled` about the children of the first row.
    props?.nodeType === 'tableHeader' || $2eea383c18bc2e17$var$isHeaderTableRow(fragment, props, parentInfo));
}





const $9b48afaee399d3ff$export$a41c3f74aab75ba5 = ({ adfContentId: adfContentId })=>{
    // adfContentIdSequenceRef is set to a new object every time adfContentId changes. This allows us to
    // distinguish between separate serializations of the same contentId. For example, when the user
    // navigates away from a page and then back to it.
    const adfContentIdSequenceRef = (0, $42omo.useRef)(undefined);
    if (adfContentIdSequenceRef.current?.adfContentId !== adfContentId) adfContentIdSequenceRef.current = adfContentId ? {
        adfContentId: adfContentId
    } : undefined;
    // fullySerializeAdfContentIdSequence tracks the most recently batch rendered content. If adfContentIdSequenceRef matches this,
    // then we know that the current content should now be fully serialized.
    const [fullySerializeAdfContentIdSequence, setFullySerializeAdfContentIdSequence] = (0, $42omo.useState)(undefined);
    // We are intentionally using referential equality here. This is because we want to distinguish between
    // separate serializations of the same contentId.
    const fullySerialize = adfContentIdSequenceRef.current === fullySerializeAdfContentIdSequence;
    const onBatchRendered = (0, $42omo.useCallback)((done)=>{
        if (!done) setFullySerializeAdfContentIdSequence(adfContentIdSequenceRef.current);
    }, [
        setFullySerializeAdfContentIdSequence
    ]);
    return {
        onlySerializeFirstBatch: !fullySerialize,
        onBatchRendered: onBatchRendered
    };
};



var $4VJDS = parcelRequire("4VJDS");

const $2c965f70a5ee6b1b$export$5975a8ab7eb35660 = ({ skip: skip, totalNodeCount: totalNodeCount, nodeCountByType: nodeCountByType })=>{
    let isComplexPageReason;
    let batchSize = 0;
    if (!skip) {
        const defaultConfig = (0, $4VJDS.default).getString('cc_complexit_fe_progressive_adf_rendering_configs', '').split(',');
        const batchSizeConfig = Number(defaultConfig[0]) || 1000;
        const multiplierConfig = Number(defaultConfig[1]) || 1;
        // Figure out whether progressive rendering is to be enabled:
        if (totalNodeCount >= batchSizeConfig * multiplierConfig) {
            isComplexPageReason = 'TooManyNodes';
            batchSize = batchSizeConfig;
        } else if ((nodeCountByType['extension'] || 0) + (nodeCountByType['inlineExtension'] || 0) + (nodeCountByType['bodiedExtension'] || 0) + (nodeCountByType['multiBodiedExtension'] || 0) > 4) isComplexPageReason = 'TooManyExtensions';
    }
    return {
        isComplexPageReason: isComplexPageReason,
        batchSize: batchSize
    };
};


const $cea2e5ba540a4cdb$export$484ca74668034d1a = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    const { adfContentId: adfContentId, skip: skip } = props;
    const { isComplexPageReason: isComplexPageReason, batchSize: batchSize } = (0, $2c965f70a5ee6b1b$export$5975a8ab7eb35660)(props);
    let t0;
    if ($[0] !== adfContentId) {
        t0 = {
            adfContentId: adfContentId
        };
        $[0] = adfContentId;
        $[1] = t0;
    } else t0 = $[1];
    const { onlySerializeFirstBatch: onlySerializeFirstBatch, onBatchRendered: onBatchRendered } = (0, $9b48afaee399d3ff$export$a41c3f74aab75ba5)(t0);
    let t1;
    if ($[2] !== batchSize || $[3] !== isComplexPageReason || $[4] !== onBatchRendered || $[5] !== onlySerializeFirstBatch) {
        t1 = (init)=>{
            if (isComplexPageReason === "TooManyExtensions") return new (0, $71fea19cc22d532b$export$96066f3459dc24dc)(init, onlySerializeFirstBatch, onBatchRendered);
            else return new (0, $2eea383c18bc2e17$export$63b7ba093b5cd770)(init, batchSize, onlySerializeFirstBatch, onBatchRendered);
        };
        $[2] = batchSize;
        $[3] = isComplexPageReason;
        $[4] = onBatchRendered;
        $[5] = onlySerializeFirstBatch;
        $[6] = t1;
    } else t1 = $[6];
    const createComplexPageSerializer = t1;
    if (!skip && isComplexPageReason) return createComplexPageSerializer;
} : (props)=>{
    const { adfContentId: adfContentId, skip: skip } = props;
    const { isComplexPageReason: isComplexPageReason, batchSize: batchSize } = (0, $2c965f70a5ee6b1b$export$5975a8ab7eb35660)(props);
    // Initially, only serialize the first batch. This is a performance optimization to delay
    // serialization of the remaining batches until later. The optimization is disabled if there
    // are not enough batches to warrant it.
    //
    // For SSR, subsequent serializations never happen.
    // For SPA, subsequent serializations happen after the first batch is rendered.
    const { onlySerializeFirstBatch: onlySerializeFirstBatch, onBatchRendered: onBatchRendered } = (0, $9b48afaee399d3ff$export$a41c3f74aab75ba5)({
        adfContentId: adfContentId
    });
    const createComplexPageSerializer = (0, $42omo.useCallback)((init)=>{
        if (isComplexPageReason === 'TooManyExtensions') return new (0, $71fea19cc22d532b$export$96066f3459dc24dc)(init, onlySerializeFirstBatch, onBatchRendered);
        else // Progressively renders ADF as described at https://hello.atlassian.net/wiki/spaces/~lmarinov/pages/5177285037/COMPLEXIT+Progressive+rendering+of+ADF
        return new (0, $2eea383c18bc2e17$export$63b7ba093b5cd770)(init, batchSize, onlySerializeFirstBatch, onBatchRendered);
    }, [
        batchSize,
        isComplexPageReason,
        onlySerializeFirstBatch,
        onBatchRendered
    ]);
    if (!skip && isComplexPageReason) return createComplexPageSerializer;
};









var $4FxUL = parcelRequire("4FxUL");


var $dx8CK = parcelRequire("dx8CK");


var $fySJw = parcelRequire("fySJw");


var $hMRhJ = parcelRequire("hMRhJ");


var $ebUME = parcelRequire("ebUME");

const $a735f8c8b32f03c5$var$MACRO_REGEX = /data-macro-name="(.+?)"/;
const $a735f8c8b32f03c5$export$b839509474480e69 = (macroRenderedOutput)=>{
    const parsedMacros = new Set();
    macroRenderedOutput?.forEach((macro)=>{
        const macroName = macro?.value?.value?.match($a735f8c8b32f03c5$var$MACRO_REGEX);
        if (!macroName) return;
        if (parsedMacros.has(macroName[1])) {
            const tags = macro?.value?.webresource?.tags;
            if (tags) tags.js = '';
        } else parsedMacros.add(macroName[1]);
    });
    return macroRenderedOutput;
};



var $gTyTP = parcelRequire("gTyTP");





var $e8Lxy = parcelRequire("e8Lxy");


var $8pcS0 = parcelRequire("8pcS0");

function $54eb6276e3fffcef$export$699d8efb713e86d4(delegates) {
    const extensionType = (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE;
    const delegate = $54eb6276e3fffcef$var$getExtensionRenderer(delegates?.[extensionType]);
    if (delegate) return {
        [extensionType]: function extensionHandler(ext) {
            if (ext.extensionKey === (0, $8pcS0.EXTENSION_KEY).TOC && ext.extensionType === extensionType) return delegate.apply(this, arguments);
            else return null;
        }
    };
}
function $54eb6276e3fffcef$var$getExtensionRenderer(extensionHandler) {
    if (extensionHandler && typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}


function $b240ca0c78d31548$export$3380a1458ccc1bcb({ content: content, contentId: contentId, contentBody: contentBody, contentMode: contentMode, isTemplateEditorRenderer: isTemplateEditorRenderer, spaceKey: spaceKey, spaceId: spaceId, isPreviewMode: isPreviewMode }, annotationProvider) {
    const { featureFlags: featureFlags, environment: environment, cloudId: cloudId, userId: userId, locale: locale, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [manifestReadyState, setManifestReadyState] = (0, $42omo.useState)(false);
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $42omo.useContext)((0, $hMRhJ.RendererExtensionContext));
    const contentType = content?.type;
    const adf = contentBody?.value || '';
    const macroRenderedOutput = (0, $42omo.useMemo)(()=>content && 'macroRenderedOutput' in content ? (0, $a735f8c8b32f03c5$export$b839509474480e69)(content['macroRenderedOutput']) : null, [
        content
    ]);
    // If legacy fabric macros exist, superbatch css and js needs to be added
    // only once before any macros are rendered.
    const includeSuperbatch = (0, $42omo.useCallback)(()=>{
        (0, $e8Lxy.includeSuperbatchForFabricMacro)(contentBody, macroRenderedOutput);
    }, [
        contentBody,
        macroRenderedOutput
    ]);
    // Extension handlers during SSR should not be used to populate extension providers
    // Otherwise extensions manifest would reference the wrong handlers if it needs to be overrided
    // during runtime
    const extensionHandlersWithSSR = (0, $42omo.useMemo)(()=>(0, $ebUME.getSsrExtensionHandlers)({
            adf: contentBody?.value,
            contentId: contentId || '',
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId,
            macroRenderedOutput: macroRenderedOutput,
            includeSuperbatch: includeSuperbatch
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        includeSuperbatch
    ]);
    const referentialityDataSourceProvider = (0, $42omo.useMemo)(()=>{
        const refDataProvider = new (0, $dx8CK.DataSourceProvider)();
        (0, $fySJw.getConnectDataListener)().init({
            emit: (localId, reference)=>refDataProvider.createOrUpdate(localId, reference)
        });
        return refDataProvider;
    }, []);
    const extensionHandlers = (0, $42omo.useMemo)(()=>{
        return getExtensionHandlers?.({
            adf: adf,
            contentId: contentId,
            spaceKey: spaceKey,
            macroRenderedOutput: macroRenderedOutput,
            showTemplateVariablesInPreview: isTemplateEditorRenderer,
            shouldIncludeMacroWithReferencesHandlers: true,
            referentialityDataSourceProvider: referentialityDataSourceProvider,
            contentType: contentType,
            isPreviewMode: isPreviewMode,
            annotationProvider: annotationProvider
        }, createAnalyticsEvent);
    }, [
        getExtensionHandlers,
        contentId,
        spaceKey,
        adf,
        macroRenderedOutput,
        contentType,
        isPreviewMode,
        createAnalyticsEvent,
        isTemplateEditorRenderer,
        annotationProvider,
        referentialityDataSourceProvider
    ]);
    const isSsrRendered = window.__SSR_RENDERED__;
    // The extensionHandlers prop value of PageContentRendererFabric when NOT isTemplateEditorRenderer:
    const handlers = (0, $42omo.useMemo)(()=>{
        if (!isTemplateEditorRenderer) {
            if (!manifestReadyState) {
                // POST/NON SSR, macros V2 is on, and manifest is ready, extension handlers is undefined to use extension manifest
                // Don't use client side macro renderer until manifestReadyState because it takes additional cycle to render
                // The loading state will destroy the SSR rendered content
                //
                // The first render of client-side need extensionHandlersWithSSR for proper hydration as well.
                if (isSsrRendered) return extensionHandlersWithSSR;
                else return (0, $54eb6276e3fffcef$export$699d8efb713e86d4)(extensionHandlers);
            }
        }
    }, [
        extensionHandlers,
        extensionHandlersWithSSR,
        isSsrRendered,
        isTemplateEditorRenderer,
        manifestReadyState
    ]);
    const dataProviders = (0, $42omo.useMemo)(()=>{
        const providerFactory = (0, $4FxUL.default).create({});
        const intlStub = {
            formatMessage: (message)=>message?.defaultMessage,
            locale: locale
        };
        if (populateExtensionProviders) populateExtensionProviders(providerFactory, {
            intl: intlStub,
            containerId: spaceKey,
            accountId: userId,
            cloudId: cloudId,
            spaceKey: spaceKey,
            spaceId: spaceId,
            contentId: contentId,
            contentType: contentType,
            contentMode: contentMode,
            environment: environment,
            featureFlags: featureFlags,
            extensionHandlers: extensionHandlers,
            setManifestReadyState: setManifestReadyState,
            createAnalyticsEvent: createAnalyticsEvent,
            activationId: activationId,
            isLivePagesFeatureEnabled: isLivePagesFeatureEnabled
        });
        return providerFactory;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        contentType,
        extensionHandlers,
        populateExtensionProviders,
        isLivePagesFeatureEnabled,
        createAnalyticsEvent
    ]);
    return {
        dataProviders: dataProviders,
        extensionHandlers: isTemplateEditorRenderer ? extensionHandlers : handlers
    };
}


const $6bb2ed8a39c0056d$var$fabricErrorBoundaryAttributes = {
    fabric: true
};
const $6bb2ed8a39c0056d$var$WORKSPACE_RESOURCE_TYPE = 'workspace';
const $6bb2ed8a39c0056d$export$93e4c805d88fad94 = (props)=>{
    const { content: content, contentId: contentId, contentBody: contentBody, rootEl: rootEl, setRootEl: setRootEl, hasInlineComments: hasInlineComments, hasProgressiveRendering: hasProgressiveRendering, isSpaceOverview: isSpaceOverview, eventHandlerOverrides: eventHandlerOverrides, spaceKey: spaceKey, spaceId: spaceId, renderPerformanceMetrics: renderPerformanceMetrics, revision: revision, contentAppearance: contentAppearance, markerRefs: markerRefs, queryHash: queryHash, isArchived: isArchived, contentStatusError: contentStatusError, isContentHeaderFixedAtTop: isContentHeaderFixedAtTop, customPerfData: customPerfData, isPresentational: isPresentational, document: document, ...rest } = props;
    const { featureFlags: featureFlags, cloudId: cloudId, userId: userId, locale: locale, activationId: activationId, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { setDocumentUpdated: setDocumentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { setUpdateDocumentFn: setUpdateDocumentFn } = (0, $1YPul.useUpdateDocumentActions)();
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [state] = (0, $isEtk.useContentState)();
    const localRef = (0, $42omo.useRef)(null);
    const [renderComplete, setRenderComplete] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $88Nzy.usePrintIntercept)({
        enabled: (0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true),
        shouldBlockPrint: ()=>false
    });
    (0, $7oCdN.usePrintCoverInjector)((0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true), intl);
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $6mKj3.expValEquals)('confluence_fetch_appkey_field', 'isEnabled', true) ? (0, $f892729dfaf9dece$export$2e2bcd8739ae039) : (0, $1a9d70ad6034bafd$export$2e2bcd8739ae039)
    });
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const routeHashValue = (0, $dPJCf.useHash)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const contentType = content?.type;
    const lastModifiedDate = content?.metadata?.lastModifiedDate;
    // adfContentId is the content ID associated with the loaded ADF document. In contrast, contentId is the content ID from the URL.
    // This distinction is important because during page transitions we keep the old ADF document loaded while loading the new one.
    const adfContentId = content?.id;
    const adf = contentBody?.value || '';
    const isFabric = contentBody?.representation === 'atlas_doc_format';
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_disable_preview_panel_nudgebar') ? (0, $eToX6.isInPreviewPanel)() : false;
    const displayInlineCommentNudger = canAddComments && hasInlineComments && !isSpaceOverview && !commentResidesInPreviewPanel;
    const isReadingAidsAutoHighlightEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""');
    const cloudIdARI = (0, $kYvrE.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const contentARI = contentType ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId,
        activationId: ''
    }) : '';
    const spaceARI = spaceId ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'space',
        resourceId: spaceId,
        activationId: ''
    }) : '';
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: $6bb2ed8a39c0056d$var$WORKSPACE_RESOURCE_TYPE,
        resourceId: activationId,
        activationId: ''
    });
    const { data: queryData } = (0, $j1Ss3.useQuery)((0, $gKMkU.PlatformHighlightKeywordsQuery), {
        variables: {
            workspaceId: workspaceId,
            entityAri: contentARI
        },
        client: (0, $gKr8t.getAGGClient)(),
        skip: !isReadingAidsAutoHighlightEnabled
    });
    const keyPhrases = (0, $42omo.useMemo)(()=>queryData?.knowledgeDiscovery?.keyPhrases?.nodes ?? [], [
        queryData
    ]);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>(0, $le4yZ.getHighlightRegex)(queryData?.knowledgeDiscovery?.keyPhrases?.nodes ?? []), [
        queryData
    ]);
    const { fetchDefinition: fetchDefinition } = (0, $eVM9z.useDefinitionSupplier)({
        workspaceId: workspaceId,
        cloudIdARI: cloudIdARI,
        fetchConfig: {
            entity_ari: contentARI
        },
        productConfig: {
            contentId: contentARI,
            spaceId: spaceARI
        },
        isDefinitionCurationEnabled: true,
        product: 'confluence'
    });
    const onDisableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, true);
    }, []);
    const onEnableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, false);
    }, []);
    const getDefinitionsDisabled = (0, $42omo.useCallback)(()=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT), []);
    const definitionRestrictionOptions = (0, $97Szk.useDefinitionRestrictionOptions)(contentType ?? undefined);
    const [hideHeadingIds, setHideHeadingIds] = (0, $42omo.useState)(Boolean(routeHashValue));
    const extensionViewportSizes = (0, $1ITQ3.useExtensionViewportSizes)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    (0, $42omo.useEffect)(()=>{
        if (hideHeadingIds) {
            const t = setTimeout(()=>{
                setHideHeadingIds(false);
            }, 0);
            return ()=>clearTimeout(t);
        }
    }, [
        hideHeadingIds
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isReadingAidsAutoHighlightEnabled) {
            experienceTracker.start({
                name: (0, $irVI7.AI_DEFINITIONS_AUTOHIGHLIGHT_EXPERIENCE),
                attributes: {
                    contentId: contentId
                }
            });
            try {
                experienceTracker.succeed({
                    name: (0, $irVI7.AI_DEFINITIONS_AUTOHIGHLIGHT_EXPERIENCE),
                    attributes: {
                        contentId: contentId
                    }
                });
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irVI7.AI_DEFINITIONS_AUTOHIGHLIGHT_EXPERIENCE),
                    attributes: {
                        contentId: contentId
                    },
                    error: error
                });
            }
            if (!(0, $9wGTI.fg)('kd_definitions_click_and_show_event_product_parity')) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'readingAidsAcronymHighlights',
                    source: 'viewPageScreen',
                    attributes: {
                        contentId: contentId,
                        numHighlights: keyPhrases.length,
                        categories: (0, $7rLBD.getHighlightCategories)(keyPhrases),
                        beAcronymsEnabled: true
                    }
                }
            }).fire();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataActions)();
    const { isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const eventHandlers = (0, $42omo.useMemo)(()=>({
            ...(0, $kdOv6.createSmartCardEventHandler)({
                push: push,
                matchRoute: matchRoute
            }),
            ...(0, $h0UOA.createLinkEventHandler)({
                push: push,
                matchRoute: matchRoute
            }),
            ...eventHandlerOverrides
        }), [
        push,
        matchRoute,
        eventHandlerOverrides
    ]);
    const isAutoConverted = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? (0, $ayQVU.getAutoConvertionInfo)(content).isAutoConverted : !(0, $ayQVU.getAutoConvertionInfo)(content).editorProperty, [
        content
    ]);
    /**
   * Inline Edit section starts
   */ const [documentFromHook] = (0, $e1eb2588da6dd9c8$export$136dd42e3a5ac40a)(adf, isFabric);
    const adfDocument = document ?? documentFromHook;
    const adfStats = (0, $9d71800faf33d82e$export$6b8ad6aa37e0cff2)(adfDocument, customPerfData);
    const createSerializer = (0, $cea2e5ba540a4cdb$export$484ca74668034d1a)({
        skip: !hasProgressiveRendering,
        totalNodeCount: adfStats.totalNodeCount,
        nodeCountByType: adfStats.nodeCountByType,
        adfContentId: adfContentId || undefined
    });
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const readAndWriteQueryCache = (0, $a04de01f0d2a7d21$export$2f6929c1438cd284)({
        query: chooseContentUnifiedQuery,
        contentId: contentId,
        spaceKey: spaceKey
    });
    /**
   * Inline Edit section ends
   */ // e.g. this runs when a new top level comment is made on the page
    const updateDocument = (0, $42omo.useCallback)((newAdfDoc)=>{
        readAndWriteQueryCache(newAdfDoc);
        setDocumentUpdated(true);
        // Give document time to update
        // TODO: turn this into an async function
        setTimeout(()=>{
            setDocumentUpdated(false);
        }, 1500);
    }, [
        readAndWriteQueryCache,
        setDocumentUpdated
    ]);
    (0, $42omo.useEffect)(()=>{
        // Set the updateDocument function whenever the renderer mounts with a new contentId
        setUpdateDocumentFn(updateDocument);
    }, [
        contentId,
        setUpdateDocumentFn,
        updateDocument
    ]);
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const rendererAnnotationProviderOptions = (0, $8Ij3v.useRendererAnnotationProviderOptions)({
        pageId: contentId,
        validAnnotationsCallback: (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? updateUnresolvedInlineCommentFn : updateUnresolvedInlineComment,
        triggerAnalyticsEvent: createAnalyticsEvent,
        updateDocument: updateDocument,
        isArchived: isArchived
    });
    const annotationProvider = hasInlineComments ? rendererAnnotationProviderOptions : undefined;
    const { mode: mode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId,
        isArchived: isArchived
    });
    let contentMode;
    if ((0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'forceAll', true)) contentMode = 'compact';
    else if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) contentMode = mode;
    else contentMode = undefined;
    const { dataProviders: dataProviders, extensionHandlers: extensionHandlers } = (0, $b240ca0c78d31548$export$3380a1458ccc1bcb)({
        ...props,
        contentMode: contentMode
    }, annotationProvider);
    (0, $42omo.useEffect)(()=>{
        setRenderComplete(false);
    }, [
        contentId
    ]);
    const handleOnComplete = (0, $42omo.useCallback)(()=>{
        window.__RENDERER_NODES_COUNT__ = adfStats.nodeCountByType;
        setRenderComplete(true);
    }, [
        adfStats.nodeCountByType
    ]);
    const memoRendererTTIMarkerRenderWhenReady = (0, $42omo.useMemo)(()=>renderPerformanceMetrics({
            contentId: contentId,
            isFabric: true,
            appearance: contentAppearance,
            revision: revision,
            isRenderTTIMark: true,
            isAutoConverted: isAutoConverted,
            lastModifiedDate: lastModifiedDate,
            customPerfData: customPerfData
        }), [
        contentId,
        contentAppearance,
        revision,
        isAutoConverted,
        lastModifiedDate,
        customPerfData,
        renderPerformanceMetrics
    ]);
    const memoAdfRendererRenderWhenReady = (0, $42omo.useMemo)(()=>renderPerformanceMetrics({
            isFabric: true
        }), [
        renderPerformanceMetrics
    ]);
    // This is used to prevent re-renders of the text highlighter by converting all deps into a string formatted const
    const textHighlighterDependency = isReadingAidsAutoHighlightEnabled + autoHighlightRegex.toString() + keyPhrases?.length;
    const memoTextHighlighter = (0, $42omo.useMemo)(()=>isReadingAidsAutoHighlightEnabled ? {
            pattern: autoHighlightRegex,
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f632232661ebd6b0$export$524ca09d83a1460f), {
                    ...props,
                    keyPhrases: keyPhrases
                })
        } : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textHighlighterDependency
    ]);
    const memoTextPlatformHighlighter = (0, $42omo.useMemo)(()=>{
        const sourceConfig = {
            brand: isRovoEnabled ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI,
            cloudId: cloudId,
            contentARI: contentARI,
            contentId: contentId,
            experience: 'contentAutohighlight',
            source: 'readingAids',
            sourceProduct: 'confluence',
            userId: userId ?? '',
            workspaceId: workspaceId
        };
        const curatedDefinitionScopeConfig = {
            workspaceId: workspaceId,
            definitionRestrictionOptions: definitionRestrictionOptions,
            productScopes: {
                contentARI: contentARI,
                spaceARI: spaceARI
            },
            cloudId: cloudId,
            product: 'confluence'
        };
        const definitionConfig = {
            fetchDefinition: fetchDefinition,
            isAutohighlighted: true,
            definitionCurationOptions: {
                curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
            },
            disableDefinitionsCallbacks: {
                onDisableDefinitions: onDisableDefinitions,
                onEnableDefinitions: onEnableDefinitions,
                getDefinitionsDisabled: getDefinitionsDisabled
            },
            showChatFollowUps: isRovoLLMEnabled
        };
        return isReadingAidsAutoHighlightEnabled ? {
            pattern: autoHighlightRegex,
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kNfRw.RendererDefinitionTextHighlighter), {
                    ...props,
                    definitionConfig: definitionConfig,
                    keyPhrases: keyPhrases,
                    sourceConfig: sourceConfig
                })
        } : undefined;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        textHighlighterDependency
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE,
        attributes: $6bb2ed8a39c0056d$var$fabricErrorBoundaryAttributes
    }, contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "selection-portal"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $5YLPl.CONTENT_RENDERER_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $72e3a5d49a76ae4e$export$52c9562a5d07c846), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEvSd.RendererTTIMarker), {
            revision: revision,
            renderWhenReady: memoRendererTTIMarkerRenderWhenReady
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnAk8.StyledRenderer), {
            "data-testid": "pageContentRendererTestId",
            "data-vc": "pageContentRendererTestId",
            id: "main-content",
            ref: setRootEl,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "wiki-content",
            "data-test-appearance": contentAppearance,
            isFabric: true,
            bannerHeight: bannerState.getTotalHeight() || 0,
            markerRefs: markerRefs,
            intl: intl,
            isChildrenFGEnabled: (0, $9wGTI.fg)('confluence_exclude_children_macro_from_blocklist')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h8C1D.ExtrensionIndexProvider), {
            document: adfDocument
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            onEvent: (0, $03a558b37ccdab2e$export$ad07f58b79e98b10)(contentId),
            channel: "editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
            contentId: contentId,
            revision: revision,
            featureFlags: featureFlags,
            contentRendererMode: "renderer",
            useServerRenderedData: renderServerPlaceholder,
            readFragmentInterop: readFragmentInterop
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: "renderer-overrides"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2898f6304bad9ac$export$4f87e2b96269dff7), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $habRv.WithAnnotationsWrapper), {
            isArchived: isArchived,
            annotationProvider: annotationProvider,
            rendererRef: localRef,
            adfDocument: adfDocument,
            updateDocument: updateDocument,
            isNestedRender: false,
            lastModifiedDate: lastModifiedDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
            // WARN: AkRenderer relies on remount to correctly initialize media providers, which
            // must be re-initialized whenever we show new content. Also under certain circumstances
            // simple modification of the content can mangle the content displayed by AK renderer.
            // Revision is used as content can change upon reload initiated by Very Quick Reload™ feature.
            // See https://product-fabric.atlassian.net/browse/ED-10791 for details.
            key: revision,
            appearance: contentAppearance,
            contentMode: contentMode,
            contentId: contentId,
            document: adfDocument,
            eventHandlers: eventHandlers,
            extensionHandlers: extensionHandlers,
            portal: rootEl ?? undefined,
            renderWhenReady: memoAdfRendererRenderWhenReady,
            includeNodesCountInStats: false,
            onComplete: handleOnComplete,
            dataProviders: dataProviders,
            queryHash: queryHash,
            allowSelectAllTrap: true,
            isContentHeaderFixedAtTop: isContentHeaderFixedAtTop,
            allowAnnotations: hasInlineComments,
            annotationProvider: annotationProvider,
            innerRef: localRef,
            textHighlighter: (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? memoTextPlatformHighlighter : memoTextHighlighter,
            disableHeadingIDs: renderServerPlaceholder || hideHeadingIds,
            extensionViewportSizes: extensionViewportSizes,
            getExtensionHeight: (0, $9wGTI.fg)('confluence_connect_renderer_height_preset') ? (0, $5b52ab5d3548d3f7$export$b6e5804201dbc820) : undefined,
            UNSTABLE_isPresentational: isPresentational,
            createSerializer: createSerializer,
            allowRendererContainerStyles: pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('platform-ssr-table-resize'),
            ...rest
        }))))))), renderComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7b81bdbe8e487e80$export$43aecdc489234c30), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8HrX3.TaskScrollComponent), null)), displayInlineCommentNudger && state?.isContentReady && !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fef48aa9e4834ddc$export$908769aa3104966), {
            key: revision,
            contentId: contentId,
            contentAppearance: contentAppearance
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVane.InlineCommentLinkHandler), null)), isInReattachMode() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d721eb932133019$export$b905eb318829d354), {
            containerId: contentId,
            updateDocument: updateDocument
        }))))));
};
const $6bb2ed8a39c0056d$export$cf8a0a38543b2f6c = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "page-content-renderer-fabric"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6bb2ed8a39c0056d$export$93e4c805d88fad94, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-content-renderer-fabric"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6bb2ed8a39c0056d$export$93e4c805d88fad94, props));
module.exports["PageContentRendererFabricInternal"] = $6bb2ed8a39c0056d$export$93e4c805d88fad94;
module.exports["PageContentRendererFabric"] = $6bb2ed8a39c0056d$export$cf8a0a38543b2f6c;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("7mpOv", function(module, exports) {

var $gejop = parcelRequire("gejop");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$var$UseIsAIEnabledForContentQuery = (0, $gejop.default);
const $7ae32555811cd45f$var$isAIReadAllowed = (operationsList)=>{
    if (operationsList) return operationsList.some((item)=>item?.operation === 'ai_read');
    else return false;
};
const $7ae32555811cd45f$export$cc5edac91cdebf9b = ({ contentId: contentId })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback.
    // This encodes environment composition (e.g., commercial-cloud: true, fedramp-moderate: false, isolated-commercial-cloud-ga: true).
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7ae32555811cd45f$var$UseIsAIEnabledForContentQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || !isAIFeatureEnabled || !isAdminHubAIEnabled && !shouldShowRovo || !(0, $9wGTI.fg)('confluence_ai_access_policy')
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    if (!(0, $9wGTI.fg)('confluence_ai_access_policy')) return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
    const aiRead = $7ae32555811cd45f$var$isAIReadAllowed(data?.content?.nodes?.[0]?.operations);
    return {
        isAIEnabledForContent: aiRead && isAdminHubAIEnabled,
        isRovoEnabledForContent: aiRead && shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("gejop", function(module, exports) {
/**
 * @generated SignedSource<<dcc7465266fc46a48308c2a084af2ed9>>
 * @relayHash 3a27260e57e410ffecd4ba617c6d3637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d
const $3cac748832e2023e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3a27260e57e410ffecd4ba617c6d3637",
            "id": "31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d",
            "metadata": {},
            "name": "useIsAIEnabledForContentQuery",
            "operationKind": "query",
            "text": "query useIsAIEnabledForContentQuery($contentId:ID!){content(id:$contentId){nodes{id,operations{targetType,operation}}}}"
        }
    };
}();
$3cac748832e2023e$var$node.hash = "87034a7db072a7db419402593bcbd707";
var $3cac748832e2023e$export$2e2bcd8739ae039 = $3cac748832e2023e$var$node;
module.exports["default"] = $3cac748832e2023e$export$2e2bcd8739ae039;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("brNvA", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $42omo.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $42omo.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    const providerValue = (0, $42omo.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("WheoQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $42omo.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("dANtQ", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $eSUdr.default)`query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId status:["draft" "current"]){nodes{id type operations{operation targetType}}}}`;
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $diswb.useQuery)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        skip: !contentId
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");


var $6mKj3 = parcelRequire("6mKj3");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$a586f466261ecb73 = ()=>{
    const baseRoutes = [
        (0, $1NBp8.DATABASE_VIEW).name,
        (0, $1NBp8.VIEW_PAGE).name,
        (0, $1NBp8.WHITEBOARD_BOARD).name,
        (0, $1NBp8.EMBED_VIEW).name
    ];
    if ((0, $6mKj3.expValEquals)('cc-axp-delete-editing-page-redirect', 'isEnabled', true)) return [
        ...baseRoutes,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_PAGE_V2).name
    ];
    return baseRoutes;
};
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["getDeleteSuccessRedirectRoutes"] = $2aa2bdb281c6889a$export$a586f466261ecb73;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("lpxTx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ac0bfd36ecfdf97$export$7e83667ababb3077 = (0, $eSUdr.default)`query ContentBlogUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false){content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentBlogUnifiedQuery"] = $4ac0bfd36ecfdf97$export$7e83667ababb3077;

});

parcelRegister("61vTv", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7b6381fcd1b9e458$export$16dddce791a11901 = (0, $eSUdr.default)`query ContentUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "emoji-title-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentUnifiedQuery"] = $7b6381fcd1b9e458$export$16dddce791a11901;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("8tGpb", function(module, exports) {

let $62c1ecf87e58b6a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62c1ecf87e58b6a3$var$load("eY3St"),
    $62c1ecf87e58b6a3$var$load("bkd4T"),
    $62c1ecf87e58b6a3$var$load("2YffH"),
    $62c1ecf87e58b6a3$var$load("iDB1L"),
    $62c1ecf87e58b6a3$var$load("19uFC"),
    $62c1ecf87e58b6a3$var$load("a4yJG"),
    $62c1ecf87e58b6a3$var$load("6mHrv"),
    $62c1ecf87e58b6a3$var$load("2Gceu"),
    $62c1ecf87e58b6a3$var$load("1FvvC"),
    $62c1ecf87e58b6a3$var$load("9zkjw"),
    $62c1ecf87e58b6a3$var$load("4DSeC"),
    $62c1ecf87e58b6a3$var$load("607sQ"),
    $62c1ecf87e58b6a3$var$load("eEyVs"),
    $62c1ecf87e58b6a3$var$load("eieu4"),
    $62c1ecf87e58b6a3$var$load("1YtXy"),
    $62c1ecf87e58b6a3$var$load("hyzoX"),
    $62c1ecf87e58b6a3$var$load("glHWp"),
    $62c1ecf87e58b6a3$var$load("9w0Re"),
    $62c1ecf87e58b6a3$var$load("1wQU1"),
    $62c1ecf87e58b6a3$var$load("ikQAz"),
    $62c1ecf87e58b6a3$var$load("8YSo7"),
    $62c1ecf87e58b6a3$var$load("gryT8"),
    $62c1ecf87e58b6a3$var$load("5uN9h"),
    $62c1ecf87e58b6a3$var$load("9XYQ9"),
    $62c1ecf87e58b6a3$var$load("kiGNy"),
    $62c1ecf87e58b6a3$var$load("cHQ50"),
    $62c1ecf87e58b6a3$var$load("k8XPW"),
    $62c1ecf87e58b6a3$var$load("fWCRm"),
    $62c1ecf87e58b6a3$var$load("hrbhL"),
    $62c1ecf87e58b6a3$var$load("g9CVe"),
    $62c1ecf87e58b6a3$var$load("jTaSF"),
    $62c1ecf87e58b6a3$var$load("7FRNR"),
    $62c1ecf87e58b6a3$var$load("9YBgR"),
    $62c1ecf87e58b6a3$var$load("7ZIlR"),
    $62c1ecf87e58b6a3$var$load("8fXIr"),
    $62c1ecf87e58b6a3$var$load("dVkhd"),
    $62c1ecf87e58b6a3$var$load("hhss7"),
    $62c1ecf87e58b6a3$var$load("dTsOE"),
    $62c1ecf87e58b6a3$var$load("7jSfd"),
    $62c1ecf87e58b6a3$var$load("4HZlX"),
    $62c1ecf87e58b6a3$var$load("kDqHr"),
    $62c1ecf87e58b6a3$var$load("6wr18"),
    $62c1ecf87e58b6a3$var$load("kjZZD"),
    $62c1ecf87e58b6a3$var$load("9ZAzg"),
    $62c1ecf87e58b6a3$var$load("kJSYP"),
    $62c1ecf87e58b6a3$var$load("Wowvf"),
    $62c1ecf87e58b6a3$var$load("8m8aj"),
    $62c1ecf87e58b6a3$var$load("lT67w"),
    $62c1ecf87e58b6a3$var$load("8lj0L"),
    $62c1ecf87e58b6a3$var$load("ffEVr"),
    $62c1ecf87e58b6a3$var$load("kAAjo"),
    $62c1ecf87e58b6a3$var$load("fbRdC"),
    $62c1ecf87e58b6a3$var$load("d6s42"),
    $62c1ecf87e58b6a3$var$load("gZGoR"),
    $62c1ecf87e58b6a3$var$load("efnul"),
    $62c1ecf87e58b6a3$var$load("7EorR"),
    $62c1ecf87e58b6a3$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1c52947b4a05fe02fc1b43b80c341c9c>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<64599f16afee950a47221dcfc47cc997>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fovJE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");


var $jiQMW = parcelRequire("jiQMW");

const $9bf0c3c3a20a9cd4$export$138fe2534f55f0bb = 'cc-reading-aids-highlight-spotlight';
const $9bf0c3c3a20a9cd4$var$i18n = (0, $cgtv4.defineMessages)({
    acronymHighlightSpotlightText: {
        id: "contextual-reading-aids.acronym-highlight-spotlight.text",
        defaultMessage: "Highlight and define any company-specific terms, project names, and jargon without leaving the page!"
    },
    acronymHighlightSpotlightDismissButtonText: {
        id: "contextual-reading-aids.acronym-highlight-spotlight.dismiss-button.text",
        defaultMessage: "Dismiss"
    }
});
const $9bf0c3c3a20a9cd4$export$448cddbfa5406d76 = ({ contentId: contentId, onDismissClick: onDismissClick })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'readingAidsAcronymSpotlightDismissButton',
                source: 'readingAidsAcronymSpotlight',
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
        onDismissClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        dialogWidth: 275,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jiQMW))),
        actions: [
            {
                text: intl.formatMessage($9bf0c3c3a20a9cd4$var$i18n.acronymHighlightSpotlightDismissButtonText),
                onClick: handleOnClick
            }
        ],
        target: $9bf0c3c3a20a9cd4$export$138fe2534f55f0bb,
        targetRadius: 4,
        messageType: "engagement"
    }, intl.formatMessage($9bf0c3c3a20a9cd4$var$i18n.acronymHighlightSpotlightText));
};
module.exports["READING_AIDS_ACRONYM_SPOTLIGHT_MESSAGE_ID"] = $9bf0c3c3a20a9cd4$export$138fe2534f55f0bb;
module.exports["ReadingAidsAcronymSpotlight"] = $9bf0c3c3a20a9cd4$export$448cddbfa5406d76;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedToggle: $d24b02c281555a47$var$ChoreographerComponentStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("jiQMW", function(module, exports) {
module.exports = new URL("spotlightImage.33d23bc6.svg", import.meta.url).toString();

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("gKMkU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");


var $gw4Eo = parcelRequire("gw4Eo");

const $7309ff12be989147$export$a95d48b280e02650 = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>{
    const entityAri = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId,
        activationId: ''
    });
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    });
    return (0, $dYU3e.queryAgg)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $7309ff12be989147$export$2d09cf1ac847a2a4,
        variables: {
            workspaceId: workspaceId,
            entityAri: entityAri
        }
    });
};
const $7309ff12be989147$export$2d09cf1ac847a2a4 = (0, $eSUdr.default)`query PlatformHighlightKeywordsQuery($entityAri:String!$workspaceId:String!$jiraReporterAccountId:String$jiraAssigneeAccountId:String$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri workspaceId:$workspaceId jiraReporterAccountId:$jiraReporterAccountId jiraAssigneeAccountId:$jiraAssigneeAccountId inputText:$inputText)@optIn(to:"KnowledgeDiscovery Get Key Phrases"){__typename ...on KnowledgeDiscoveryKeyPhraseConnection{nodes{...on KnowledgeDiscoveryKeyPhrase{keyPhrase category}}}...on QueryError{message}}}}`;
module.exports["preloadAutohighlights"] = $7309ff12be989147$export$a95d48b280e02650;
module.exports["PlatformHighlightKeywordsQuery"] = $7309ff12be989147$export$2d09cf1ac847a2a4;

});

parcelRegister("dYU3e", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");



var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $9wGTI = parcelRequire("9wGTI");


var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    let single = true;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // Save current boundary context
    const currentBoundary = window.__PRELOAD_BOUNDARY_NAME__;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return client.query({
            query: query,
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            context: queryContext
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Restore the previous boundary context as soon as the query resolves
            window.__PRELOAD_BOUNDARY_NAME__ = currentBoundary;
            const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
            return {
                ...result,
                hasErrors: hasErrors
            };
        });
    })();
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("7rLBD", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("h9CEi", function(module, exports) {

let $c7d141cfb40f53a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7d141cfb40f53a3$var$load("gJjCK").then(()=>parcelRequire('b7BiQ'));

});

parcelRegister("1ITQ3", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $a4TK8 = parcelRequire("a4TK8");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $336551b5acc450de$export$e863f5b50b03c8cc = (skipQuery = false)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const VIEWPORT_SIZE_KEY = `${(0, $7Ndnw.FORGE_MODULE_XEN_MACRO)}:viewportSizes:${contentId}`;
    const filteredExtensions = window.__SSR_FORGE_EXTENSIONS__?.[VIEWPORT_SIZE_KEY]?.extensions ?? $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES;
    // Technically here cached value can have length of 0.
    // In this case, we don't want to skip the query as we have no way to tell whether its from cache or just default value.
    const hasCachedValue = filteredExtensions.length > 0;
    const { extensions: extensions, loading: loading, error: error } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO),
        skipQuery: skipQuery || hasCachedValue
    });
    const prevExtensionViewportSizes = (0, $42omo.useRef)(filteredExtensions);
    if (loading || error || !extensions) return filteredExtensions;
    const nextExtensionViewportSizes = extensions.map(({ id: id, properties: properties })=>properties?.viewportSize ? {
            extensionId: id,
            viewportSize: properties.viewportSize
        } : undefined).filter(Boolean);
    if (prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevExtensionViewportSizes.current, nextExtensionViewportSizes)) {
        prevExtensionViewportSizes.current = nextExtensionViewportSizes;
        // Write to window object to cache the viewport sizes.
        if (window.__SSR_FORGE_EXTENSIONS__) window.__SSR_FORGE_EXTENSIONS__ = {
            ...window.__SSR_FORGE_EXTENSIONS__,
            [VIEWPORT_SIZE_KEY]: {
                extensions: nextExtensionViewportSizes
            }
        };
    }
    return prevExtensionViewportSizes.current;
};
module.exports["useExtensionViewportSizes"] = $336551b5acc450de$export$e863f5b50b03c8cc;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("3b6WO", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $42omo = parcelRequire("42omo");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: queryOptions,
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $7zIsq.usePrefilteredExtensionList)(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("7zIsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
		 * We don't want to set 'ignore' because that discards errors and we need to inspect
		 * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
		 * https://www.apollographql.com/docs/react/data/error-handling/
		 */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $diswb.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("kqIWy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const options = t0;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t1;
    if ($[2] !== data) {
        t1 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined;
        $[2] = data;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== error || $[5] !== loading || $[6] !== t1) {
        t2 = {
            loading: loading,
            data: t1,
            error: error
        };
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (spaceKey)=>{
    /** @schema cc */ const useSpaceDetailQuery = (0, $4ZxLt.default);
    const options = {
        variables: {
            spaceKey: spaceKey
        }
    };
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(useSpaceDetailQuery, options);
    return {
        loading: loading,
        data: data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined,
        error: error
    };
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("1wUq9", function(module, exports) {

let $11d48b975a593f02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $11d48b975a593f02$var$load("kugUh").then(()=>parcelRequire('cC9xk'));

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("8HrX3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

const $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedTaskId');
const $a7f86182a225a9f3$var$TaskScrollComponentInner = ()=>{
    const focusedTaskId = $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    if (focusedTaskId) {
        const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
        if (taskElement) {
            taskElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
            // Remove the query param immediately after task scroll is complete
            setQueryParams({
                focusedTaskId: undefined
            });
        }
    }
    return null;
};
const $a7f86182a225a9f3$export$d9ea3940454347d1 = ()=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_focused-task-scroll')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7f86182a225a9f3$var$TaskScrollComponentInner, null);
};
module.exports["TaskScrollComponent"] = $a7f86182a225a9f3$export$d9ea3940454347d1;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("kEvSd", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $fwDOR = parcelRequire("fwDOR");


var $78QFu = parcelRequire("78QFu");

const $836ce71c03c38488$export$63d50ae534aa489 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { renderWhenReady: renderWhenReady, revision: t1, children: children } = t0;
    const revision = t1 === undefined ? null : t1;
    const [currentRenderedRevision, setCurrentRenderedRevision] = (0, $42omo.useState)(null);
    let t2;
    if ($[0] !== revision) {
        t2 = (event)=>{
            if (event.payload.action === "rendered" && event.payload.actionSubject === "renderer") {
                setCurrentRenderedRevision(revision);
                event.update($836ce71c03c38488$var$_temp);
            }
        };
        $[0] = revision;
        $[1] = t2;
    } else t2 = $[1];
    const handleEvent = t2;
    const isReady = currentRenderedRevision === revision && revision !== null;
    const shouldInvokeRenderWhenReady = isReady || undefined;
    const t3 = !shouldInvokeRenderWhenReady;
    let t4;
    if ($[2] !== renderWhenReady || $[3] !== shouldInvokeRenderWhenReady) {
        t4 = shouldInvokeRenderWhenReady && renderWhenReady();
        $[2] = renderWhenReady;
        $[3] = shouldInvokeRenderWhenReady;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== handleEvent || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            channel: "editor",
            onEvent: handleEvent
        }, children, t4);
        $[5] = children;
        $[6] = handleEvent;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "RendererTTIMarker",
            hold: t3
        }, t5);
        $[9] = t3;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ renderWhenReady: renderWhenReady, revision: revision = null, children: children })=>{
    const [currentRenderedRevision, setCurrentRenderedRevision] = (0, $42omo.useState)(null);
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (event.payload.action === 'rendered' && event.payload.actionSubject === 'renderer') {
            // Store the current revision so we know what content just rendered
            setCurrentRenderedRevision(revision);
            // adding uniquePageLoad info to renderer rendered event
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
    }, [
        revision,
        setCurrentRenderedRevision
    ]);
    // The content revision prop updates earlier than the renderer event fires.
    // We aren't "ready" until the emitted event syncs up with the revision prop.
    const isReady = currentRenderedRevision === revision && revision !== null;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const shouldInvokeRenderWhenReady = isReady || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "RendererTTIMarker",
        hold: !shouldInvokeRenderWhenReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: "editor",
        onEvent: handleEvent
    }, children, shouldInvokeRenderWhenReady && renderWhenReady()));
};
function $836ce71c03c38488$var$_temp(payload) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        }
    };
}
module.exports["RendererTTIMarker"] = $836ce71c03c38488$export$63d50ae534aa489;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true));
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("aSsfA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
} : ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("88Nzy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2ZJmt = parcelRequire("2ZJmt");


var $bHWAG = parcelRequire("bHWAG");

const $86935ecd4293d578$var$i18n = (0, $cgtv4.defineMessages)({
    lockoutMessage: {
        id: "pdf-print-utils.navigation-lockout-message",
        defaultMessage: "You have unsaved changes. Please save before printing."
    }
});
function $86935ecd4293d578$var$tryGetAtlToken() {
    try {
        return (0, $bHWAG.getLiveAtlToken)();
    } catch  {
        return null;
    }
}
async function $86935ecd4293d578$export$94dac1f6a6cc2b5b(maxTries = 12, interval = 250) {
    let tries = 0;
    for(;;){
        const t = $86935ecd4293d578$var$tryGetAtlToken();
        if (t) return t;
        tries += 1;
        if (tries >= maxTries) throw new Error('atlToken not available');
        await new Promise((r)=>setTimeout(r, interval));
    }
}
function $86935ecd4293d578$export$36438d970303153({ enabled: enabled, shouldBlockPrint: shouldBlockPrint, onPrintBlocked: onPrintBlocked }) {
    const attachedRef = (0, $42omo.useRef)(false);
    const shouldBlockPrintRef = (0, $42omo.useRef)(shouldBlockPrint);
    const [showLockout, setShowLockout] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        shouldBlockPrintRef.current = shouldBlockPrint;
    }, [
        shouldBlockPrint
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        if (attachedRef.current) return;
        attachedRef.current = true;
        if ((0, $bHWAG.isInsideIframe)()) return;
        const handler = async (e)=>{
            const key = typeof e.key === 'string' ? e.key : '';
            const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
            const isPrintCombo = isMac ? e.metaKey && (key === 'p' || key === 'P' // mac: only cmd+P
            ) : e.ctrlKey && (key === 'p' || key === 'P'); // windows/linux: only ctrl+P
            if (!isPrintCombo) return;
            const shouldBlock = shouldBlockPrintRef.current ? shouldBlockPrintRef.current() : false;
            if (shouldBlock) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                setShowLockout(true);
                onPrintBlocked?.();
                return;
            }
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            const pageId = (0, $bHWAG.getPageId)(window.location.pathname);
            if (!pageId) return;
            let atlToken = $86935ecd4293d578$var$tryGetAtlToken();
            if (!atlToken) try {
                atlToken = await $86935ecd4293d578$export$94dac1f6a6cc2b5b();
            } catch  {
                return;
            }
            if (!atlToken || !pageId) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            const params = new URLSearchParams({
                pageId: pageId,
                atl_token: atlToken,
                showPdfBanner: 'true'
            });
            const url = `${window.location.origin}/wiki/spaces/flyingpdf/pdfpageexport.action?${params.toString()}`;
            window.location.assign(url);
        };
        const opts = {
            capture: true,
            passive: false
        };
        window.addEventListener('keydown', handler, opts);
        document.addEventListener('keydown', handler, opts);
        return ()=>{
            window.removeEventListener('keydown', handler, opts);
            document.removeEventListener('keydown', handler, opts);
            attachedRef.current = false;
        };
    }, [
        enabled,
        onPrintBlocked
    ]);
    const lockoutComponent = showLockout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($86935ecd4293d578$var$i18n.lockoutMessage)
    }) : null;
    return lockoutComponent;
}
module.exports["usePrintIntercept"] = $86935ecd4293d578$export$36438d970303153;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("bHWAG", function(module, exports) {
function $661369be983dfb69$export$7b6f372ddaf80f4a() {
    // in SSR or non-browser contexts there is no document
    if (typeof document === 'undefined') return null;
    // try the meta tag first: <meta name="ajs-atl-token" content="...">
    // use a typed querySelector so .content is available on HTMLMetaElement
    const metaToken = document.querySelector('meta[name="ajs-atl-token"]')?.content ?? // fallback to attribute read in case DOM typings differ
    document.querySelector('meta[name="ajs-atl-token"]')?.getAttribute('content');
    if (metaToken) return metaToken;
    // fallback to cookies if readable in this environment
    const m = document.cookie.match(/(?:^|;\s*)(atl\.xsrf\.token|atlassian\.account\.xsrf\.token)=([^;]+)/);
    // group 2 is the token value
    return m ? m[2] : null;
}
function $661369be983dfb69$export$2ce6e339a89daf7a(path) {
    const m = path.match(/\/pages\/(\d+)/);
    return m ? m[1] : null;
}
function $661369be983dfb69$export$1ae14b4842b49ade(path) {
    // Manual pathname check instead of using VIEW_PAGE.match() to avoid circular dependency
    // Using @confluence/named-routes -> @confluence/view-page-common creates a circular dependency:
    // @confluence/content-renderer -> @confluence/pdf-export -> @confluence/view-page-common -> @confluence/content-renderer
    // Pattern matches: /spaces/:spaceKey/pages/:contentId(digits)/:contentSlug?
    return path.match(/\/spaces\/[^/]+\/pages\/\d+/) !== null;
}
function $661369be983dfb69$export$bc4e1d0ebda8ad2c() {
    try {
        return window.self !== window.top;
    } catch (e) {
        // accessing window.top can throw in some cross-origin scenarios
        return true;
    }
}
const $661369be983dfb69$export$d8536155e595e20f = (imagePath)=>{
    const img = new Image();
    img.src = imagePath;
};
module.exports["getLiveAtlToken"] = $661369be983dfb69$export$7b6f372ddaf80f4a;
module.exports["getPageId"] = $661369be983dfb69$export$2ce6e339a89daf7a;
module.exports["isPageViewRoute"] = $661369be983dfb69$export$1ae14b4842b49ade;
module.exports["isInsideIframe"] = $661369be983dfb69$export$bc4e1d0ebda8ad2c;
module.exports["preloadImage"] = $661369be983dfb69$export$d8536155e595e20f;

});

parcelRegister("7oCdN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $1e2E5 = parcelRequire("1e2E5");


var $1xywh = parcelRequire("1xywh");


var $iEYBu = parcelRequire("iEYBu");


var $bHWAG = parcelRequire("bHWAG");

const $3b7fa3742d344605$var$TARGET_SELECTOR = '#AkMainContent';
const $3b7fa3742d344605$var$COVER_ID = 'print-cover-page';
const $3b7fa3742d344605$var$STYLE_DATA_ATTR = 'data-print-cover-style';
function $3b7fa3742d344605$var$ensurePrintStyles() {
    if (typeof document === 'undefined') return;
    if (document.head.querySelector(`style[${$3b7fa3742d344605$var$STYLE_DATA_ATTR}="true"]`)) return;
    const style = document.createElement('style');
    style.setAttribute($3b7fa3742d344605$var$STYLE_DATA_ATTR, 'true');
    style.textContent = `
				/* Hidden on screen; visible when printing */
				#${$3b7fa3742d344605$var$COVER_ID} { display: none; }

				@media print {
				#${$3b7fa3742d344605$var$COVER_ID} {
					display: block !important;
					break-after: page;        /* modern */
					page-break-after: always; /* legacy */
				}
					
				/* Hide only the layout header when printing */
					header[data-layout-slot="true"] {
						display: none !important;
						visibility: hidden !important;
				}
			}`;
    document.head.appendChild(style);
}
function $3b7fa3742d344605$export$4b3266eb0ec6c746(enabled, intl) {
    const rootRef = (0, $42omo.useRef)(null);
    const hostRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') return;
        $3b7fa3742d344605$var$ensurePrintStyles();
        (0, $bHWAG.preloadImage)((0, (/*@__PURE__*/$parcel$interopDefault($1xywh))));
        const before = ()=>{
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            // find the main content container where we'll inject the cover page
            const target = document.querySelector($3b7fa3742d344605$var$TARGET_SELECTOR);
            // exit early if target element doesn't exist
            if (!target) return;
            // check if the cover page host container already exists in the DOM
            let host = document.getElementById($3b7fa3742d344605$var$COVER_ID);
            if (!host) {
                // Create a new host container if it doesn't exist
                host = document.createElement('div');
                host.id = $3b7fa3742d344605$var$COVER_ID;
            }
            /* insert the host as the first child of target so the cover page prints before content
      only insert if it's not already the first child (prevents duplicate insertions) */ if (target.firstChild !== host) target.insertBefore(host, target.firstChild);
            /* create a React root for the host container if it doesn't exist yet
      This allows us to render React components into this DOM node */ if (!rootRef.current) rootRef.current = (0, $2FNjD.createRoot)(host);
            // render the cover page component with internationalization support
            // wrap it in IntlProvider to provide translations from the parent app
            rootRef.current.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
                locale: intl.locale,
                messages: intl.messages,
                defaultLocale: "en"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iEYBu.CoverPageComponent), null)));
            // store reference to the host element for cleanup later
            hostRef.current = host;
        };
        const after = ()=>{
            // clean up the React root to prevent memory leaks
            if (rootRef.current) {
                // unmount the React component tree from the DOM
                rootRef.current.unmount();
                rootRef.current = null;
            }
            // remove the host container from the DOM if it exists and has a parent
            if (hostRef.current?.parentNode) // remove the cover page element from its parent node
            hostRef.current.parentNode.removeChild(hostRef.current);
            // clear the host element reference
            hostRef.current = null;
        };
        window.addEventListener('beforeprint', before);
        window.addEventListener('afterprint', after);
        // safety: some browsers may skip afterprint on cancel
        const onVisibility = ()=>{
            if (document.visibilityState === 'visible') after();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return ()=>{
            window.removeEventListener('beforeprint', before);
            window.removeEventListener('afterprint', after);
            document.removeEventListener('visibilitychange', onVisibility);
            after();
        };
    }, [
        enabled,
        intl
    ]);
}
module.exports["usePrintCoverInjector"] = $3b7fa3742d344605$export$4b3266eb0ec6c746;

});

parcelRegister("1xywh", function(module, exports) {
module.exports = new URL("PDFexport.298a755d.png", import.meta.url).toString();

});

parcelRegister("iEYBu", function(module, exports) {
/* PrintCoverComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1xywh = parcelRequire("1xywh");

const $182813799a742845$export$d7f7fd46ad566704 = (0, $cgtv4.defineMessages)({
    printCoverHeader: {
        id: "pdf-print-utils.print-cover.header",
        defaultMessage: "Your page may not be formatted properly if you print now."
    },
    printCoverSubheader: {
        id: "pdf-print-utils.print-cover.subheader",
        defaultMessage: "To maintain your page's format, export it as a PDF before printing - either with \u2318P/Ctrl+P or by following these steps:"
    },
    printStep1: {
        id: "pdf-print-utils.print-cover.step1",
        defaultMessage: "Close this window"
    },
    printStep2: {
        id: "pdf-print-utils.print-cover.step2",
        defaultMessage: "Select More actions (\u2022\u2022\u2022) in the upper right."
    },
    printStep3: {
        id: "pdf-print-utils.print-cover.step3",
        defaultMessage: "Select Export > Export as PDF."
    },
    printStep4: {
        id: "pdf-print-utils.print-cover.step4",
        defaultMessage: "Download and open the PDF to print."
    },
    imageAlt: {
        id: "pdf-print-utils.print-cover.image-alt",
        defaultMessage: "PDF export instructions diagram"
    }
});
const $182813799a742845$var$coverWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    padding: 'space.500',
    boxSizing: 'border-box',
    marginTop: 'space.100'
});
const $182813799a742845$var$headingStyles = null;
const $182813799a742845$var$subHeadingStyles = null;
const $182813799a742845$var$imgContStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.100',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay'
});
const $182813799a742845$var$imageStyles = null;
const $182813799a742845$var$listStyles = null;
const $182813799a742845$var$listItemStyles = null;
const $182813799a742845$export$a01b7b078c69ca5a = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$coverWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wybldb6 _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printCoverHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wyb1ou6 _19pk1ejb _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printCoverSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$imgContStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        alt: intl.formatMessage($182813799a742845$export$d7f7fd46ad566704.imageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1xywh))),
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1ule"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        className: (0, $gMc0m.default)([
            "_19pku2gc _bozgxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $182813799a742845$export$d7f7fd46ad566704.printStep4))));
};
module.exports["CoverPageComponent"] = $182813799a742845$export$a01b7b078c69ca5a;

});

parcelRegister("gnAk8", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5dnlf = parcelRequire("5dnlf");


var $cStGJ = parcelRequire("cStGJ");

const $c8c86397f9eec097$export$6039c17b260b039c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e5xcnr80"
})(({ isFabric: isFabric, isChildrenFGEnabled: isChildrenFGEnabled })=>isFabric && isChildrenFGEnabled && `
    // Prevents layout shifting of child macros when a macro is inserted via LegacyMacroDOMManipulatedByJQuery
    ul.childpages-macro {
      margin-top: 0
    }
  `, ".ak-renderer-document [data-macro-name='toc-zone'] [data-macro-name='code']{display:inline-block;width:calc(100% - 15px);background:var(--ds-surface, #FFFFFF);}.ak-renderer-document [data-macro-name='toc-zone'] [data-macro-name='code']>div{line-height:0;}.ak-renderer-document [data-macro-name='toc-zone'] [data-macro-name='code'] td.code{display:inline-block;width:calc(100% - 15px);padding:0 0 0 15px;background:var(--ds-surface, #FFFFFF);}ul,ol{margin:10px 0 0 0;}li>ul:first-of-type,li>ol:first-of-type{margin-top:0;}", ({ bannerHeight: bannerHeight })=>bannerHeight && `
    h1, h2, h3, h4, h5, h6 {
      scroll-margin-top: ${bannerHeight}px;
    }
    // fix for floating table header
    td > h1, td > h2, td > h3, td > h4, td > h5, td > h6 {
      scroll-margin-top: ${bannerHeight * 2.5}px;
    }
  `, " ", ({ markerRefs: markerRefs, isFabric: isFabric, intl: intl })=>markerRefs && (0, $5dnlf.inlineHighlightStyles)(markerRefs, isFabric, intl), " ", ({ isFabric: isFabric })=>isFabric && `
    .renderer-overrides {
      /**
       * Reduce content shifting after superbatch CSS loads
       * The !important below is necessary (alas!) as editor migration to emotion
       * changed the order of applying
       */
      h1 {
        font-size: 1.714em;
        font-weight: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '600' : '500'};
        line-height: 1.166;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.45833em' : '1.667em'};
      }
      h2 {
        font-size: 1.43em;
        font-weight: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '600' : '500'};
        line-height: 1.2;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.4em' : '1.8em'};
      }
      h3 {
        font-size: 1.142em;
        line-height: 1.5;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.31249em' : '2em'};
      }
      h4 {
        font-size: 1em;
        line-height: 1.428;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.25em' : '1.357em'};
      }
      h5 {
        font-size: 0.857em;
        line-height: 1.333;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.45833em' : '1.667em'};
      }
      h6 {
        line-height: 1.454;
        font-weight: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '600' : '700'};
        font-size: 0.785em;
        margin-top: ${(0, $9wGTI.fg)('platform_editor_typography_ugc') ? '1.59091em' : '1.455em'};
      }
      /**
      * React Renderer dynamically adds a heading-anchor-wrapper to hide the header link icon
      * This wrapper doesn't load via SSR so we have to manually hide the icon
      */
      h1, h2, h3, h4, h5, h6 {
        > button {
          position: absolute;
          right: auto;

          > span[role="img"] {
            opacity: 0;
          }
        }
      }
      ${(0, $6mKj3.expValEquals)('platform_editor_blockquote_overflow', 'isEnabled', true) ? '' : `blockquote {
            border-left: ${"var(--ds-border-width, 1px)"} solid #ccc;
            margin-left: 19px;
            padding: 10px 20px;
          }`}
      // CEMS-2974 TOC macro with decimal number was having first number cut off due to padding
      .toc-macro[data-cssliststyle="decimal"] > ul {
        padding-left: ${"var(--ds-space-500, 40px)"}};
      }
      // CONFCLOUD-73546 / CEMS-3103 overrides to fix margin-top: 0 on centered headings
      .fabric-editor-block-mark[data-align] > h1, .fabric-editor-indentation-mark > h1, .fabric-editor-indentation-mark.fabric-editor-block-mark:first-of-type > h1:first-of-type {
          margin-top: ${"var(--ds-space-500, 40px)"};
        }
        .fabric-editor-block-mark[data-align] > h2, .fabric-editor-indentation-mark > h2 {
          margin-top: 28px;
        }
        .fabric-editor-block-mark[data-align] > h3, .fabric-editor-indentation-mark > h3 {
          margin-top: ${"var(--ds-space-300, 24px)"};
        }
        .fabric-editor-block-mark[data-align] > h4, .fabric-editor-indentation-mark > h4 {
          margin-top: ${"var(--ds-space-150, 12px)"};
        }
         .fabric-editor-block-mark[data-align] > h5, .fabric-editor-indentation-mark > h5 {
          margin-top: ${"var(--ds-space-250, 20px)"};
         }
        .fabric-editor-block-mark[data-align] > h6, .fabric-editor-indentation-mark > h6 {
          margin-top: ${"var(--ds-space-200, 16px)"};
        }
        .ak-ul li > ul {
          margin-top: ${"var(--ds-space-050, 4px)"};
        }
        ul.childpages-macro li {
          &::before {
            line-height: 24px;
          }
        }
    }
  `, ";", ({ isFabric: isFabric })=>!isFabric && `// css styling for Tiny pages

    /**
    * Sortable Tables
    */

   /* BEGIN: override default css-reset from atlaskit */
   .wiki-content table.confluenceTable {
     width: initial;
   }

   .wiki-content table.confluenceTable td:first-of-type,
   th:first-of-type {
     padding-left: 10px !important;
   }

   .wiki-content table.confluenceTable td:last-child,
   th:last-child {
     padding-right: 10px !important;
   }
   /* END: override default css-reset from atlaskit */

   .wiki-content
    table.confluenceTable
    th.confluenceTh
    > .tablesorter-header-inner
    > p {
    font-weight: ${"var(--ds-font-weight-bold, 653)"};
    margin-bottom: 0;
  }

  .wiki-content
    table.confluenceTable
    td.confluenceTd
    > .tablesorter-header-inner
    > :first-of-type,
  .wiki-content
    table.confluenceTable
    th.confluenceTh
    > .tablesorter-header-inner
    > :first-of-type {
    /* CONF-26496 - Should be zero, but this causes the border to be rendered 2px high in some cases in Chrome */
    margin-top: 0.2px;
  }

  .wiki-content table.tablesorter > thead > tr > th {
    background: var(--ds-background-accent-gray-subtlest, #f0f0f0) center right no-repeat;
    padding-right: 15px;
    cursor: pointer;
  }

  .wiki-content table.tablesorter > thead > tr:hover > th {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKBAMAAACQ3rmwAAAAA3NCSVQICAjb4U/gAAAAD1BMVEX///9QYXNQYXNQYXNQYXNa92HSAAAABXRSTlMAESIzRJTdRHwAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAedEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzUuMasfSOsAAAB5dEVYdG5hbWVTZXRzAHsgZGVzY3JpcHRpb246IkRvd25sb2FkIHRoZSBcIk5hbWVkIFNlbGVjdGlvbiBTZXRzXCIgcGFuZWwgZnJvbSBodHRwOi8vZmlyZXdvcmtzLmFiZWFsbC5jb20iLCBpZDotMSwgc2V0czp7ICB9IH1YpK+bAAAAFXRFWHRDcmVhdGlvbiBUaW1lADI5LzMvMTJcby01AAAAJUlEQVQImWNgUGIAAUYXARDF4uIIokxcnBkwAFRQxMUBSQNEOwB/EQOGsCyAPwAAAABJRU5ErkJggg==);
  }

  .wiki-content table.tablesorter > thead > tr > th.tablesorter-headerSortDown {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKBAMAAACQ3rmwAAAAA3NCSVQICAjb4U/gAAAAHlBMVEX///9QYXNQYXNQYXNQYXNQYXNQYXNQYXNQYXNQYXOMgbQDAAAACnRSTlMAESIzRGZ3maq7ZAl7FAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB50RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNS4xqx9I6wAAAHl0RVh0bmFtZVNldHMAeyBkZXNjcmlwdGlvbjoiRG93bmxvYWQgdGhlIFwiTmFtZWQgU2VsZWN0aW9uIFNldHNcIiBwYW5lbCBmcm9tIGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSIsIGlkOi0xLCBzZXRzOnsgIH0gfVikr5sAAAAVdEVYdENyZWF0aW9uIFRpbWUAMjkvMy8xMlxvLTUAAAAdSURBVAiZY2AIYwAB5pkOIEpiZhOIqpw5nYEUAADZjgQPuazuBAAAAABJRU5ErkJggg==);
  }

  .wiki-content table.tablesorter > thead > tr > th.tablesorter-headerSortUp {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKBAMAAACQ3rmwAAAAA3NCSVQICAjb4U/gAAAAHlBMVEX///9QYXNQYXNQYXNQYXNQYXNQYXNQYXNQYXNQYXOMgbQDAAAACnRSTlMAESIzRGZ3maq7ZAl7FAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAB50RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNS4xqx9I6wAAAHl0RVh0bmFtZVNldHMAeyBkZXNjcmlwdGlvbjoiRG93bmxvYWQgdGhlIFwiTmFtZWQgU2VsZWN0aW9uIFNldHNcIiBwYW5lbCBmcm9tIGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSIsIGlkOi0xLCBzZXRzOnsgIH0gfVikr5sAAAAVdEVYdENyZWF0aW9uIFRpbWUAMjkvMy8xMlxvLTUAAAAdSURBVAiZY2AgGlTOnA6iNGY2giiWmQZg0VQQAQBOSAQedpgI7AAAAABJRU5ErkJggg==);
  }

  /**
    * image positions
    */
  .wiki-content .image-center-wrapper {
    display: table;
    margin-left: auto;
    margin-right: auto;
  }

  .wiki-content .image-right-wrapper {
    display: table;
    margin: 0 0 10px auto;
  }

  .wiki-content .image-left-wrapper {
    display: table;
    margin: 0 auto 10px 0;
  }

  .wiki-content .confluence-embedded-file-wrapper .confluence-embedded-image {
    display: block;
    margin-left: ${"var(--ds-space-025, 2px)"};
    margin-right: ${"var(--ds-space-025, 2px)"};;
    max-width: ${(0, $9wGTI.fg)('confluence_legacy_content_no_max_image_width') ? 'none' : 'calc(100% - 4px)'};
  }

   /**
    * headers
    */

  .wiki-content h1 {
    font-size: 1.714em;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 1.166;
  }

  .wiki-content h2 {
    font-size: 1.43em;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 1.2;
  }

  .wiki-content h3 {
    font-size: 1.142em;
    font-weight: ${"var(--ds-font-weight-regular, 400)"};
    line-height: 1.5;
  }

  .wiki-content h4 {
    font-size: 1em;
    line-height: 1.428;
    font-weight: ${"var(--ds-font-weight-bold, 653)"};
  }

  .wiki-content h5 {
    font-size: 0.857em;
    line-height: 1.333;
    font-weight: ${"var(--ds-font-weight-bold, 653)"};
  }

  .wiki-content h6 {
    line-height: 1.454;
    font-size: 0.785em;
    font-weight: ${"var(--ds-font-weight-bold, 653)"};
  }

  h1 + h2,
  h2 + h3,
  h3 + h4,
  h4 + h5,
  h5 + h6 {
    margin-top: 10px;
  }

  /**
   * quotes element
   *
   * The same styling is curerntly used for fabric pages. This fixes the issue where quote styling is not applied when a tiny page is SSR-ed. Also fixes the CLS when the page is not SSR-ed.
   */

  .wiki-content blockquote {
    border-left: ${"var(--ds-border-width, 1px)"} solid #ccc;
    color: #707070;
    margin-left: 19px;
    padding: 10px 20px;
  }

  .wiki-content blockquote p {
    margin: 10px 0 0 0;
  }

  .wiki-content blockquote p:first-of-type {
    margin-top: 0;
  }

  // the list item markers start all the way from left and then move to center/right when not SSR-ed
  li[style*='text-align: center'], li[style*='text-align: right'] {
    list-style-position: inside;
  }
  `, ";");
module.exports["StyledRenderer"] = $c8c86397f9eec097$export$6039c17b260b039c;

});

parcelRegister("5dnlf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ // We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("2jMPn");
var $7GrAm = parcelRequire("7GrAm");


var $cgtv4 = parcelRequire("cgtv4");

const $407fdba28f01fe31$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "content-renderer.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "content-renderer.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
/* Yellow highlights*/ const $407fdba28f01fe31$var$highlightStyle = (intl, isFabric)=>(0, $7GrAm.default)`
	cursor: pointer;
	background-color: ${isFabric ? "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" : "var(--ds-background-accent-yellow-subtler, #F5E989)"};
	border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
	&.active-highlight {
		background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
		border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
		box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
	}

	/* Accessibility markers for screen readers: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/mark#accessibility_concerns */
	&::before,
	&::after {
		clip-path: inset(100%);
		clip: rect(1px, 1px, 1px, 1px);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}

	&.first-mark-highlight::before {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerStart)}] ';
	}

	&.last-mark-highlight::after {
		content: ' [${intl.formatMessage($407fdba28f01fe31$export$defe85febe8b728c.contentRendererInlineCommentMarkerEnd)}] ';
	}
`;
const $407fdba28f01fe31$export$ff7bdbeb01ad8e1f = (markerRefs, isFabric, intl)=>{
    const combinedStyles = {
        ...$407fdba28f01fe31$export$b2855f2a39bd93e8(intl) // Include the SPA styles
    };
    // Add SSR-style direct marker ref targeting
    markerRefs.forEach((markerRef)=>{
        const attribute = isFabric ? 'id' : 'ref';
        const selector = isFabric ? `mark[data-${attribute}="${markerRef}"]` : `span[data-${attribute}="${markerRef}"]`;
        combinedStyles[selector] = $407fdba28f01fe31$var$highlightStyle(intl, isFabric);
    });
    return combinedStyles;
};
const $407fdba28f01fe31$export$b2855f2a39bd93e8 = (intl)=>(0, $7GrAm.default)`
	div[mode='stick'] {
		z-index: 1;
		background: ${"var(--ds-background-inverse-subtle, #00000029)"};
	}

	span {
		&.inline-highlight {
			${$407fdba28f01fe31$var$highlightStyle(intl)}
		}

		&.inline-create-comment-selection {
			background-color: ${"var(--ds-background-accent-yellow-subtle, #EED12B)"};
			border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"};
			box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
		}
	}
`;
module.exports["messages"] = $407fdba28f01fe31$export$defe85febe8b728c;
module.exports["inlineHighlightStyles"] = $407fdba28f01fe31$export$ff7bdbeb01ad8e1f;
module.exports["inlineCommentStyles"] = $407fdba28f01fe31$export$b2855f2a39bd93e8;

});

parcelRegister("2jMPn", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("7GrAm")).default);

var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");

parcelRequire("3p0fY");


var $1naEG = parcelRequire("1naEG");


var $dmgN7 = parcelRequire("dmgN7");


var $5ElVn = parcelRequire("5ElVn");


var $17TcT = parcelRequire("17TcT");


var $7GrAm = parcelRequire("7GrAm");

var $1b033b47e5e51d93$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $1naEG.h).call(props, 'css')) // $FlowFixMe
    return (0, $42omo.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $1naEG.E);
    createElementArgArray[1] = (0, $1naEG.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $42omo.createElement).apply(null, createElementArgArray);
};
var $1b033b47e5e51d93$var$warnedAboutCssPropForGlobal = false;
var $1b033b47e5e51d93$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $1naEG.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $42omo.createElement)((0, $1naEG.T).Consumer, null, function(theme) {
        var serialized = (0, $5ElVn.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $5ElVn.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1b033b47e5e51d93$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $17TcT.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $dmgN7.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $42omo.Component));
var $1b033b47e5e51d93$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7GrAm.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $1b033b47e5e51d93$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $1b033b47e5e51d93$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1b033b47e5e51d93$var$Noop = function Noop() {
    return null;
};
var $1b033b47e5e51d93$export$9b9c0f9d9f3552b8 = (0, $1naEG.w)(function(props, context) {
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $1naEG.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $5ElVn.serializeStyles)(args, context.registered);
            (0, $dmgN7.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $1b033b47e5e51d93$var$merge(context.registered, css, $1b033b47e5e51d93$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $42omo.createElement)($1b033b47e5e51d93$var$Noop, null);
        return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), null, possiblyStyleElement, ele);
    });
});

});

parcelRegister("3p0fY", function(module, exports) {

var $17TcT = parcelRequire("17TcT");


var $iJwkl = parcelRequire("iJwkl");

parcelRequire("b2bJs");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $27a3e7d86cf699a4$var$delimiter = '/*|*/';
var $27a3e7d86cf699a4$var$needle = $27a3e7d86cf699a4$var$delimiter + '}';
function $27a3e7d86cf699a4$var$toSheet(block) {
    if (block) $27a3e7d86cf699a4$var$Sheet.current.insert(block + '}');
}
var $27a3e7d86cf699a4$var$Sheet = {
    current: null
};
var $27a3e7d86cf699a4$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $27a3e7d86cf699a4$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $27a3e7d86cf699a4$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $27a3e7d86cf699a4$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $27a3e7d86cf699a4$var$delimiter : '');
            }
        case -2:
            content.split($27a3e7d86cf699a4$var$needle).forEach($27a3e7d86cf699a4$var$toSheet);
    }
};
var $27a3e7d86cf699a4$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iJwkl.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($27a3e7d86cf699a4$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $27a3e7d86cf699a4$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $17TcT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $27a3e7d86cf699a4$export$2e2bcd8739ae039 = $27a3e7d86cf699a4$var$createCache;
module.exports["default"] = $27a3e7d86cf699a4$export$2e2bcd8739ae039;

});

parcelRegister("b2bJs", function(module, exports) {
var $8088fb5b17b7a32a$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $8088fb5b17b7a32a$export$2e2bcd8739ae039 = $8088fb5b17b7a32a$var$weakMemoize;

});

parcelRegister("1naEG", function(module, exports) {
parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $3p0fY = parcelRequire("3p0fY");


var $dmgN7 = parcelRequire("dmgN7");


var $5ElVn = parcelRequire("5ElVn");

var $10003458710057aa$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $10003458710057aa$var$EmotionCacheContext = /*#__PURE__*/ (0, $42omo.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $3p0fY.default)() : null);
var $10003458710057aa$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $42omo.createContext)({});
var $10003458710057aa$export$e7094788287c5e9b = $10003458710057aa$var$EmotionCacheContext.Provider;
var $10003458710057aa$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $42omo.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $10003458710057aa$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $10003458710057aa$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $10003458710057aa$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $10003458710057aa$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($10003458710057aa$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$10003458710057aa$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $10003458710057aa$var$Noop = function Noop() {
    return null;
};
var $10003458710057aa$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$10003458710057aa$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $5ElVn.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $dmgN7.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($10003458710057aa$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $10003458710057aa$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $42omo.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$var$Noop, null);
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $10003458710057aa$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $10003458710057aa$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $42omo.createElement)($10003458710057aa$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $10003458710057aa$var$render(cache, props, theme, ref);
    });
    return $10003458710057aa$var$render(cache, props, null, ref);
});
module.exports["h"] = $10003458710057aa$export$dda1d9f60106f0e9;
module.exports["T"] = $10003458710057aa$export$971d5caa766a69d7;
module.exports["w"] = $10003458710057aa$export$efccba1c4a2ef57b;
module.exports["c"] = $10003458710057aa$export$db3b6bfb95261072;
module.exports["E"] = $10003458710057aa$export$a9c23c6ac3fc3eca;

});

parcelRegister("5ElVn", function(module, exports) {

var $81A5B = parcelRequire("81A5B");


var $fTleW = parcelRequire("fTleW");


var $77umQ = parcelRequire("77umQ");

var $41d1b1e3faa6b423$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $41d1b1e3faa6b423$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $41d1b1e3faa6b423$var$hyphenateRegex = /[A-Z]|^ms/g;
var $41d1b1e3faa6b423$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $41d1b1e3faa6b423$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $41d1b1e3faa6b423$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $41d1b1e3faa6b423$var$processStyleName = (0, $77umQ.default)(function(styleName) {
    return $41d1b1e3faa6b423$var$isCustomProperty(styleName) ? styleName : styleName.replace($41d1b1e3faa6b423$var$hyphenateRegex, '-$&').toLowerCase();
});
var $41d1b1e3faa6b423$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($41d1b1e3faa6b423$var$animationRegex, function(match, p1, p2) {
                $41d1b1e3faa6b423$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $41d1b1e3faa6b423$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fTleW.default)[key] !== 1 && !$41d1b1e3faa6b423$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $41d1b1e3faa6b423$var$contentValuePattern, $41d1b1e3faa6b423$var$contentValues, $41d1b1e3faa6b423$var$oldProcessStyleValue, $41d1b1e3faa6b423$var$msPattern, $41d1b1e3faa6b423$var$hyphenPattern, $41d1b1e3faa6b423$var$hyphenatedCache;
var $41d1b1e3faa6b423$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $41d1b1e3faa6b423$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $41d1b1e3faa6b423$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $41d1b1e3faa6b423$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $41d1b1e3faa6b423$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $41d1b1e3faa6b423$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $41d1b1e3faa6b423$var$cursor;
                var result = interpolation(mergedProps);
                $41d1b1e3faa6b423$var$cursor = previousCursor;
                return $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $41d1b1e3faa6b423$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($41d1b1e3faa6b423$var$isProcessableValue(value)) string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + $41d1b1e3faa6b423$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($41d1b1e3faa6b423$var$isProcessableValue(value[_i])) string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + $41d1b1e3faa6b423$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $41d1b1e3faa6b423$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $41d1b1e3faa6b423$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $41d1b1e3faa6b423$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $41d1b1e3faa6b423$var$cursor;
var $41d1b1e3faa6b423$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $41d1b1e3faa6b423$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $41d1b1e3faa6b423$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $41d1b1e3faa6b423$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $41d1b1e3faa6b423$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $81A5B.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $41d1b1e3faa6b423$var$cursor
    };
};
module.exports["serializeStyles"] = $41d1b1e3faa6b423$export$6321afa313b251b5;

});

parcelRegister("81A5B", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $5d7a694cc4314d6e$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $5d7a694cc4314d6e$export$2e2bcd8739ae039 = $5d7a694cc4314d6e$var$murmur2;
module.exports["default"] = $5d7a694cc4314d6e$export$2e2bcd8739ae039;

});

parcelRegister("fTleW", function(module, exports) {
var $02fc5483b8246141$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $02fc5483b8246141$export$2e2bcd8739ae039 = $02fc5483b8246141$var$unitlessKeys;
module.exports["default"] = $02fc5483b8246141$export$2e2bcd8739ae039;

});

parcelRegister("77umQ", function(module, exports) {
function $52f0be343b1694de$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $52f0be343b1694de$export$2e2bcd8739ae039 = $52f0be343b1694de$var$memoize;
module.exports["default"] = $52f0be343b1694de$export$2e2bcd8739ae039;

});

parcelRegister("7GrAm", function(module, exports) {

var $gaYGO = parcelRequire("gaYGO");

function $5981da884573f5f2$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gaYGO.serializeStyles)(args);
}
var $5981da884573f5f2$export$2e2bcd8739ae039 = $5981da884573f5f2$var$css;
module.exports["default"] = $5981da884573f5f2$export$2e2bcd8739ae039;

});

parcelRegister("gaYGO", function(module, exports) {

var $kCFr8 = parcelRequire("kCFr8");


var $kBt7i = parcelRequire("kBt7i");


var $4SQOF = parcelRequire("4SQOF");

var $bc6ca833ea660b74$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $bc6ca833ea660b74$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $bc6ca833ea660b74$var$hyphenateRegex = /[A-Z]|^ms/g;
var $bc6ca833ea660b74$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $bc6ca833ea660b74$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $bc6ca833ea660b74$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $bc6ca833ea660b74$var$processStyleName = (0, $4SQOF.default)(function(styleName) {
    return $bc6ca833ea660b74$var$isCustomProperty(styleName) ? styleName : styleName.replace($bc6ca833ea660b74$var$hyphenateRegex, '-$&').toLowerCase();
});
var $bc6ca833ea660b74$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($bc6ca833ea660b74$var$animationRegex, function(match, p1, p2) {
                $bc6ca833ea660b74$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $bc6ca833ea660b74$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kBt7i.default)[key] !== 1 && !$bc6ca833ea660b74$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $bc6ca833ea660b74$var$contentValuePattern, $bc6ca833ea660b74$var$contentValues, $bc6ca833ea660b74$var$oldProcessStyleValue, $bc6ca833ea660b74$var$msPattern, $bc6ca833ea660b74$var$hyphenPattern, $bc6ca833ea660b74$var$hyphenatedCache;
var $bc6ca833ea660b74$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $bc6ca833ea660b74$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $bc6ca833ea660b74$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $bc6ca833ea660b74$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $bc6ca833ea660b74$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $bc6ca833ea660b74$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $bc6ca833ea660b74$var$cursor;
                var result = interpolation(mergedProps);
                $bc6ca833ea660b74$var$cursor = previousCursor;
                return $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $bc6ca833ea660b74$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($bc6ca833ea660b74$var$isProcessableValue(value)) string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + $bc6ca833ea660b74$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($bc6ca833ea660b74$var$isProcessableValue(value[_i])) string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + $bc6ca833ea660b74$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $bc6ca833ea660b74$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $bc6ca833ea660b74$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $bc6ca833ea660b74$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $bc6ca833ea660b74$var$cursor;
var $bc6ca833ea660b74$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $bc6ca833ea660b74$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $bc6ca833ea660b74$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $bc6ca833ea660b74$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $bc6ca833ea660b74$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $kCFr8.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $bc6ca833ea660b74$var$cursor
    };
};
module.exports["serializeStyles"] = $bc6ca833ea660b74$export$6321afa313b251b5;

});

parcelRegister("kCFr8", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f0377fb5614f23a4$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $f0377fb5614f23a4$export$2e2bcd8739ae039 = $f0377fb5614f23a4$var$murmur2;
module.exports["default"] = $f0377fb5614f23a4$export$2e2bcd8739ae039;

});

parcelRegister("kBt7i", function(module, exports) {
var $effdd9535a2a84c3$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $effdd9535a2a84c3$export$2e2bcd8739ae039 = $effdd9535a2a84c3$var$unitlessKeys;
module.exports["default"] = $effdd9535a2a84c3$export$2e2bcd8739ae039;

});

parcelRegister("4SQOF", function(module, exports) {
function $38e52cc536218d28$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $38e52cc536218d28$export$2e2bcd8739ae039 = $38e52cc536218d28$var$memoize;
module.exports["default"] = $38e52cc536218d28$export$2e2bcd8739ae039;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        document?.content?.forEach((node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        });
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        // Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        // Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect4ttxp _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect4ttxp _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4ttxp _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect4ttxp _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<fc3f514c1b8fc23b442bac6c90faf10b>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$ed215fd77db898ec(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToScriptTags"] = $372ebd682f0fb003$export$ed215fd77db898ec;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/editor-features/src/utils/getCachedPageTitle.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<fcddcf783b4b8317e3322bb502f8e37b>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $79vw2 = parcelRequire("79vw2");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
const $807e27f9bf9a8610$var$isLoomUrl = (url)=>{
    return url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?")));
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)"));
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>/\/browse\/((?:\w+)-(?:\d+))/i.test(url);
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    nodeDataKey(node) {
        // We can use URL as a key here, because CardClient returns the same data for the same URL
        // regardless of the type of card (inline, block, embed).
        return node.attrs.url;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            return this.cardClient.fetchData(url);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        return [
            'inlineCard',
            'blockCard',
            'embedCard'
        ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomUrl(url) || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $79vw2.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference && (0, $dh538.fg)('platform_sl_3p_unauth_paste_as_block_card_gate')) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') {
                            const isUnauthPasteAsBlockCardEnabled = !(0, $1oCLl.expValEquals)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'control', 'control');
                            if (isUnauthPasteAsBlockCardEnabled) return this.transformer.toSmartlinkAdf(url, 'block');
                        }
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.onResolve = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: headers,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKey = contentType === 'database' ? 'confluence-databases' : 'confluence-whiteboards';
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKey);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("21K7m", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

var $b38ed7ab605aa654$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $b38ed7ab605aa654$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5rDjV)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $b38ed7ab605aa654$export$c1c4b33b4e7b1c70;

});

parcelRegister("eUDtA", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5nBzc = parcelRequire("5nBzc");


var $1DWH0 = parcelRequire("1DWH0");


var $hFf4D = parcelRequire("hFf4D");


var $aLypr = parcelRequire("aLypr");

function $fb06ceb36ba8e92b$var$_defineProperty(e, r, t) {
    return (r = $fb06ceb36ba8e92b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb06ceb36ba8e92b$var$_toPropertyKey(t) {
    var i = $fb06ceb36ba8e92b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb06ceb36ba8e92b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success'
};
const $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE = 'default';
const $fb06ceb36ba8e92b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $fb06ceb36ba8e92b$var$inlineBlockStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $fb06ceb36ba8e92b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $fb06ceb36ba8e92b$var$StatusInternal extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = $fb06ceb36ba8e92b$var$colorToLozengeAppearanceMap[color] || $fb06ceb36ba8e92b$var$DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $42omo.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $gMc0m.default)([
                $fb06ceb36ba8e92b$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            "data-node-type": "status",
            "data-color": color,
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), {
            appearance: appearance,
            maxWidth: $fb06ceb36ba8e92b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "hoverStartTime", 0);
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $fb06ceb36ba8e92b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $aLypr.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$fb06ceb36ba8e92b$var$_defineProperty($fb06ceb36ba8e92b$var$StatusInternal, "displayName", 'StatusInternal');
const $fb06ceb36ba8e92b$export$96e9906d6d93a972 = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $hFf4D.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($fb06ceb36ba8e92b$var$StatusInternal);
module.exports["Status"] = $fb06ceb36ba8e92b$export$96e9906d6d93a972;

});

parcelRegister("hFf4D", function(module, exports) {
const $d7337cb21e4187c0$export$d821aa4c8afb384e = 'fabric-elements';
const $d7337cb21e4187c0$var$packageName = "platform-pkg";
const $d7337cb21e4187c0$var$packageVersion = "0.0.0-use.local";
const $d7337cb21e4187c0$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $d7337cb21e4187c0$var$packageName;
        statusPayload.attributes.packageVersion = $d7337cb21e4187c0$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($d7337cb21e4187c0$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $d7337cb21e4187c0$export$aa98853957f9f5aa;

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $49cfd043cf935c3d$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$49cfd043cf935c3d$var$getOverrides(overrides).MoreIndicator.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$49cfd043cf935c3d$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6MWy1 = parcelRequire("6MWy1");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $1ztii = parcelRequire("1ztii");

const $5d9c84f5f87b7a1d$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($5d9c84f5f87b7a1d$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["FocusManagerContext"] = $5d9c84f5f87b7a1d$export$f18c1d4fc7326096;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $6MWy1 = parcelRequire("6MWy1");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _1q8w1np6 _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _t9ec1np6 _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $dh538 = parcelRequire("dh538");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $8C5kA = parcelRequire("8C5kA");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("jz7J7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc6573ead9ef7c8$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse Agents"
    }
});

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $f220a889fcad0dca$export$f636b5b56f1d624a;
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("hzZxz", function(module, exports) {

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $diswb.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$OLD_REPLAY_WINDOW_HOURS = 24;
const $e5d99b79ae0d2558$var$NEW_REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const replayWindowHours = (0, $9wGTI.fg)('confluence_frontend_comments_extend_replay_window') ? $e5d99b79ae0d2558$var$NEW_REPLAY_WINDOW_HOURS : $e5d99b79ae0d2558$var$OLD_REPLAY_WINDOW_HOURS;
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - replayWindowHours * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("cLo2u", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

const $91bacb73ef37142f$export$12ed3d1363567203 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useSpaceKey(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
} : function useSpaceKey(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
};
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("jln20", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
} : ()=>(0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $42omo.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    const contextValue = (0, $42omo.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = (props)=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $9ee4137247832c84$var$getExperimentValue = (0, $c6GJD.default).getExperimentValue;
const $9ee4137247832c84$var$EXPERIMENT = 'platform_global_preview_panels_default_width';
const $9ee4137247832c84$export$c82b124a4ae0f274 = 'isEnabled';
const $9ee4137247832c84$export$56368731b0f4a091 = 'minimumWidth';
const $9ee4137247832c84$export$97a0618f336c05be = 'ratio';
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$FALLBACK_RATIO = 0.25;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    if (!$9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$c82b124a4ae0f274, false)) return $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    const windowWidth = window.innerWidth;
    const minWidthForWiderPanel = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$56368731b0f4a091, Number.MAX_VALUE);
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth > minWidthForWiderPanel) {
        const panelWidthToWindowWidthRatio = $9ee4137247832c84$var$getExperimentValue($9ee4137247832c84$var$EXPERIMENT, $9ee4137247832c84$export$97a0618f336c05be, $9ee4137247832c84$var$FALLBACK_RATIO);
        const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        commentsMarkedAsRead: {
            inline: {},
            general: {}
        },
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setCommentsInThreadToBeMarkedAsRead: ({ threadKey: threadKey, commentIds: commentIds, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsMarkedAsRead: commentsMarkedAsRead } = getState();
            if (threadKey && commentIds) {
                // Add the new comment IDs to the existing set for the specific parent
                const updatedCommentIds = {
                    ...commentsMarkedAsRead
                };
                const existingIdsSet = updatedCommentIds[commentType][threadKey] || new Set();
                commentIds.forEach((id)=>existingIdsSet.add(id));
                // Update the map with the new set of IDs
                updatedCommentIds[commentType][threadKey] = existingIdsSet;
                setState({
                    commentsMarkedAsRead: updatedCommentIds
                });
            }
        },
    setCommentsToBeMarkedAsRead: (commentsMarkedAsRead)=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: commentsMarkedAsRead
            });
        },
    clearCommentsMarkedAsRead: ()=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: {
                    inline: {},
                    general: {}
                }
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $9buj5 = parcelRequire("9buj5");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("gjOim"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("cbcL4"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("dL9RT"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("8bEOr"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { handleMarkCommentsAsRead: handleMarkCommentsAsRead } = (0, $9buj5.useUnreadPanelComments)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [shouldClearUnreads, setShouldClearUnreads] = (0, $42omo.useState)(false);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    // Required to invoke handleMarkCommentsAsRead and if any commentsMarkedAsRead
    // then we will call the MarkCommentsReadMutation Mutation
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (shouldClearUnreads) handleMarkCommentsAsRead();
        return ()=>{
            setShouldClearUnreads(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldClearUnreads,
        setShouldClearUnreads
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        setShouldClearUnreads(true);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        setShouldClearUnreads,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = (0, $9wGTI.fg)('confluence_comment_footercomments_editpage') ? pageMode !== (0, $cD1qu.PageMode).EDIT : true;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon : undefined,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenu : undefined
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    if (isTemplateBrowserEnabled) allowedEllipsisButtons.push("template-browser");
    const isSpacePickerDisabled = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'] ?? false;
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;

});

parcelRegister("9buj5", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $3mVfX = parcelRequire("3mVfX");


var $9wGTI = parcelRequire("9wGTI");

const $02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation = (0, $eSUdr.default)`mutation useUnreadPanelCommentsMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $02faaefae22f6672$export$b2c07ec1a20446f7 = ()=>{
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { clearCommentsMarkedAsRead: clearCommentsMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadStatus: updateUnreadStatus } = (0, $8i27m.useCommentsDataActions)();
    const [{ readCommentsListState: readCommentsListState, unreadCommentsListState: unreadCommentsListState }, { updateReadCommentsListState: updateReadCommentsListState, updateUnreadCommentsListState: updateUnreadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    // TODO: handle error
    const [markInlineCommentsRead] = (0, $diswb.useMutation)($02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation);
    // call the mutation to mark the list of comment IDs as read
    const handleMarkCommentsAsRead = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (Object.keys(commentsMarkedAsRead.inline).length > 0 || Object.keys(commentsMarkedAsRead.general).length > 0) {
            const inlineCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.inline).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const generalCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.general).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const commentIdsToMarkAsRead = [
                ...inlineCommentIdsToMarkAsRead,
                ...generalCommentIdsToMarkAsRead
            ];
            if (!commentIdsToMarkAsRead?.length) return;
            markInlineCommentsRead({
                variables: {
                    commentIds: commentIdsToMarkAsRead
                }
            });
            // update our data store to indicate these comments are now read
            updateUnreadStatus(commentsMarkedAsRead, (0, $8i27m.UnreadAction).READ);
            // reset our list of comments to mark as read
            clearCommentsMarkedAsRead();
            // update existing unread and read data stores
            const commentIdsToMarkAsReadSet = new Set(commentIdsToMarkAsRead);
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>!commentIdsToMarkAsReadSet.has(unreadComment.id));
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            const newReadCommentsListState = new Set([
                ...readCommentsListState,
                ...commentIdsToMarkAsRead
            ]);
            updateReadCommentsListState(()=>newReadCommentsListState);
        }
    }, [
        markInlineCommentsRead,
        clearCommentsMarkedAsRead,
        commentsMarkedAsRead,
        updateUnreadStatus,
        readCommentsListState,
        unreadCommentsListState,
        updateReadCommentsListState,
        updateUnreadCommentsListState
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        const handleBeforeUnload = ()=>{
            // Mark comments as read if the user closes the window
            handleMarkCommentsAsRead();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            // Mark comments as read when the component unmounts
            handleMarkCommentsAsRead();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $42omo.useMemo)(()=>({
            handleMarkCommentsAsRead: handleMarkCommentsAsRead
        }), [
        handleMarkCommentsAsRead
    ]);
};
module.exports["useUnreadPanelComments"] = $02faaefae22f6672$export$b2c07ec1a20446f7;

});

parcelRegister("gjOim", function(module, exports) {

let $be156f3d961da240$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be156f3d961da240$var$load("3ySTn"),
    $be156f3d961da240$var$load("c2rHL"),
    $be156f3d961da240$var$load("kAAjo"),
    $be156f3d961da240$var$load("fbRdC"),
    $be156f3d961da240$var$load("kHOMt"),
    $be156f3d961da240$var$load("7Ewqa"),
    $be156f3d961da240$var$load("607sQ"),
    $be156f3d961da240$var$load("goLL0"),
    $be156f3d961da240$var$load("e4Jl9"),
    $be156f3d961da240$var$load("22RDk"),
    $be156f3d961da240$var$load("ev7SX"),
    $be156f3d961da240$var$load("gLGsg"),
    $be156f3d961da240$var$load("5zqeF"),
    $be156f3d961da240$var$load("i68GZ"),
    $be156f3d961da240$var$load("8VT23"),
    $be156f3d961da240$var$load("fJtJG"),
    $be156f3d961da240$var$load("lkOIY"),
    $be156f3d961da240$var$load("clQc9"),
    $be156f3d961da240$var$load("8PPsf"),
    $be156f3d961da240$var$load("8tLTz"),
    $be156f3d961da240$var$load("jbxHq"),
    $be156f3d961da240$var$load("8YSo7"),
    $be156f3d961da240$var$load("k8XPW"),
    $be156f3d961da240$var$load("fWCRm"),
    $be156f3d961da240$var$load("9ijrN"),
    $be156f3d961da240$var$load("Wowvf"),
    $be156f3d961da240$var$load("cyGuT"),
    $be156f3d961da240$var$load("kvhKJ"),
    $be156f3d961da240$var$load("k5VqV"),
    $be156f3d961da240$var$load("8m8aj"),
    $be156f3d961da240$var$load("lT67w"),
    $be156f3d961da240$var$load("fZt2F"),
    $be156f3d961da240$var$load("7u4WP"),
    $be156f3d961da240$var$load("8lj0L"),
    $be156f3d961da240$var$load("lY1AS"),
    $be156f3d961da240$var$load("d6s42"),
    $be156f3d961da240$var$load("gZGoR"),
    $be156f3d961da240$var$load("iqKwT"),
    $be156f3d961da240$var$load("efnul"),
    $be156f3d961da240$var$load("9IeAj"),
    $be156f3d961da240$var$load("18EHe"),
    $be156f3d961da240$var$load("kT5Gk"),
    $be156f3d961da240$var$load("kUbUu"),
    $be156f3d961da240$var$load("1dcav"),
    $be156f3d961da240$var$load("8ublV"),
    $be156f3d961da240$var$load("iZ4sC"),
    $be156f3d961da240$var$load("4yA1q"),
    $be156f3d961da240$var$load("5vIUN"),
    $be156f3d961da240$var$load("6wr18"),
    $be156f3d961da240$var$load("ffEVr"),
    $be156f3d961da240$var$load("iZU4p"),
    $be156f3d961da240$var$load("flGQy"),
    $be156f3d961da240$var$load("5PUzW"),
    $be156f3d961da240$var$load("jwWp5"),
    $be156f3d961da240$var$load("7EorR"),
    $be156f3d961da240$var$load("awqCy"),
    $be156f3d961da240$var$load("hhss7"),
    $be156f3d961da240$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("cbcL4", function(module, exports) {

let $8de0689b1a09973f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8de0689b1a09973f$var$load("3ySTn"),
    $8de0689b1a09973f$var$load("c2rHL"),
    $8de0689b1a09973f$var$load("kAAjo"),
    $8de0689b1a09973f$var$load("fbRdC"),
    $8de0689b1a09973f$var$load("kHOMt"),
    $8de0689b1a09973f$var$load("7Ewqa"),
    $8de0689b1a09973f$var$load("607sQ"),
    $8de0689b1a09973f$var$load("goLL0"),
    $8de0689b1a09973f$var$load("e4Jl9"),
    $8de0689b1a09973f$var$load("22RDk"),
    $8de0689b1a09973f$var$load("ev7SX"),
    $8de0689b1a09973f$var$load("gLGsg"),
    $8de0689b1a09973f$var$load("5zqeF"),
    $8de0689b1a09973f$var$load("i68GZ"),
    $8de0689b1a09973f$var$load("8VT23"),
    $8de0689b1a09973f$var$load("fJtJG"),
    $8de0689b1a09973f$var$load("lkOIY"),
    $8de0689b1a09973f$var$load("clQc9"),
    $8de0689b1a09973f$var$load("8PPsf"),
    $8de0689b1a09973f$var$load("8tLTz"),
    $8de0689b1a09973f$var$load("jbxHq"),
    $8de0689b1a09973f$var$load("8YSo7"),
    $8de0689b1a09973f$var$load("k8XPW"),
    $8de0689b1a09973f$var$load("fWCRm"),
    $8de0689b1a09973f$var$load("9ijrN"),
    $8de0689b1a09973f$var$load("Wowvf"),
    $8de0689b1a09973f$var$load("cyGuT"),
    $8de0689b1a09973f$var$load("kvhKJ"),
    $8de0689b1a09973f$var$load("k5VqV"),
    $8de0689b1a09973f$var$load("8m8aj"),
    $8de0689b1a09973f$var$load("lT67w"),
    $8de0689b1a09973f$var$load("fZt2F"),
    $8de0689b1a09973f$var$load("7u4WP"),
    $8de0689b1a09973f$var$load("8lj0L"),
    $8de0689b1a09973f$var$load("lY1AS"),
    $8de0689b1a09973f$var$load("d6s42"),
    $8de0689b1a09973f$var$load("gZGoR"),
    $8de0689b1a09973f$var$load("iqKwT"),
    $8de0689b1a09973f$var$load("efnul"),
    $8de0689b1a09973f$var$load("9IeAj"),
    $8de0689b1a09973f$var$load("18EHe"),
    $8de0689b1a09973f$var$load("kT5Gk"),
    $8de0689b1a09973f$var$load("kUbUu"),
    $8de0689b1a09973f$var$load("1dcav"),
    $8de0689b1a09973f$var$load("8ublV"),
    $8de0689b1a09973f$var$load("iZ4sC"),
    $8de0689b1a09973f$var$load("4yA1q"),
    $8de0689b1a09973f$var$load("5vIUN"),
    $8de0689b1a09973f$var$load("6wr18"),
    $8de0689b1a09973f$var$load("ffEVr"),
    $8de0689b1a09973f$var$load("iZU4p"),
    $8de0689b1a09973f$var$load("flGQy"),
    $8de0689b1a09973f$var$load("5PUzW"),
    $8de0689b1a09973f$var$load("jwWp5"),
    $8de0689b1a09973f$var$load("7EorR"),
    $8de0689b1a09973f$var$load("awqCy"),
    $8de0689b1a09973f$var$load("hhss7"),
    $8de0689b1a09973f$var$load("bZz7X")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("dL9RT", function(module, exports) {

let $a04751ca645cd5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a04751ca645cd5bf$var$load("3ySTn"),
    $a04751ca645cd5bf$var$load("c2rHL"),
    $a04751ca645cd5bf$var$load("kAAjo"),
    $a04751ca645cd5bf$var$load("fbRdC"),
    $a04751ca645cd5bf$var$load("kHOMt"),
    $a04751ca645cd5bf$var$load("7Ewqa"),
    $a04751ca645cd5bf$var$load("607sQ"),
    $a04751ca645cd5bf$var$load("goLL0"),
    $a04751ca645cd5bf$var$load("e4Jl9"),
    $a04751ca645cd5bf$var$load("22RDk"),
    $a04751ca645cd5bf$var$load("ev7SX"),
    $a04751ca645cd5bf$var$load("gLGsg"),
    $a04751ca645cd5bf$var$load("5zqeF"),
    $a04751ca645cd5bf$var$load("i68GZ"),
    $a04751ca645cd5bf$var$load("8VT23"),
    $a04751ca645cd5bf$var$load("fJtJG"),
    $a04751ca645cd5bf$var$load("lkOIY"),
    $a04751ca645cd5bf$var$load("clQc9"),
    $a04751ca645cd5bf$var$load("8PPsf"),
    $a04751ca645cd5bf$var$load("8tLTz"),
    $a04751ca645cd5bf$var$load("jbxHq"),
    $a04751ca645cd5bf$var$load("8YSo7"),
    $a04751ca645cd5bf$var$load("k8XPW"),
    $a04751ca645cd5bf$var$load("fWCRm"),
    $a04751ca645cd5bf$var$load("9ijrN"),
    $a04751ca645cd5bf$var$load("Wowvf"),
    $a04751ca645cd5bf$var$load("cyGuT"),
    $a04751ca645cd5bf$var$load("kvhKJ"),
    $a04751ca645cd5bf$var$load("k5VqV"),
    $a04751ca645cd5bf$var$load("8m8aj"),
    $a04751ca645cd5bf$var$load("lT67w"),
    $a04751ca645cd5bf$var$load("fZt2F"),
    $a04751ca645cd5bf$var$load("7u4WP"),
    $a04751ca645cd5bf$var$load("8lj0L"),
    $a04751ca645cd5bf$var$load("lY1AS"),
    $a04751ca645cd5bf$var$load("d6s42"),
    $a04751ca645cd5bf$var$load("gZGoR"),
    $a04751ca645cd5bf$var$load("iqKwT"),
    $a04751ca645cd5bf$var$load("efnul"),
    $a04751ca645cd5bf$var$load("9IeAj"),
    $a04751ca645cd5bf$var$load("18EHe"),
    $a04751ca645cd5bf$var$load("kT5Gk"),
    $a04751ca645cd5bf$var$load("kUbUu"),
    $a04751ca645cd5bf$var$load("1dcav"),
    $a04751ca645cd5bf$var$load("8ublV"),
    $a04751ca645cd5bf$var$load("iZ4sC"),
    $a04751ca645cd5bf$var$load("4yA1q"),
    $a04751ca645cd5bf$var$load("5vIUN"),
    $a04751ca645cd5bf$var$load("6wr18"),
    $a04751ca645cd5bf$var$load("ffEVr"),
    $a04751ca645cd5bf$var$load("iZU4p"),
    $a04751ca645cd5bf$var$load("flGQy"),
    $a04751ca645cd5bf$var$load("5PUzW"),
    $a04751ca645cd5bf$var$load("jwWp5"),
    $a04751ca645cd5bf$var$load("7EorR"),
    $a04751ca645cd5bf$var$load("awqCy"),
    $a04751ca645cd5bf$var$load("hhss7"),
    $a04751ca645cd5bf$var$load("bZz7X")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("8bEOr", function(module, exports) {

let $5f5f025bbd6db281$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f5f025bbd6db281$var$load("3ySTn"),
    $5f5f025bbd6db281$var$load("c2rHL"),
    $5f5f025bbd6db281$var$load("kAAjo"),
    $5f5f025bbd6db281$var$load("fbRdC"),
    $5f5f025bbd6db281$var$load("kHOMt"),
    $5f5f025bbd6db281$var$load("7Ewqa"),
    $5f5f025bbd6db281$var$load("607sQ"),
    $5f5f025bbd6db281$var$load("goLL0"),
    $5f5f025bbd6db281$var$load("e4Jl9"),
    $5f5f025bbd6db281$var$load("22RDk"),
    $5f5f025bbd6db281$var$load("ev7SX"),
    $5f5f025bbd6db281$var$load("gLGsg"),
    $5f5f025bbd6db281$var$load("5zqeF"),
    $5f5f025bbd6db281$var$load("i68GZ"),
    $5f5f025bbd6db281$var$load("8VT23"),
    $5f5f025bbd6db281$var$load("fJtJG"),
    $5f5f025bbd6db281$var$load("lkOIY"),
    $5f5f025bbd6db281$var$load("clQc9"),
    $5f5f025bbd6db281$var$load("8PPsf"),
    $5f5f025bbd6db281$var$load("8tLTz"),
    $5f5f025bbd6db281$var$load("jbxHq"),
    $5f5f025bbd6db281$var$load("8YSo7"),
    $5f5f025bbd6db281$var$load("k8XPW"),
    $5f5f025bbd6db281$var$load("fWCRm"),
    $5f5f025bbd6db281$var$load("9ijrN"),
    $5f5f025bbd6db281$var$load("Wowvf"),
    $5f5f025bbd6db281$var$load("cyGuT"),
    $5f5f025bbd6db281$var$load("kvhKJ"),
    $5f5f025bbd6db281$var$load("k5VqV"),
    $5f5f025bbd6db281$var$load("8m8aj"),
    $5f5f025bbd6db281$var$load("lT67w"),
    $5f5f025bbd6db281$var$load("fZt2F"),
    $5f5f025bbd6db281$var$load("7u4WP"),
    $5f5f025bbd6db281$var$load("8lj0L"),
    $5f5f025bbd6db281$var$load("lY1AS"),
    $5f5f025bbd6db281$var$load("d6s42"),
    $5f5f025bbd6db281$var$load("gZGoR"),
    $5f5f025bbd6db281$var$load("iqKwT"),
    $5f5f025bbd6db281$var$load("efnul"),
    $5f5f025bbd6db281$var$load("9IeAj"),
    $5f5f025bbd6db281$var$load("18EHe"),
    $5f5f025bbd6db281$var$load("kT5Gk"),
    $5f5f025bbd6db281$var$load("kUbUu"),
    $5f5f025bbd6db281$var$load("1dcav"),
    $5f5f025bbd6db281$var$load("8ublV"),
    $5f5f025bbd6db281$var$load("iZ4sC"),
    $5f5f025bbd6db281$var$load("4yA1q"),
    $5f5f025bbd6db281$var$load("5vIUN"),
    $5f5f025bbd6db281$var$load("6wr18"),
    $5f5f025bbd6db281$var$load("ffEVr"),
    $5f5f025bbd6db281$var$load("iZU4p"),
    $5f5f025bbd6db281$var$load("flGQy"),
    $5f5f025bbd6db281$var$load("5PUzW"),
    $5f5f025bbd6db281$var$load("jwWp5"),
    $5f5f025bbd6db281$var$load("7EorR"),
    $5f5f025bbd6db281$var$load("awqCy"),
    $5f5f025bbd6db281$var$load("hhss7"),
    $5f5f025bbd6db281$var$load("bZz7X")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<b75deca64f0533d7fe2b70cf54f2ff13>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("7B9wr", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");

const $e0dcf0245d0f4db8$export$8ee67841592dfd9f = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    return contentType !== (0, $1ggpj.ContentType).DATABASE && contentType !== (0, $1ggpj.ContentType).WHITEBOARD && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
};
module.exports["useIsNewDanglingCommentExperienceEnabled"] = $e0dcf0245d0f4db8$export$8ee67841592dfd9f;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eSUdr.default)`query useViewedCommentsQuery($contentId:ID!$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId contentType:$contentType){commentIds}}`;
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, and whiteboard support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || contentType === 'whiteboard') return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds,
                        __typename: 'ViewedComments'
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<d7ff2c3ce2ccb5f9937eae905c203b17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<4105699bb3b57f32cd10410da7fded55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   */ onUpdateComment(threadKey) {
        this.onUpdateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("hvl1n"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("hvl1n"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("hvl1n"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("hvl1n", function(module, exports) {

let $cbe5a34c7289747f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cbe5a34c7289747f$var$load("djxpx"),
    $cbe5a34c7289747f$var$load("b5fSJ"),
    $cbe5a34c7289747f$var$load("jwWp5"),
    $cbe5a34c7289747f$var$load("k8XPW"),
    $cbe5a34c7289747f$var$load("fWCRm"),
    $cbe5a34c7289747f$var$load("aeEUI"),
    $cbe5a34c7289747f$var$load("eY3St"),
    $cbe5a34c7289747f$var$load("bkd4T"),
    $cbe5a34c7289747f$var$load("kvhKJ"),
    $cbe5a34c7289747f$var$load("k5VqV"),
    $cbe5a34c7289747f$var$load("kWSPH"),
    $cbe5a34c7289747f$var$load("4yA1q"),
    $cbe5a34c7289747f$var$load("5vIUN"),
    $cbe5a34c7289747f$var$load("2YffH"),
    $cbe5a34c7289747f$var$load("hxZ7B"),
    $cbe5a34c7289747f$var$load("fOF46"),
    $cbe5a34c7289747f$var$load("1eO5Z"),
    $cbe5a34c7289747f$var$load("R7cS6"),
    $cbe5a34c7289747f$var$load("fJtJG"),
    $cbe5a34c7289747f$var$load("aKcjp"),
    $cbe5a34c7289747f$var$load("icsuN"),
    $cbe5a34c7289747f$var$load("fjMho"),
    $cbe5a34c7289747f$var$load("kPclQ"),
    $cbe5a34c7289747f$var$load("9w0Re"),
    $cbe5a34c7289747f$var$load("1wQU1"),
    $cbe5a34c7289747f$var$load("ikQAz"),
    $cbe5a34c7289747f$var$load("lkOIY"),
    $cbe5a34c7289747f$var$load("clQc9"),
    $cbe5a34c7289747f$var$load("8PPsf"),
    $cbe5a34c7289747f$var$load("5RQVa"),
    $cbe5a34c7289747f$var$load("eBY1U"),
    $cbe5a34c7289747f$var$load("dUz9k"),
    $cbe5a34c7289747f$var$load("3s26T"),
    $cbe5a34c7289747f$var$load("9XYQ9"),
    $cbe5a34c7289747f$var$load("1qlDN"),
    $cbe5a34c7289747f$var$load("1yVM6"),
    $cbe5a34c7289747f$var$load("4USmq"),
    $cbe5a34c7289747f$var$load("hrbhL"),
    $cbe5a34c7289747f$var$load("9hfvd"),
    $cbe5a34c7289747f$var$load("34i5i"),
    $cbe5a34c7289747f$var$load("hshEG"),
    $cbe5a34c7289747f$var$load("jTaSF"),
    $cbe5a34c7289747f$var$load("9YBgR"),
    $cbe5a34c7289747f$var$load("7ZIlR"),
    $cbe5a34c7289747f$var$load("8fXIr"),
    $cbe5a34c7289747f$var$load("dVkhd"),
    $cbe5a34c7289747f$var$load("6wr18"),
    $cbe5a34c7289747f$var$load("kjZZD"),
    $cbe5a34c7289747f$var$load("9ZAzg"),
    $cbe5a34c7289747f$var$load("kJSYP"),
    $cbe5a34c7289747f$var$load("3ySTn"),
    $cbe5a34c7289747f$var$load("c2rHL"),
    $cbe5a34c7289747f$var$load("cyGuT"),
    $cbe5a34c7289747f$var$load("hhss7"),
    $cbe5a34c7289747f$var$load("8m8aj"),
    $cbe5a34c7289747f$var$load("lT67w"),
    $cbe5a34c7289747f$var$load("7u4WP"),
    $cbe5a34c7289747f$var$load("Wowvf"),
    $cbe5a34c7289747f$var$load("ffEVr"),
    $cbe5a34c7289747f$var$load("kAAjo"),
    $cbe5a34c7289747f$var$load("fbRdC"),
    $cbe5a34c7289747f$var$load("iqKwT"),
    $cbe5a34c7289747f$var$load("efnul"),
    $cbe5a34c7289747f$var$load("18EHe"),
    $cbe5a34c7289747f$var$load("kT5Gk"),
    $cbe5a34c7289747f$var$load("kUbUu"),
    $cbe5a34c7289747f$var$load("7EorR"),
    $cbe5a34c7289747f$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("ljn7X"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const PLACEHOLDER_SIZE = props.height || 26;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: props.loadingMargin
            },
            className: (0, $gMc0m.default)([
                "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("ljn7X", function(module, exports) {

let $f83d4ff3a7e78ac2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f83d4ff3a7e78ac2$var$load("6wr18"),
    $f83d4ff3a7e78ac2$var$load("kjZZD"),
    $f83d4ff3a7e78ac2$var$load("ffEVr"),
    $f83d4ff3a7e78ac2$var$load("7q8Na"),
    $f83d4ff3a7e78ac2$var$load("8OeKT"),
    $f83d4ff3a7e78ac2$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("fNzRA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width)=>{
                setWidth(width ? `${width}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry)=>{
                setFooterEditorEntry(footerEditorEntry);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("ly0vw", function(module, exports) {

var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $1ZEfa = parcelRequire("1ZEfa");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $1ZEfa.default);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.queryAgg)({
            query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
            variables: {
                ids: ids
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await $ed0e2cb9f5186ade$var$getUserData(ids);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("1ZEfa", function(module, exports) {
/**
 * @generated SignedSource<<59554e5c48b23248e96fbd4f6208bc53>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;
module.exports["default"] = $2c3903aefb77a74c$export$2e2bcd8739ae039;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            else this.isTeam(recommended);
            return this.convertToTeamMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isUser(recommended) {
        return recommended.entityType === 'USER';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isShareableLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.SHAREABLE_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {
/**
 * This is a temporary exception list which is used to determine if the link
 * is pointing to either Jira, a different instance or outside of Atlassian
 * entirely.
 */ const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = window.location.hostname;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        urlObject = url && new URL(url);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $lUZCl = parcelRequire("lUZCl");

const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, invokedPlugins: invokedPlugins, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        let libAttributes = {
            ...attributes,
            aiFeatureName: 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                trackAIResultAction(payload.actionResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'feedback':
                trackAIFeedbackSubmit(payload.feedbackResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("lUZCl", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $iN5LM = parcelRequire("iN5LM");

const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iN5LM.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $ee6ebd3561b1c806$export$d97c97ed77ff09e8;

});

parcelRegister("iN5LM", function(module, exports) {
const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $79e4722581e5fb43$export$e31e24b63b7085fd;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    JIRA: 'jira'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $cOrQJ = parcelRequire("cOrQJ");


var $bHGk9 = parcelRequire("bHGk9");


var $ibFXh = parcelRequire("ibFXh");

var $1GJJf = parcelRequire("1GJJf");

var $aSy6D = parcelRequire("aSy6D");

var $8APLM = parcelRequire("8APLM");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");


var $cu1WV = parcelRequire("cu1WV");


var $aXOz9 = parcelRequire("aXOz9");

const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$export$a8a96573251792b1 = ({ url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const themeState = (0, $cOrQJ.default)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $aXOz9.initializeAnalyticsClient)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $aXOz9.onEditMode)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $aXOz9.constructUrl)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    const runtimeProps = {
        url: formattedUrl,
        showFooter: false,
        hasFooterLogo: false,
        onModeChange: onModeChange,
        parentProduct: parentProduct,
        embeddedConfluenceSource: "confluence-page-preview-panel",
        themeState: themeState
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3ZVni.PreviewPanelHeader), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                onClose: onClose,
                onOpenInNewTab: actions?.onOpenInNewTab,
                url: formattedUrl,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3R2u2.PreviewPanelTitle), {
                        title: formatMessage((0, $cu1WV.messages).pageTitle),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    !!actions && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GJJf.PreviewPanelActionGroup), {
                        children: actions.onExpand && /*#__PURE__*/ (0, $l998X.jsx)((0, $8APLM.PreviewPanelExpand), {
                            onClick: actions.onExpand
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aSy6D.PreviewPanelBody), {
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: 'confluence-page',
                styles: $178f91e075c3dc2a$var$styles.body,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHGk9.EmbeddedConfluence), {
                    ...runtimeProps
                })
            })
        ]
    });
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>/*#__PURE__*/ (0, $l998X.jsx)($178f91e075c3dc2a$export$a8a96573251792b1, {
        url: url,
        parentProduct: parentProduct,
        cloudId: cloudId,
        panelData: panelData
    });
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent;
module.exports["ConfluencePagePreviewPanel"] = $178f91e075c3dc2a$export$a8a96573251792b1;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("bHGk9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");
var $jyd5r = parcelRequire("jyd5r");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $96msn.lazyForPaint)(()=>(parcelRequire("1MqGu")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kudeD.PerformanceMetricsProvider), {
            contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
            sourceComponent: 'EmbeddedConfluence',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4a221c0892a490b0$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($4a221c0892a490b0$var$LazyEmbeddedConfluence, {
                    ...props
                })
            })
        })
    });
module.exports["EmbeddedConfluence"] = $4a221c0892a490b0$export$c4789cfd0b0cd2c4;

});

parcelRegister("1MqGu", function(module, exports) {

let $14bef9128349c0f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14bef9128349c0f3$var$load("jTaSF"),
    $14bef9128349c0f3$var$load("Wowvf"),
    $14bef9128349c0f3$var$load("hhss7"),
    $14bef9128349c0f3$var$load("iqKwT"),
    $14bef9128349c0f3$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("1GJJf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center",
        children: children
    });
};
module.exports["PreviewPanelActionGroup"] = $1fc8fb56653d2345$export$b3bbf50939c515ce;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        children: children
    });
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("8APLM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lOzEN = parcelRequire("lOzEN");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelExpand"] = $91e6116a3cc9352a$export$40b251582cb3e1fe;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("cu1WV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});
module.exports["messages"] = $11543dd8ad4b06d3$export$defe85febe8b728c;

});

parcelRegister("aXOz9", function(module, exports) {

var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kFwgS = parcelRequire("kFwgS");

var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};
module.exports["onEditMode"] = $8f94b4972688fbbf$export$232fd46a0431e57a;
module.exports["initializeAnalyticsClient"] = $8f94b4972688fbbf$export$7d842b959fcdcd03;
module.exports["constructUrl"] = $8f94b4972688fbbf$export$a639a54e55b70225;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const isResponsiveEnabled = (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true);
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.toolbarResponsive, isResponsiveEnabled && $a3c14e992c9fdb13$var$styles.hiddenSelectors, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.toolbarSeparator, (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? undefined : 'toolbar',
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'inline' : undefined,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    if (isResponsiveEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
    return wrappedToolbar;
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_responsive', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        reducedBreakpoints: reducedBreakpoints,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? undefined : 'toolbar',
            "aria-label": label,
            "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar),
        role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? undefined : 'toolbar',
        "aria-label": label,
        "data-toolbar-type": (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? 'primary' : undefined,
        children: children
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRules: "_t3a8glyw _1x5z1ule _6nrqglyw _1fq21ule _1ireglyw _zy2m1ule _hfbeglyw _gw6d1ule _1je21ule _tjgx1ule _jt9u1ule _6c751ule",
    responsiveRulesReduced: "_j094glyw _1mc51ule _77vl1ule _gipeglyw _311r1ule _1h871ule _11u4glyw _v1i61ule _ghxv1ule _19x4glyw _qck01ule _87bn1ule",
    responsiveRulesReducedOverridden: "_e2nbglyw _ol4q1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset, reducedBreakpoints: reducedBreakpoints })=>{
    // Use new preset-based logic when preset is provided and feature gate is enabled
    if (breakpointPreset && (0, $dh538.fg)('platform_editor_toolbar_aifc_responsive_improve')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, reducedBreakpoints ? $bc8e1bf6110fb52a$var$styles.responsiveRulesReduced : $bc8e1bf6110fb52a$var$styles.responsiveRules, reducedBreakpoints && (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) && $bc8e1bf6110fb52a$var$styles.responsiveRulesReducedOverridden),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if ((0, $dh538.fg)('platform_editor_toolbar_aifc_patch_7')) switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
            else switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: (0, $1oCLl.expValEquals)('platform_editor_aifc_remove_duplicate_role', 'isEnabled', true) ? 'toolbar' : undefined,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $d7ZU3 = parcelRequire("d7ZU3");

var $led7c = parcelRequire("led7c");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("aAj6E", function(module, exports) {
const $1f2b71b0315184bd$export$200dcd0a5903c968 = (...content)=>({
        type: 'blockquote',
        content: content
    });
module.exports["blockQuote"] = $1f2b71b0315184bd$export$200dcd0a5903c968;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("bAT9l", function(module, exports) {
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });
module.exports["mention"] = $6b7e17532fed1b16$export$db83999c14438df4;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("aGjYc", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$var$getKey = (type, mode)=>{
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$var$getKey(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    const providerValue = (0, $42omo.useMemo)(()=>({
            refetchContent: refetchContent
        }), [
        refetchContent
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        }), [
        setRefetchContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $676464c7222bdee0$export$68e22604851d391b = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
} : ()=>(0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
const $676464c7222bdee0$export$8ebf7a2378ada555 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
} : ()=>(0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("liGyh", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $eSUdr.default)`query useCommentQueryParamsCommentLocationQuery($commentId:ID$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId contentStatus:$contentStatus){nodes{container{id}location{type}}}}`;
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $diswb.useQuery)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<5436b93d76e4ad3ca1b847dd48c8568a>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/**
 * @generated SignedSource<<5ee01bec8d3f6c744747b059c459e176>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("8SCD6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("bavCP", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");

function $86f32d96feea2a1f$export$67f105fad14d18d({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
}
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("ftXPY", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $eSUdr.default)`query CommentsSectionQuery($offset:String$first:Long$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}reactionsSummary(pageId:$contentId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $eSUdr.default)`query CommentsSectionWithoutReactionsQuery($offset:String$first:Long$contentId:ID!){comments(pageId:$contentId type:FOOTER depth:ALL confluenceCommentFilter:{commentState:UNRESOLVED commentType:FOOTER}first:$first after:$offset){totalCount pageInfo{hasNextPage endCursor}edges{cursor node{id ancestors{id}author{type displayName profilePicture{path}...on KnownUser{accountId permissionType}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}version{friendlyWhen number when by{type displayName ...on KnownUser{accountId}}}}}}content(id:$contentId){nodes{subType id operations{operation targetType}space{id homepageId}type history{createdBy{...on KnownUser{accountId}}}}}user:confluence_atlassianUser(current:true){displayName photos{isPrimary value}id}}`;
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("aUU0C", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $1P1Tu.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $9zUhf.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $9zUhf.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("7Oxky", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $fHAwL = parcelRequire("fHAwL");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $eSUdr.default)`query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const annotationsInEditorDoc = (0, $42omo.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;
module.exports["useActiveInlineCommentsQuery"] = $9d95853344936385$export$6ddede7674b6d70f;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $cgtv4.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("cAdj8", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $eSUdr.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type status space{id}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: ''
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("a6t12", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");


var $dD7ks = parcelRequire("dD7ks");


var $9wGTI = parcelRequire("9wGTI");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { position: t1, userId: userId, isAnonymous: t2, canViewProfile: t3, children: children, trigger: t4, fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel } = t0;
    const position = t1 === undefined ? "bottom-start" : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const canViewProfile = t3 === undefined ? true : t3;
    const trigger = t4 === undefined ? "hover" : t4;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            type: "LANDING"
        };
        $[0] = t5;
    } else t5 = $[0];
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)(t5);
    let t6;
    if ($[1] !== orgId) {
        t6 = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || "", {
                type: "USER",
                payload: {
                    userId: clickedUserId
                }
            });
        $[1] = orgId;
        $[2] = t6;
    } else t6 = $[2];
    const getReportingLinesUserProfile = t6;
    const t7 = userId || "";
    let t8;
    if ($[3] !== t7) {
        t8 = {
            type: "USER",
            payload: {
                userId: t7
            }
        };
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)(t8);
    let t9;
    if ($[5] !== reportingLines) {
        t9 = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
        $[5] = reportingLines;
        $[6] = t9;
    } else t9 = $[6];
    const reportingLinesProfileUrl = t9;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    let t10;
    if ($[7] !== push || $[8] !== userId || $[9] !== userProfile) {
        t10 = (0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        });
        $[7] = push;
        $[8] = userId;
        $[9] = userProfile;
        $[10] = t10;
    } else t10 = $[10];
    const viewProfileAction = t10;
    let t11;
    if ($[11] !== followedUsers || $[12] !== getToggleFollowUser || $[13] !== loggedInUserId || $[14] !== renderFeedFollow || $[15] !== userId) {
        t11 = $3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        });
        $[11] = followedUsers;
        $[12] = getToggleFollowUser;
        $[13] = loggedInUserId;
        $[14] = renderFeedFollow;
        $[15] = userId;
        $[16] = t11;
    } else t11 = $[16];
    const followUserAction = t11;
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) {
        let t12;
        if ($[17] !== children) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[17] = children;
            $[18] = t12;
        } else t12 = $[18];
        return t12;
    }
    let t12;
    if ($[19] !== createAnalyticsEvent || $[20] !== getReportingLinesUserProfile || $[21] !== push) {
        t12 = (clickedUserId_0)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "profileCardWrapper",
                    action: "clicked",
                    actionSubject: "viewProfile",
                    actionSubjectId: "userProfileCard",
                    attributes: {
                        clickTarget: "userReportingLine"
                    }
                }
            }).fire();
            if ((0, $5XsiK.isTeamsAppEnabled)()) {
                getReportingLinesUserProfile(clickedUserId_0).onNavigate();
                return false;
            }
            if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, "", (0, $jlIaF.CONTEXT_PATH)), "_blank", "noreferrer");
            else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, $3d0f3ea3171aff68$var$_temp);
        };
        $[19] = createAnalyticsEvent;
        $[20] = getReportingLinesUserProfile;
        $[21] = push;
        $[22] = t12;
    } else t12 = $[22];
    const reportingLinesClickCallback = t12;
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== ariaLabel || $[25] !== children || $[26] !== cloudId || $[27] !== disabledAriaAttributes || $[28] !== featureFlags || $[29] !== feedConfigError || $[30] !== followUserAction || $[31] !== fullName || $[32] !== isVisible || $[33] !== loggedInUserId || $[34] !== mutationError || $[35] !== offset || $[36] !== onVisibilityChange || $[37] !== position || $[38] !== reportingLinesClickCallback || $[39] !== reportingLinesProfileUrl || $[40] !== trigger || $[41] !== userId || $[42] !== viewProfileAction) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t13
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
                feedConfigError: feedConfigError,
                mutationError: mutationError,
                showErrorFlag: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
                cloudId: cloudId,
                userId: userId,
                resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
                position: position,
                trigger: trigger,
                actions: [
                    viewProfileAction,
                    followUserAction
                ],
                reportingLinesProfileUrl: reportingLinesProfileUrl,
                onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
                addFlag: (flag)=>flags.showFlag(flag),
                prepopulatedData: {
                    fullName: fullName
                },
                disabledAriaAttributes: disabledAriaAttributes,
                isVisible: (0, $9wGTI.fg)("fix_profilecard_trigger_isvisible") ? undefined : isVisible,
                onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                    setIsVisible(changedIsVisible);
                }),
                offset: offset,
                testId: "profileCardTrigger",
                viewingUserId: loggedInUserId,
                ...disabledAriaAttributes ? {} : {
                    ariaLabel: ariaLabel
                }
            }, children)));
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = cloudId;
        $[27] = disabledAriaAttributes;
        $[28] = featureFlags;
        $[29] = feedConfigError;
        $[30] = followUserAction;
        $[31] = fullName;
        $[32] = isVisible;
        $[33] = loggedInUserId;
        $[34] = mutationError;
        $[35] = offset;
        $[36] = onVisibilityChange;
        $[37] = position;
        $[38] = reportingLinesClickCallback;
        $[39] = reportingLinesProfileUrl;
        $[40] = trigger;
        $[41] = userId;
        $[42] = viewProfileAction;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const reportingLines = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $42omo.useMemo)(()=>(0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $42omo.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $5XsiK.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            isVisible: (0, $9wGTI.fg)('fix_profilecard_trigger_isvisible') ? undefined : isVisible,
            onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                setIsVisible(changedIsVisible);
            }),
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
function $3d0f3ea3171aff68$var$_temp() {}
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("bedVD", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $cgtv4.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ followed: followed })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip),
        position: "bottom",
        testId: "feed-follow-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow)));
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $eSUdr.default)`query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}`;
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $eSUdr.default)`mutation useFeedFollowFeedFollowMutation($follow:[ID]$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow unfollowUsers:$unfollow}){success}}`;
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $diswb.useQuery)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error)
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $diswb.useMutation)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            },
            'FeedFollowQuery'
        ]
    });
    const followedUsers = data?.getFeedUserConfig?.accountIds;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch (_) {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    const feedFollowData = {
        renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
        loading: queryLoading,
        getToggleFollowUser: getToggleFollowUser,
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        followedUsers: followedUsers
    };
    const feedFollowDataMemoized = (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? feedFollowDataMemoized : feedFollowData;
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $hp2SH = parcelRequire("hp2SH");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const UserProfileClientForConfluencePromise = (0, $hp2SH.getApolloClient)().query({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            }
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/**
 * @generated SignedSource<<6837b1662181fa3feff08f9973248f40>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $eSUdr.default)`query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false id:$userId){id confluence{permissionType}}entitlements{externalCollaborator{isEntitled}}}`;
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("gj42z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: feedConfigError
    }) : null, mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (showErrorFlag) flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
        });
        return null;
    })) : null);
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("9CnRS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("jJK3p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ userId: userId, fullName: fullName, isAnonymous: isAnonymous = false, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: behavior = 'link', position: position = 'bottom-start', offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: isUnderlinedByDefault = true })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    const renderNameComponent = ()=>{
        if (behavior === 'card') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            isAnonymous: isAnonymous,
            userId: userId,
            position: position,
            offset: offset,
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            xcss: $5c1fbd48d7d200d4$var$linkStyles
        }, fullName));
        else {
            const linkStyle = {
                ...style,
                ...isUnderlinedByDefault ? {
                    textDecoration: 'underline'
                } : {}
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                target: "_blank",
                onClick: onUserLinkClick,
                href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: linkStyle,
                "data-testid": "profile-link",
                "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                    fullName: fullName
                })
            }, fullName);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "profile.anonymous.name",
        defaultMessage: "Anonymous"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : (props)=>{
    const { href: href, to: to, ...otherProps } = props;
    const url = to || href;
    const path = url && url.indexOf('/') !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        ...props,
        href: (0, $5XsiK.isTeamsAppEnabled)() ? url : destination,
        ...otherProps
    });
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("8lYIw", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8T1Wf = parcelRequire("8T1Wf");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (props, ref)=>{
    const { target: target, name: name, href: href = null, to: to = null, params: params = {} } = props;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: ""
    });
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    return match && target !== '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
        ...props,
        ref: ref,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: path
    });
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
} : ({ path: path, ...parentProps }, ref)=>{
    const { children: children, className: className, target: target, testId: testId, style: style, id: id } = parentProps;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    const onAnchorLinkClick = (e)=>{
        // @ts-ignore this should probably be `e.currentTarget`
        onPageReload(e.target.getAttribute('href'), false);
        if (parentProps.onClick) parentProps.onClick(e);
    };
    const onAnchorContextMenuClick = (e_0)=>{
        parentProps.onContextMenu?.(e_0);
    };
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: path,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onAnchorLinkClick,
        onContextMenu: onAnchorContextMenuClick,
        target: target,
        id: id,
        rel: target === '_blank' ? 'noreferrer' : undefined,
        "data-testid": testId,
        ref: ref,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ match: match, ...parentProps }, ref)=>{
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    const onMouseDownCapture = async ()=>preloadRoute(match);
    /**
   * Define the `onClick` handler for `react-router-dom`
   * [Link](https://github.com/ReactTraining/react-router/blob/346153e38365e6a88657ce2e4e5acada290fc430/packages/react-router-dom/modules/Link.js)
   * to make sure the SPA transition will go through RouteManager's push
   * method. Under the hood `RouteManager#push` still calls `history.push`, but
   * in addition it can reach out specified route policy if any. If not
   * eligible for SPA transition, then it will continue delegate to
   * react-router-dom Link to handle the click.
   */ const onClick = (event)=>{
        if (parentProps.onClick) parentProps.onClick(event);
        const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
        if (!event.defaultPrevented && details?.href) {
            event.preventDefault();
            routesContext.push(details.href);
        }
    };
    const onContextMenu = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
        to: `${match.pathname}${match.search}${match.hash}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onClick,
        onContextMenu: onContextMenu,
        onMouseDownCapture: onMouseDownCapture,
        innerRef: ref,
        id: id,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("8T1Wf", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6784f6b3e56cd8b3$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6784f6b3e56cd8b3$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $6784f6b3e56cd8b3$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fgJFQ.createLocation)(to, null, null, currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef === "undefined") $6784f6b3e56cd8b3$var$forwardRef = $6784f6b3e56cd8b3$var$forwardRefShim;
function $6784f6b3e56cd8b3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6784f6b3e56cd8b3$var$LinkAnchor = $6784f6b3e56cd8b3$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6784f6b3e56cd8b3$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a = $6784f6b3e56cd8b3$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6784f6b3e56cd8b3$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6784f6b3e56cd8b3$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $fgJFQ.createPath)(context.location) === (0, $fgJFQ.createPath)($6784f6b3e56cd8b3$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $6784f6b3e56cd8b3$var$toType, $6784f6b3e56cd8b3$var$refType;
var $6784f6b3e56cd8b3$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef$1 === "undefined") $6784f6b3e56cd8b3$var$forwardRef$1 = $6784f6b3e56cd8b3$var$forwardRefShim$1;
function $6784f6b3e56cd8b3$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6784f6b3e56cd8b3$export$b0d92dbee9b5b60d = $6784f6b3e56cd8b3$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6784f6b3e56cd8b3$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim$1 !== $6784f6b3e56cd8b3$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784f6b3e56cd8b3$export$a6c7ac8248d6e38a, props);
    });
});
var $6784f6b3e56cd8b3$var$ariaCurrentType;
module.exports["Link"] = $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a;

});

parcelRegister("fs6LW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t4;
    } else t4 = $[0];
    const handleVisibilityChange = t4;
    let t5;
    let t6;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t5 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t6 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t5;
        $[4] = t6;
    } else {
        t5 = $[3];
        t6 = $[4];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t7 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t7;
    } else t7 = $[7];
    const handleKeyDown = t7;
    const t8 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t9;
    if ($[8] !== intl) {
        t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t8 || $[16] !== t9 || $[17] !== testId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t8,
            ...t9,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t8;
        $[16] = t9;
        $[17] = testId;
        $[18] = t10;
    } else t10 = $[18];
    const Icon = t10;
    let t11;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name) {
        t11 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = t11;
    } else t11 = $[22];
    const getAriaProps = t11;
    const t12 = name || "";
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[23] = t13;
    } else t13 = $[23];
    const t14 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t15;
    if ($[24] !== t14) {
        t15 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t14
        ];
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== getAriaProps) {
        t16 = getAriaProps();
        $[26] = getAriaProps;
        $[27] = t16;
    } else t16 = $[27];
    let t17;
    if ($[28] !== Icon || $[29] !== handleKeyDown || $[30] !== t15 || $[31] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t15,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t16
        }, Icon);
        $[28] = Icon;
        $[29] = handleKeyDown;
        $[30] = t15;
        $[31] = t16;
        $[32] = t17;
    } else t17 = $[32];
    let t18;
    if ($[33] !== canViewProfile || $[34] !== isAnonymous || $[35] !== offset || $[36] !== position || $[37] !== t12 || $[38] !== t17 || $[39] !== trigger || $[40] !== userId) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t12,
            disabledAriaAttributes: t13,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t17);
        $[33] = canViewProfile;
        $[34] = isAnonymous;
        $[35] = offset;
        $[36] = position;
        $[37] = t12;
        $[38] = t17;
        $[39] = trigger;
        $[40] = userId;
        $[41] = t18;
    } else t18 = $[41];
    return t18;
} : ({ userId: userId, canViewProfile: canViewProfile = true, isAnonymous: isAnonymous = false, size: size = 'medium', src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset })=>{
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    const handleVisibilityChange = (isVisible_0)=>{
        setIsVisible(isVisible_0);
    };
    (0, $42omo.useEffect)(()=>{
        if (shouldReturnFocus && !isVisible && avatarRef.current) {
            avatarRef.current.focus();
            setShouldReturnFocus(false);
        }
    }, [
        isVisible,
        shouldReturnFocus
    ]);
    const handleKeyDown = (e)=>{
        e.stopPropagation();
        if (e.key === 'Enter') {
            setWasKeyboardAction(true);
            setIsVisible((prev)=>!prev);
            setShouldReturnFocus(true);
        } else if (e.key === 'Escape' && isVisible && wasKeyboardAction) {
            setIsVisible(false);
            setWasKeyboardAction(false);
            setShouldReturnFocus(true);
        }
    };
    const Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarSrc,
        size: size,
        target: "_blank",
        name: (0, $9wGTI.fg)('a11y_whiteboards_changes') ? '' : name || '',
        ...(0, $9wGTI.fg)('a11y_whiteboards_changes') ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        },
        stackIndex: stackIndex,
        testId: testId,
        borderColor: borderColor,
        onClick: onClick
    });
    // Compute ARIA attributes based on feature flag
    const getAriaProps = ()=>{
        if ((0, $9wGTI.fg)('a11y_whiteboards_changes')) // When feature flag is enabled, don't add ARIA attributes to the div
        return {};
        // Legacy behavior: always add ARIA attributes when feature flag is off
        return {
            'aria-haspopup': 'true',
            'aria-expanded': isVisible,
            'aria-label': intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                name: name || ''
            }),
            role: 'button',
            tabIndex: 0
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        canViewProfile: canViewProfile,
        isAnonymous: isAnonymous,
        trigger: trigger,
        fullName: name || '',
        disabledAriaAttributes: (0, $9wGTI.fg)('a11y_whiteboards_changes'),
        onVisibilityChange: handleVisibilityChange,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor
        ],
        testId: "avatarWrapperTestId",
        ref: avatarRef,
        onKeyDown: handleKeyDown,
        ...getAriaProps()
    }, Icon));
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("6b5EI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ])
    });
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
        ...rest,
        ref: ref
    }, children));
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
} : ({ visible: visible, textToCopy: textToCopy, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    const needRenderCopyArea = (0, $42omo.useMemo)(()=>!(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)(), []);
    (0, $42omo.useEffect)(()=>{
        if (needRenderCopyArea) copyWrapperRef.current = document.getElementById('copyWrapperRef');
    }, [
        needRenderCopyArea
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
        return ()=>clearTimeout(cleanupTimer.current);
    }, [
        isCopied
    ]);
    const handleButtonClick = async (event)=>{
        event.stopPropagation();
        if (isCopied) return;
        if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
        else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
        else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
        const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                action: 'clicked',
                actionSubject: 'copyCommentLink',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
        setCopied(true);
    };
    const tooltipContent = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
        visible: visible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        position: "top",
        tag: $0220545780b126ac$var$CustomizedTooltipTag,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        "data-cy": "inline-comment-time-link",
        iconBefore: !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        }),
        onClick: handleButtonClick,
        spacing: "none"
    })), needRenderCopyArea && // there won't be children, but VisuallyHidden requires it
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        testId: $0220545780b126ac$export$266980ac2cfa7919,
        id: "copyWrapperRef"
    }, children));
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $1dnxO = parcelRequire("1dnxO");


var $9wGTI = parcelRequire("9wGTI");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
const $e9d2c346c5e28ee8$export$aa10bd88079cd4f3 = 60;
/**
 * Returns the HTMLElement that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled = false) {
    //if we are in mobile size for nav4, we should still scroll window.
    // the magic number below maps to media.above.md @media (min-width: 64rem)	1024px which sadly appears to have no means of access in pure JS
    if (isNav4Enabled && window.innerWidth > 1023 && document.getElementById('AkMainContent')) return document.getElementById('AkMainContent');
    return window;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("kI6Jo")),
                (parcelRequire("YiYda"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    if (scrollRootElement) {
        //typecheck is convinced this can be null
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = isLivePage ? document.querySelector('.fabric-editor-popup-scroll-parent') : $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = isNav4Enabled ? (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 56 : 0 : $e9d2c346c5e28ee8$export$aa10bd88079cd4f3;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch (err) {
        isNav4Enabled ? $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent` : $e9d2c346c5e28ee8$var$logger.error`window.scroll() is not supported`;
    }
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;

});

parcelRegister("kI6Jo", function(module, exports) {

let $f13d236567563fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13d236567563fe5$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("YiYda", function(module, exports) {

let $0b5451c9b84ee3f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b5451c9b84ee3f1$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

const $f3bd82ae210529c7$export$57395cb9dce31159 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useNavigationPolicy() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useNavigationPolicy() {
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    return (0, $42omo.useMemo)(()=>({
            routePolicy: routePolicy,
            ...shimUrl
        }), [
        routePolicy,
        shimUrl
    ]);
};
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
const $734ea8da77496ad5$export$8ed0b067e5cd675d = (0, $3u0dr.isReactCompilerActiveV1)() ? function useShimUrl(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : function useShimUrl(navigationPolicy) {
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    const shimUrl = (0, $42omo.useCallback)((urlToShim)=>{
        return $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimAdfUrls = (0, $42omo.useCallback)((adf)=>{
        if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
        const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
        $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        return adfClone;
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter
    ]);
    const shimHtmlUrls = (0, $42omo.useCallback)((html)=>{
        if (!shimTemplate || !html) return html;
        // shimHtmlUrls is used on legacy macros, but some legacy macros return stringified ADFEntity
        // Check if the input is a JSON-stringified ADFEntity
        try {
            const parsedContent = JSON.parse(html);
            if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                // It's a valid ADF document - check if it needs nested table transformation
                if (html.includes('"extensionKey":"nested-table"')) {
                    const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                    return JSON.stringify(processedAdf);
                } else {
                    // ADF without nested tables - just delegate to shimAdfUrls and stringify the result
                    const shimmedAdf = shimAdfUrls(parsedContent);
                    return JSON.stringify(shimmedAdf);
                }
            }
        } catch  {
        // Not valid JSON, fall through to HTML processing
        }
        // Process as HTML string (for non-ADF content)
        try {
            return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, 'text/html'), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
        } catch  {
            return html;
        }
    }, [
        shimTemplate,
        domainNamesToReplace,
        spaceKeyFilter,
        shimAdfUrls
    ]);
    return (0, $42omo.useMemo)(()=>({
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        }), [
        shimUrl,
        shimAdfUrls,
        shimHtmlUrls
    ]);
};
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");


var $jf9LK = parcelRequire("jf9LK");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))) {
            const activeFeatureGate = featureName;
            const featureGateKey = (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))[activeFeatureGate];
            return (0, $9wGTI.fg)(featureGateKey);
        }
        return false;
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("jf9LK", function(module, exports) {
module.exports = JSON.parse("{\"whiteboardSolidHeader\":\"confluence_frontend_solid_whiteboard_header\",\"whiteboardOptOut\":\"whiteboards_compliance_opt_out\",\"digitalTeammate\":\"cc-ai-whiteboards-enable-digital-teammate\",\"aiFirstCreation\":\"aifc_create_enabled\"}");

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("7EIq6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");

const $649b778bbd82b1bb$export$1defcb29347f9ac6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(15);
    const t0 = spaceKey !== undefined;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== t0) {
        t2 = {
            skip: t0,
            variables: t1
        };
        $[1] = t0;
        $[2] = t2;
    } else t2 = $[2];
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t2);
    const t3 = !spaceKey && !defaultSpaceKeyData;
    const t4 = spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id;
    let t5;
    if ($[3] !== t4) {
        t5 = {
            spaceKey: t4
        };
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = {
            errorPolicy: "all",
            skip: t3,
            variables: t5
        };
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const spaceEnabledContentTypesQueryOptions = t6;
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    let t7;
    if ($[8] !== isCreateBlogEnabled || $[9] !== isCreateDatabaseEnabled || $[10] !== isCreateFolderEnabled || $[11] !== isCreateLiveDocEnabled || $[12] !== isCreateSmartLinkEnabled || $[13] !== isCreateWhiteboardEnabled) {
        t7 = {
            isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
            isCreateBlogEnabled: isCreateBlogEnabled,
            isCreateDatabaseEnabled: isCreateDatabaseEnabled,
            isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
            isCreateLiveDocEnabled: isCreateLiveDocEnabled,
            isCreateFolderEnabled: isCreateFolderEnabled
        };
        $[8] = isCreateBlogEnabled;
        $[9] = isCreateDatabaseEnabled;
        $[10] = isCreateFolderEnabled;
        $[11] = isCreateLiveDocEnabled;
        $[12] = isCreateSmartLinkEnabled;
        $[13] = isCreateWhiteboardEnabled;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : (spaceKey)=>{
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const isCreateWhiteboardEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const isCreateBlogEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isBlogsEnabled);
    const isCreateDatabaseEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    const isCreateSmartLinkEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isEmbedsEnabled);
    const isCreateLiveDocEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const isCreateFolderEnabled = Boolean(enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled);
    return {
        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
        isCreateBlogEnabled: isCreateBlogEnabled,
        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
        isCreateFolderEnabled: isCreateFolderEnabled
    };
};
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("bMPhU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $ep3mz = parcelRequire("ep3mz");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (spaceKey)=>{
    const $ = (0, $frIzR.c)(6);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`;
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $diswb.useQuery)(t0, t3);
    return data?.space?.homepage?.id || undefined;
} : (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $diswb.useQuery)((0, $eSUdr.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $cgtv4.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("2w2Hu", function(module, exports) {
// Please keep this file in sync with MustPreloadLoadableNamesNew.ts
// while gate confluence_ssr_remove_nested_babel_transforms is running
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ var $8cf96aaaf31dfd76$export$75ebf2388340a0ba = /*#__PURE__*/ function(MustPreloadLoadableNames) {
    MustPreloadLoadableNames["ClassicRendererLoader"] = "ClassicRendererLoader";
    MustPreloadLoadableNames["ClassicEditorContextProviderLoader"] = "ClassicEditorContextProviderLoader";
    MustPreloadLoadableNames["NativeCollabLoader"] = "NativeCollabLoader";
    MustPreloadLoadableNames["FullPageEditorLoader"] = "FullPageEditorLoader";
    MustPreloadLoadableNames["ViewPageRouteComponentLoader"] = "ViewPageRouteComponentLoader";
    MustPreloadLoadableNames["LivePageComponentLoader"] = "LivePageComponentLoader";
    MustPreloadLoadableNames["EditorByLineArea"] = "EditorByLineArea";
    return MustPreloadLoadableNames;
}({});
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("79msg"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("79msg"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("79msg", function(module, exports) {

let $534acab63c6d7f83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $534acab63c6d7f83$var$load("7q8Na"),
    $534acab63c6d7f83$var$load("8ublV"),
    $534acab63c6d7f83$var$load("kWSPH"),
    $534acab63c6d7f83$var$load("jXx9i"),
    $534acab63c6d7f83$var$load("iZU4p"),
    $534acab63c6d7f83$var$load("9ftJe"),
    $534acab63c6d7f83$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("hHZWk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
const $fe7178b75f06350f$export$b688bc1b9fd324b6 = (0, $3u0dr.isReactCompilerActiveV1)() ? function MarkPlaceholderIgnoredWrapper(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function MarkPlaceholderIgnoredWrapper({ placeholder: placeholder, children: children }) {
    (0, $42omo.useLayoutEffect)(()=>{
        const markPlaceholderIgnored = (e)=>{
            if (e?.tagName === 'SPAN') {
                e.setAttribute('data-ssr-placeholder-ignored', 'true');
                Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
            }
        };
        markPlaceholderIgnored(placeholder);
    }, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("euF5O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("eV0v4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("c1UWH", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            this.observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer) {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $2XqLN.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("iEfSb"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("iEfSb"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $4FHTF = parcelRequire("4FHTF");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $eSUdr.default)`query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}`;
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $diswb.useQuery)($3ae84312c23de134$var$ReactionsPlaceholderQuery, t3);
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
} : ({ useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading } = (0, $diswb.useQuery)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        variables: {
            contentId: contentId
        },
        // Only run this query if we're in SSR and useAccuratePills is set and not showing picker since doesn't use the pill UI
        skip: !isSSR || !useAccuratePills || !contentId || onlyRenderPicker
    });
    if (loading) return null;
     // Picker is only an icon and has no pills
    const renderPlaceholder = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            justifyContent: "center",
            alignItems: "center",
            testId: "reactions-picker-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
            label: "",
            analyticsContext: {
                name: 'reactionsPicker',
                ...customAnalyticsAttributes
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "reactions-placeholder",
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
            ])
        }, Array(numPills).fill('').map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                key: i,
                "data-testid": "reactions-pill",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
                ])
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "reaction-icon",
            className: (0, $gMc0m.default)([
                "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
            ])
        })); // We only need to show accurate pills in SSR
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length; // If we get a count of reactions use it, otherwise fall back to the default
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        return renderPlaceholder(numReactionPills);
    } else return renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $gMc0m.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("5Kc7f", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $eTjjM = parcelRequire("eTjjM");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        className: (0, $gMc0m.default)([
            $aba7293523a7a5b0$var$styles.wrapperStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $aba7293523a7a5b0$var$styles.countSkeletonStyles
        ])
    }));
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("iEfSb", function(module, exports) {

let $d9384678a3891dd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9384678a3891dd7$var$load("1dcav"),
    $d9384678a3891dd7$var$load("kWSPH"),
    $d9384678a3891dd7$var$load("6wr18"),
    $d9384678a3891dd7$var$load("Wowvf"),
    $d9384678a3891dd7$var$load("7EorR"),
    $d9384678a3891dd7$var$load("3EXzu"),
    $d9384678a3891dd7$var$load("ffEVr"),
    $d9384678a3891dd7$var$load("7q8Na"),
    $d9384678a3891dd7$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("6bd6t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $biiXa = parcelRequire("biiXa");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $fYQcF = parcelRequire("fYQcF");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $7OLeD = parcelRequire("7OLeD");


var $PjC9c = parcelRequire("PjC9c");


var $dchHi = parcelRequire("dchHi");

const $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $6d65bb3bd17dd577$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    likeSuggestionTooltip: {
        id: "quick-summary.like-suggestion.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeSuggestionTooltip: {
        id: "quick-summary.dislike-suggestion.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $6d65bb3bd17dd577$var$PrivacyPolicyLink = ({ link: link })=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink));
const $6d65bb3bd17dd577$var$ResearchGroupLink = ({ link: link })=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.researchGroupLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6d65bb3bd17dd577$var$i18n.researchGroupLink));
const $6d65bb3bd17dd577$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$6d65bb3bd17dd577$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$PrivacyPolicyLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $6d65bb3bd17dd577$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$6d65bb3bd17dd577$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$ResearchGroupLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $6d65bb3bd17dd577$var$TooltipWrapperXCSS = (0, $ecnYn.xcss)({
    listStyle: 'none',
    marginTop: 'space.0'
});
const $6d65bb3bd17dd577$var$FeedbackIconXCSS = (0, $ecnYn.xcss)({
    marginRight: 'space.050'
});
const $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $6d65bb3bd17dd577$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $6d65bb3bd17dd577$var$InlineULXCSS = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0',
    display: 'flex'
});
const $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3 = ({ analyticsProperties: analyticsProperties, contentId: contentId, spaceKey: spaceKey, summaryId: summaryId, summaryLocale: summaryLocale, feedbackTitle: feedbackTitle, feedbackSummaryPlaceholder: feedbackSummaryPlaceholder, aiContentType: aiContentType })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const feedbackCollectorProperties = (0, $dchHi.useFeedbackCollectorProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // Only fetch contributor info when contentId is provided (not for space-level feedback)
    const shouldFetchContributors = !!contentId;
    const contributorResult = (0, $PjC9c.useCurrentUserContributor)(contentId || '');
    const { isCurrentUserContributor: isCurrentUserContributor, contentContributorsError: contentContributorsError } = shouldFetchContributors ? contributorResult : {
        isCurrentUserContributor: undefined,
        contentContributorsError: undefined
    };
    const feedbackContextParts = [
        contentId && `contentId: ${contentId}`,
        spaceKey && `spaceKey: ${spaceKey}`,
        `sentiment: ${sentiment}`,
        `cloudId: ${cloudId}`,
        `isCurrentUserContributor: ${isCurrentUserContributor}`,
        feedbackCollectorProperties.feedbackContext.length > 0 && feedbackCollectorProperties.feedbackContext
    ].filter(Boolean);
    const feedbackContextString = feedbackContextParts.join(' ');
    (0, $42omo.useEffect)(()=>{
        if (isFeedbackOpen) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: `${analyticsProperties.source}FeedbackCollectorDialog`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFeedbackOpen,
        contentId,
        spaceKey,
        summaryId,
        summaryLocale,
        sentiment,
        analyticsProperties
    ]);
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($6d65bb3bd17dd577$var$i18n.flagTitle),
            description: formatMessage($6d65bb3bd17dd577$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('up');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}DislikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('down');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}SubmitFeedbackButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    const likeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.likeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.likeTooltip;
    const dislikeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.dislikeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.dislikeTooltip;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $6d65bb3bd17dd577$var$InlineULXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage(likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: onLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage(dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: onDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage(feedbackSummaryPlaceholder ?? $6d65bb3bd17dd577$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage(feedbackTitle ?? $6d65bb3bd17dd577$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($6d65bb3bd17dd577$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$EnrolLabel, null)
    })), contentContributorsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentContributorsError
    })));
};
module.exports["SmartsFeedbackComponent"] = $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3;

});

parcelRegister("7OLeD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $e94a9fb89963bcaa$export$1337fc502d44e2c0 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        spacing: "spacious",
        label: ""
    });
module.exports["ThumbsIcon"] = $e94a9fb89963bcaa$export$1337fc502d44e2c0;

});

parcelRegister("PjC9c", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");

const $03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery = (0, $eSUdr.default)`query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}`;
const $03062ed3aa730446$export$b7b7e80a2f61884d = (contentId)=>{
    const { data: data, loading: contentContributorsLoading, error: contentContributorsError } = (0, $j1Ss3.useQuery)($03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery, {
        variables: {
            contentId: contentId
        }
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? undefined;
    return {
        isCurrentUserContributor: isCurrentUserContributor,
        contentContributorsLoading: contentContributorsLoading,
        contentContributorsError: contentContributorsError
    };
};
module.exports["useCurrentUserContributor"] = $03062ed3aa730446$export$b7b7e80a2f61884d;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
	 * Calculates Create Issue dialog target area
	 */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
	 * Calculates the action panel target area
	 */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("804Ue", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");


var $cQkIJ = parcelRequire("cQkIJ");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $42omo.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $42omo.useRef)(null);
    const missedEventQueryTimeout = (0, $42omo.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $42omo.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $42omo.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const response = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $cQkIJ.MissedCommentEventsQuery),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                context: {
                    fetchOptions: {
                        ignoreNoNetworkError: true
                    },
                    single: true
                }
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = (comment.comment?.author).accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $42omo.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("cQkIJ", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $49adc3cefa9af833$export$9a6d2339e4e672fb = (0, $eSUdr.default)`query MissedCommentEventsQuery($contentId:Long!$since:Long!){quickReload(pageId:$contentId since:$since){time comments{comment{id location{type}author{...on KnownUser{accountId}...on UnknownUser{accountId}}}}}}`;
module.exports["MissedCommentEventsQuery"] = $49adc3cefa9af833$export$9a6d2339e4e672fb;

});

parcelRegister("eTcMK", function(module, exports) {
const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("hkzol", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $8C5kA.default)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $kfIha = parcelRequire("kfIha");


var $hkzol = parcelRequire("hkzol");

const $68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery = (0, $eSUdr.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip
    });
    const makeContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            // omit databases and other unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("jooGc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $1P1Tu.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $9zUhf.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $9zUhf.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("03oqz", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $hp2SH = parcelRequire("hp2SH");


var $9wGTI = parcelRequire("9wGTI");

const $895e8bda1c5e4d1e$export$15e2805385ec0eed = (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $3B9cR.InlineCommentQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            annotationId: markerRef,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
    else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
};
const $895e8bda1c5e4d1e$export$90e382997b4dc102 = async (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const commentThreadDataResult = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $3B9cR.InlineCommentQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                annotationId: markerRef,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    } else {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const commentThreadDataResult = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                inlineMarkerRefList: [
                    markerRef
                ],
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    }
};
const $895e8bda1c5e4d1e$export$e136ff0cd91112e0 = async ({ contentId: contentId, markerRef: markerRef, addNewCommentThreads: addNewCommentThreads })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) addNewCommentThreads && addNewCommentThreads({
        inline: {
            [markerRef]: {
                ...comment,
                isUnread: true,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).INLINE
            }
        },
        general: {}
    });
};
const $895e8bda1c5e4d1e$export$120fd6a8527dd6bd = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, addReplyToCommentThread: addReplyToCommentThread, commentType: commentType, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const replies = comment?.replies;
    const reply = replies?.filter((r)=>r?.id === commentId)[0];
    if (reply) {
        // Update storedCommentData if it exists by adding the new reply
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData,
                replies: [
                    ...storedCommentData.replies || [],
                    reply
                ]
            };
            // Only update if inlineMarkerRef matches between stored and fetched comment
            if (storedCommentData.location?.inlineMarkerRef === comment?.location?.inlineMarkerRef) setStoredCommentData(updatedCommentData);
        }
        addReplyToCommentThread && addReplyToCommentThread(markerRef, {
            ...reply,
            isUnread: true
        }, commentType);
    }
};
const $895e8bda1c5e4d1e$export$7652b163bd2668c5 = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const targetComment = comment?.id === commentId ? comment : comment?.replies?.find((r)=>r?.id === commentId);
    if (targetComment && updateCommentBody) updateCommentBody(commentId, markerRef, targetComment.body.value, (0, $8i27m.CommentType).INLINE, targetComment.version.by?.displayName);
};
module.exports["refreshCommentThread"] = $895e8bda1c5e4d1e$export$15e2805385ec0eed;
module.exports["handleAddNewCommentThread"] = $895e8bda1c5e4d1e$export$e136ff0cd91112e0;
module.exports["handleAddedReplyInCommentThread"] = $895e8bda1c5e4d1e$export$120fd6a8527dd6bd;
module.exports["handleEditedComment"] = $895e8bda1c5e4d1e$export$7652b163bd2668c5;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("hl0fg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $42omo.useState)(getSize);
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("3D12W", function(module, exports) {
/* CommentPanelButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $8Q7Uc = parcelRequire("8Q7Uc");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $cgtv4.defineMessages)({
    openCommentsPanelLabel: {
        id: "object-sidebar-components.open.comments.panel.label",
        defaultMessage: "Open Comments Panel"
    },
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    },
    unreadCommentsLabel: {
        id: "object-sidebar-components.unread.comments.icon.label",
        defaultMessage: "You have unread comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = ({ contentId: contentId, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { commentsMarkedAsRead: commentsMarkedAsRead } = (0, $3mVfX.useCommentsPanelState)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon) return;
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: isShortcutTextShown && !(0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            contentBefore: formatMessage($404f4d0022b5692a$var$i18n.showCommentsLabel),
            isEditorShortcut: pageMode === 'edit' || isLiveEditMode,
            isTooltip: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown && (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
        } : {},
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q7Uc.UnreadCommentCount), {
        pageId: contentId,
        pageMode: pageMode === 'view' ? 'view' : 'edit',
        commentsMarkedAsRead: commentsMarkedAsRead,
        isStandaloneComment: isStandaloneComment
    })), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("8Q7Uc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bb1882b5e8585780$export$991e9ba11b35b458 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ykWGq",
    name: "UnreadCommentCount",
    loader: async ()=>(await (parcelRequire("hV0WE"))).UnreadCommentCount
});
module.exports["UnreadCommentCount"] = $bb1882b5e8585780$export$991e9ba11b35b458;

});

parcelRegister("hV0WE", function(module, exports) {

let $d0b87e34861efd6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0b87e34861efd6f$var$load("7ZBIQ"),
    $d0b87e34861efd6f$var$load("kpzlp")
]).then(()=>parcelRequire('i34K4'));

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("g1WP0", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8J3W8")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8J3W8")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;
module.exports["NotificationNudgeAsyncWrapper"] = $a55d612ff94024a3$export$abc42570cc861f1b;

});

parcelRegister("8J3W8", function(module, exports) {

let $65a5946b29a9e3e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65a5946b29a9e3e3$var$load("6wr18"),
    $65a5946b29a9e3e3$var$load("1TOYq"),
    $65a5946b29a9e3e3$var$load("ffEVr"),
    $65a5946b29a9e3e3$var$load("7EorR"),
    $65a5946b29a9e3e3$var$load("awqCy"),
    $65a5946b29a9e3e3$var$load("hhss7"),
    $65a5946b29a9e3e3$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("4gEXU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: onConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // This hook enables the new preemptive gate for the editor comment API manager to catch the situation
    // where the user tries to start a draft while there is unsaved content in the editor.
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            if (hasContentChanged) annotationManager.setPreemptiveGate(()=>{
                return new Promise((resolve)=>{
                    showModal((0, $cMvMc.CommentWarningDialog), {
                        onConfirm: ()=>{
                            resetContentChanged();
                            onConfirm();
                            // Allow the draft to be started or the comment viewed.
                            resolve(true);
                        },
                        onCancel: ()=>{
                            // Cancel the start draft or view attempt.
                            resolve(false);
                        },
                        onClose: ()=>{
                            // Just in case the user closes the modal by some other means we need to ensure the
                            // promise is resolved. We do not want to leave the preemptive gate open.
                            resolve(false);
                        }
                    });
                });
            });
            else annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            return ()=>{
                annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            };
        }
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        onConfirm
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("bEdUx", function(module, exports) {
/* HighlightActionsProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4JDbp = parcelRequire("4JDbp");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$baseStyles = null;
const $cef29f59925fac19$var$zIndex11Styles = null;
const $cef29f59925fac19$var$zIndex13Styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm",
            (0, $9wGTI.fg)('confluence_highlight_actions_zindex_fix') ? "_1pbyibnn" : "_1pbyilow"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4JDbp.WidthObserver), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; /**
    *  In Nav4, we need to render the HighlightActionsProvider inside the #AkMainContent container instead of at the top of
    *  our app in <App />. This is because Nav4 uses a grid. So in Nav4 the window itself no longer scrolls; the #AkMainContent
    *  element does.
    *
    *  These HighlightActionsProviderForNav3 and HighlightActionsProviderForNav4 components allow us to render
    *  HighlightActions in different places depending on which nav is enabled.
    */ 
const $cef29f59925fac19$export$84dec73d5759755c = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? null : /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return (0, $1dnxO.getIsNav4Enabled)() ? /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null) : null;
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav3"] = $cef29f59925fac19$export$84dec73d5759755c;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("kxhju", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gTyTP = parcelRequire("gTyTP");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch, isLiveDocsEnabled: isLiveDocsEnabled } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            if (isLiveDocsEnabled) webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    let t0;
    if ($[0] !== isLivePagesFeatureEnabled || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
            ...props,
            isLiveDocsEnabled: isLivePagesFeatureEnabled
        });
        $[0] = isLivePagesFeatureEnabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, {
        ...props,
        isLiveDocsEnabled: isLivePagesFeatureEnabled
    });
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ])
    });
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("8tGpb"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("kmWRd", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    let t4;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: "320px",
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ headerHeight: headerHeight = 0, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        fade: "inout"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            // `props` has className, so use inline styling to avoid conflicts
            style: {
                backgroundColor: 'elevation.surface',
                position: isFixed ? 'fixed' : 'absolute',
                right: '0',
                top: `${panelTop}px`,
                width: '320px',
                padding: 'space.300',
                borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                height: `calc(100vh - ${headerHeight}px)`,
                borderTop: displayTopBorder ? `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7a88b175622d580e$var$sidePanelContentStyling
        }, children))));
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("cfwlu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $b4emg = parcelRequire("b4emg");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fwDOR = parcelRequire("fwDOR");


var $9hlns = parcelRequire("9hlns");


var $cOrQJ = parcelRequire("cOrQJ");


var $fVTNs = parcelRequire("fVTNs");

var $3C50A = parcelRequire("3C50A");

var $bHD89 = parcelRequire("bHD89");


var $liF9q = parcelRequire("liF9q");


var $4KAVh = parcelRequire("4KAVh");


var $0XxK1 = parcelRequire("0XxK1");


var $g5o3i = parcelRequire("g5o3i");


var $7u9UW = parcelRequire("7u9UW");


var $4SDuV = parcelRequire("4SDuV");

const $0e7ff5291d49736a$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $0e7ff5291d49736a$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0XxK1.AnalyticsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVTNs.ContextWrapper), {
            sourceType: (0, $bHD89.MODAL),
            sourceName: "gicAnywhere",
            children: /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$c43a9e8a05acb520, {
                ...props
            })
        })
    });
};
const $0e7ff5291d49736a$var$styles = {
    hiddenDisplay: "_1e0cglyw",
    gicAnywhere: "_1bsb1osq _4t3i1osq",
    loadingScreen: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o"
};
const $0e7ff5291d49736a$export$c43a9e8a05acb520 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $7u9UW.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false, additionalMappedFields: additionalMappedFields, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $g5o3i.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId,
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $42omo.useState)($0e7ff5291d49736a$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $0e7ff5291d49736a$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($0e7ff5291d49736a$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $0e7ff5291d49736a$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($0e7ff5291d49736a$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $42omo.useCallback)(()=>{
        setPhase($0e7ff5291d49736a$var$phases.idle);
        return {
            summary: summary || 'No summary provided' /* this is impossible case */ ,
            descriptionAdf: descriptionAdf || (0, $b4emg.getEmptyADF)(),
            projectId: projectId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee,
            fieldData: additionalMappedFields
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        issueTypeId,
        issueTypes,
        assignee,
        additionalMappedFields
    ]);
    const renderPhaseInformation = (0, $42omo.useMemo)(()=>{
        switch(phase){
            case $0e7ff5291d49736a$var$phases.timeout:
            case $0e7ff5291d49736a$var$phases.loading:
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $1Whri.cx)($0e7ff5291d49736a$var$styles.gicAnywhere, $0e7ff5291d49736a$var$styles.loadingScreen),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: formatMessage(phase === $0e7ff5291d49736a$var$phases.timeout ? (0, $4SDuV.messages).iFrameSlowLoading : (0, $4SDuV.messages).iFrameLoading, {
                                br: /*#__PURE__*/ (0, $l998X.jsx)("br", {})
                            })
                        })
                    ]
                });
            case $0e7ff5291d49736a$var$phases.error:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-error",
                    xcss: $0e7ff5291d49736a$var$styles.gicAnywhere,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                        header: formatMessage((0, $4SDuV.messages).errorHeader),
                        description: formatMessage((0, $4SDuV.messages).errorBody),
                        primaryAction: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                            onClick: ()=>{
                                onClose();
                            },
                            href: domainName || '/',
                            target: "_blank",
                            appearance: "primary",
                            children: formatMessage((0, $4SDuV.messages).openInJiraButton)
                        }),
                        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($liF9q))),
                        imageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageHeight: (0, $7u9UW.MAX_ERROR_IMAGE_HEIGHT)
                    })
                });
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            renderPhaseInformation,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: "gic-anywhere-iframe-loading",
                hold: phase === $0e7ff5291d49736a$var$phases.loading
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: phase !== $0e7ff5291d49736a$var$phases.idle ? $0e7ff5291d49736a$var$styles.hiddenDisplay : $0e7ff5291d49736a$var$styles.gicAnywhere,
                children: domainName !== undefined && /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$ae3b6dcb03669e81, {
                    domainName: domainName,
                    consumer: consumer,
                    onGICReady: onGICReady,
                    onInit: onInit,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onClose: onClose,
                    configuration: configuration,
                    displaySitePicker: displaySitePicker,
                    isPayloadReady: isPayloadReady,
                    overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined
                })
            })
        ]
    });
};
const $0e7ff5291d49736a$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false })=>{
    (0, $fBMbo.di)($0e7ff5291d49736a$export$b32b5f1ee4493319);
    const iframeRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $42omo.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $42omo.useState)(false);
    const isGicReadyRef = (0, $42omo.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $42omo.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $42omo.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]); // Create a debounced version of onInit that will only execute the latest call after 2 seconds
    const debouncedOnInit = (0, $42omo.useMemo)(()=>{
        if (!onInit) return undefined;
        if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return onInit;
        return (0, $0XxK1.debounce)(()=>onInit(), 2000);
    }, [
        onInit
    ]); // Cleanup the debounced function on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const debouncedFn = debouncedOnInit; // Only call cancel if debouncedOnInit is actually a debounced function
            if (debouncedFn && typeof debouncedFn.cancel === 'function') debouncedFn.cancel();
        };
    }, [
        debouncedOnInit
    ]);
    (0, $42omo.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $3C50A.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $3C50A.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                const { fieldData: fieldData, ...defaultValues } = issuePayload ?? {}; // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: defaultValues,
                        ...fieldData && {
                            fieldData: {
                                ...fieldData,
                                ...defaultValues
                            }
                        }
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                debouncedOnInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        debouncedOnInit
    ]);
    const iframeSrc = (0, $0XxK1.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: displaySitePicker,
        ...configuration,
        overrideCloudId: overrideCloudId
    });
    (0, $42omo.useEffect)(()=>{
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $42omo.useEffect)(()=>{
        const TIMEOUT_10_SECONDS = 10000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_10_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $0e7ff5291d49736a$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});
module.exports["GicAnywhere"] = $0e7ff5291d49736a$export$9af19a1ca8685214;

});

parcelRegister("liF9q", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("4KAVh", function(module, exports) {
// Error messages
const $2ad7ca53e97d3c24$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $2ad7ca53e97d3c24$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $2ad7ca53e97d3c24$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $2ad7ca53e97d3c24$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $2ad7ca53e97d3c24$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
module.exports["ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED"] = $2ad7ca53e97d3c24$export$bdb28edf034fd38;
module.exports["JIRA_EMBED_ISSUE_CREATE_INIT"] = $2ad7ca53e97d3c24$export$b342b407e829290;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $2ad7ca53e97d3c24$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_SUCCESS"] = $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9;
module.exports["JIRA_EMBED_ISSUE_CREATE_FAILURE"] = $2ad7ca53e97d3c24$export$c1caf9536ed579cc;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $2ad7ca53e97d3c24$export$a402043ad8e6699;

});

parcelRegister("0XxK1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a9sR2 = parcelRequire("a9sR2");


var $kDuN4 = parcelRequire("kDuN4");


var $dh538 = parcelRequire("dh538");


var $bHD89 = parcelRequire("bHD89");

var $hzZxz = parcelRequire("hzZxz");


var $4KAVh = parcelRequire("4KAVh");

const $5588f1d8fd0b9255$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $5588f1d8fd0b9255$var$LIGHT_MODE = 'light';
const $5588f1d8fd0b9255$var$DARK_MODE = 'dark';
const $5588f1d8fd0b9255$var$AUTO = 'auto';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $5588f1d8fd0b9255$export$a31dd10290664cf6 = 2048;
const $5588f1d8fd0b9255$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $5588f1d8fd0b9255$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    /**
	 * We want to use the postMessageInit param to instruct the Jira embed iframe
	 * to wait before mounting Issue Create.
	 * It will send a message back to us when it's ready to receive the init message
	 */ const srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if (srcUrl.length > $5588f1d8fd0b9255$export$a31dd10290664cf6) onFailure?.(new Error((0, $4KAVh.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $5588f1d8fd0b9255$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
async function $5588f1d8fd0b9255$export$5e195155111b6846(baseUrlForAvailableSites) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $5588f1d8fd0b9255$export$61874183278c256e
        })
    };
    const base = baseUrlForAvailableSites ? baseUrlForAvailableSites.replace(/\/$/, '') : '';
    const availableSitesPath = (0, $dh538.fg)('issue_create_modal_site_picker_api_unit_compliant') ? $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH;
    const response = await fetch(`${base}${availableSitesPath}`, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $5588f1d8fd0b9255$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $42omo.useRef)(new (0, $a9sR2.default)($5588f1d8fd0b9255$var$analyticsClientInfo, {}));
    const sendEvent = (0, $42omo.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $bHD89.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $bHD89.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $bHD89.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: (0, $bHD89.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $hzZxz.extractAWCDataFromEvent)(event)),
        children: props.children
    });
};
const $5588f1d8fd0b9255$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return func;
    const debounced = (...args)=>{
        const later = ()=>{
            timeout = undefined;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
module.exports["getIframeSrc"] = $5588f1d8fd0b9255$export$584bd4ae64a8d7e2;
module.exports["getAvailableJiraSites"] = $5588f1d8fd0b9255$export$5e195155111b6846;
module.exports["AnalyticsProvider"] = $5588f1d8fd0b9255$export$1b581a2ec13e37f1;
module.exports["debounce"] = $5588f1d8fd0b9255$export$61fc7d43ac8f84b0;

});

parcelRegister("g5o3i", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $0XxK1 = parcelRequire("0XxK1");

const $5909ab59f28be203$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [domain, setDomain] = (0, $42omo.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const hasMount = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)(baseUrlForAvailableSites);
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        baseUrlForAvailableSites,
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $5909ab59f28be203$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $5909ab59f28be203$export$7872bb66f9195035({
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const { domain: domainName } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if (error) throw new Error('Failed to fetch available sites');
    return loading ? {
        availableSites: [],
        domainName: undefined,
        isOverrideSiteAvailable: undefined
    } : {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};
module.exports["useGetFirstAvailableSiteDomain"] = $5909ab59f28be203$export$930bddfd3ad23bb7;
module.exports["useGetDomainAndAvailableSites"] = $5909ab59f28be203$export$48ca77029c1208c2;

});

parcelRegister("7u9UW", function(module, exports) {
const $f25a4ef78ed97248$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $f25a4ef78ed97248$export$6dfc55fc5e2544ae = 188;
const $f25a4ef78ed97248$export$85d8afb0902718e2 = 250;
module.exports["DEFAULT_TIMEOUT"] = $f25a4ef78ed97248$export$7bd623b29ec8e1eb;
module.exports["MAX_ERROR_IMAGE_WIDTH"] = $f25a4ef78ed97248$export$6dfc55fc5e2544ae;
module.exports["MAX_ERROR_IMAGE_HEIGHT"] = $f25a4ef78ed97248$export$85d8afb0902718e2;

});

parcelRegister("4SDuV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $2b8c8c7153d4d991$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading work item details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your work item.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});
module.exports["messages"] = $2b8c8c7153d4d991$export$defe85febe8b728c;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("4WZFP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, children);
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("lKMTm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $91csT = parcelRequire("91csT");


var $1Z9af = parcelRequire("1Z9af");

const $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES = 50;
const $12fcc847cd6ca878$var$getNotesQueryOptions = {
    query: (0, $1Z9af.GetNotesQuery),
    variables: {
        limit: $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES
    }
};
const $12fcc847cd6ca878$export$30b78dd9f3a45abb = ()=>{
    const { error: error, loading: loading, data: data } = (0, $diswb.useQuery)((0, $eSUdr.default)`query useNotesDataNotesByCreatorQuery($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`, {
        ...$12fcc847cd6ca878$var$getNotesQueryOptions,
        errorPolicy: 'all'
    });
    const transformDataToCacheFormat = (currentCache, dataToCache)=>{
        return {
            ...currentCache,
            notesByCreator: {
                ...currentCache.notesByCreator,
                nodes: dataToCache
            }
        };
    };
    const readCache = (cache)=>cache.readQuery($12fcc847cd6ca878$var$getNotesQueryOptions);
    const writeCache = (cache, notesByCreatorData)=>{
        cache.writeQuery({
            ...$12fcc847cd6ca878$var$getNotesQueryOptions,
            data: notesByCreatorData
        });
    };
    const [createNoteMutation, { loading: createNoteLoading }] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation useNotesDataCreateNoteMutation($title:String$body:String){createNote(input:{title:$title body:$body}){errors{message}success note{ari title body bodyExcerpt collectionName isPinned thumbnailId labels createdAt updatedAt backgroundColor extraProps{key value}}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.createNote?.note) {
                const newCacheData = [
                    responseData.createNote.note,
                    ...cachedData.notesByCreator.nodes
                ];
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const [updateNoteMutation] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation useNotesDataUpdateNoteMutation($ari:String!$title:String$body:String$isPinned:Boolean=false$backgroundColor:String){updateNote(input:{title:$title body:$body backgroundColor:$backgroundColor metadata:{ari:$ari isPinned:$isPinned}}){errors{message extensions{errorType statusCode}}success note{ari title body bodyExcerpt collectionName isPinned updatedAt backgroundColor}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.updateNote?.note?.ari) {
                // find old cache note index
                const cachedNoteIndex = cachedData.notesByCreator.nodes.findIndex((note)=>note?.ari === responseData.updateNote?.note?.ari);
                if (cachedNoteIndex >= 0) {
                    // if exist get the cache note data
                    const cachedNoteData = cachedData.notesByCreator.nodes[cachedNoteIndex];
                    if (cachedNoteData) {
                        // if data is not null, delete cache note and add updated note to top
                        const updatedNoteData = {
                            ...cachedNoteData,
                            ...responseData.updateNote?.note
                        }; // added null to keep types happy
                        const newCacheData = [
                            updatedNoteData
                        ].concat(cachedData.notesByCreator.nodes.slice(0, cachedNoteIndex), cachedData.notesByCreator.nodes.slice(cachedNoteIndex + 1));
                        writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
                    }
                }
            }
        }
    });
    const [deleteNoteMutation, { error: deleteNoteError, loading: deleteNoteLoading, data: deleteNoteData }] = (0, $diswb.useMutation)((0, $eSUdr.default)`mutation useNotesDataDeleteNoteMutation($ari:String!){deleteNote(input:{ari:$ari}){errors{message}success ari}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.deleteNote?.ari) {
                const newCacheData = cachedData.notesByCreator.nodes.filter((note)=>note?.ari !== responseData?.deleteNote?.ari);
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const all = data?.notesByCreator;
    const notes = (all?.nodes || []).map((note)=>(0, $91csT.transformToNote)(note || undefined));
    // This has been created just for the early access program since we are limiting users to only 50 notes.
    const userHasMaxNumberOfNotes = notes.length >= $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES;
    return {
        notesData: notes,
        createNote: createNoteMutation,
        createNoteLoading: createNoteLoading,
        deleteNote: deleteNoteMutation,
        deleteNoteError: deleteNoteError,
        deleteNoteLoading: deleteNoteLoading,
        deleteNoteData: deleteNoteData,
        updateNote: updateNoteMutation,
        loading: loading,
        error: error,
        userHasMaxNumberOfNotes: userHasMaxNumberOfNotes
    };
};
module.exports["useNotesData"] = $12fcc847cd6ca878$export$30b78dd9f3a45abb;

});

parcelRegister("91csT", function(module, exports) {
const $77980f4c3c79dff6$export$c24f25c953d270b8 = (payload)=>{
    if (!payload) return {};
    const { body: body, ...noteData } = payload;
    let adf;
    // This try catch has been added temporarily because plaintext non-adf/json was added to the DB
    // TODO: remove once we sanitize all of those test entries
    try {
        adf = body ? JSON.parse(body) : undefined;
    } catch (e) {
        adf = undefined;
    }
    return {
        ...noteData,
        adf: adf
    };
};
module.exports["transformToNote"] = $77980f4c3c79dff6$export$c24f25c953d270b8;

});

parcelRegister("1Z9af", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b216a6ab139869d9$export$34a99364d28fe306 = (0, $eSUdr.default)`query NotesByCreator($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`;
module.exports["GetNotesQuery"] = $b216a6ab139869d9$export$34a99364d28fe306;

});

parcelRegister("6JI2k", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $3b74fcc841254653$var$notesInitialState = {
    activeNoteId: undefined
};
const $3b74fcc841254653$var$noteEditorApiInitialState = {
    noteEditorApi: undefined
};
const $3b74fcc841254653$var$notesActions = {
    setActiveNoteId: (activeNoteId)=>({ setState: setState })=>{
            setState({
                activeNoteId: activeNoteId
            });
        },
    resetActiveNoteId: ()=>({ setState: setState })=>{
            setState({
                activeNoteId: undefined
            });
        }
};
const $3b74fcc841254653$var$noteEditorApiActions = {
    setNoteEditorApi: (noteEditorApi)=>({ setState: setState })=>{
            setState({
                noteEditorApi: noteEditorApi
            });
        },
    resetNoteEditorApi: ()=>({ setState: setState })=>{
            setState($3b74fcc841254653$var$noteEditorApiInitialState);
        }
};
const $3b74fcc841254653$var$NotesStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$notesInitialState,
    actions: $3b74fcc841254653$var$notesActions,
    name: 'NotesStore'
});
const $3b74fcc841254653$var$NoteEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$noteEditorApiInitialState,
    actions: $3b74fcc841254653$var$noteEditorApiActions,
    name: 'NoteEditorApiStore'
});
const $3b74fcc841254653$export$ecce9ae725432b7b = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NotesStore);
const $3b74fcc841254653$var$selectActiveNoteId = (state)=>state.activeNoteId;
const $3b74fcc841254653$export$2e974306a61c660e = (0, $9zUhf.createHook)($3b74fcc841254653$var$NotesStore, {
    selector: $3b74fcc841254653$var$selectActiveNoteId
});
const $3b74fcc841254653$export$b2bc9c556f5ab60 = (0, $9zUhf.createHook)($3b74fcc841254653$var$NoteEditorApiStore);
const $3b74fcc841254653$export$510fc84c2883e9ba = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NoteEditorApiStore);
module.exports["useNotesActions"] = $3b74fcc841254653$export$ecce9ae725432b7b;
module.exports["useActiveNoteId"] = $3b74fcc841254653$export$2e974306a61c660e;
module.exports["useNoteEditorApi"] = $3b74fcc841254653$export$b2bc9c556f5ab60;
module.exports["useNoteEditorApiActions"] = $3b74fcc841254653$export$510fc84c2883e9ba;

});

parcelRegister("aPZGK", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

const $9cba950ac61e4fac$export$6b103b516a87812f = (adf)=>{
    /* Temporary way to get text from ADF in order to generate an excerpt before BE query is finished
	 * Also used for frontend filtering/search
	 * We want to get the text entries of any content nodes in the adf labelled with type: text
	 */ if (adf) return (0, $1A9t2.reduce)(adf, (currentValue, node)=>{
        if (node.type === 'text') return `${currentValue} ${node.text}`.trim(); // trim to ensure we remove the space from template string if empty node.text
        else return currentValue;
    }, '');
    return '';
};
const $9cba950ac61e4fac$export$1eb0427f7c98fb36 = (note)=>{
    if (note) {
        const noteHasContent = note.adf && note.adf.content && note.adf.content.length > 0;
        return !noteHasContent && !note.title;
    }
    return true;
};
module.exports["extractAdfText"] = $9cba950ac61e4fac$export$6b103b516a87812f;
module.exports["isNoteBlank"] = $9cba950ac61e4fac$export$1eb0427f7c98fb36;

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("1hlqe"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("1hlqe", function(module, exports) {

let $0ee7fefa4c4c1110$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ee7fefa4c4c1110$var$load("jwWp5"),
    $0ee7fefa4c4c1110$var$load("3ySTn"),
    $0ee7fefa4c4c1110$var$load("c2rHL"),
    $0ee7fefa4c4c1110$var$load("kAAjo"),
    $0ee7fefa4c4c1110$var$load("fbRdC"),
    $0ee7fefa4c4c1110$var$load("6wr18"),
    $0ee7fefa4c4c1110$var$load("89WyM"),
    $0ee7fefa4c4c1110$var$load("607sQ"),
    $0ee7fefa4c4c1110$var$load("2t3HP"),
    $0ee7fefa4c4c1110$var$load("22RDk"),
    $0ee7fefa4c4c1110$var$load("gLGsg"),
    $0ee7fefa4c4c1110$var$load("5zqeF"),
    $0ee7fefa4c4c1110$var$load("fJtJG"),
    $0ee7fefa4c4c1110$var$load("glHWp"),
    $0ee7fefa4c4c1110$var$load("lkOIY"),
    $0ee7fefa4c4c1110$var$load("clQc9"),
    $0ee7fefa4c4c1110$var$load("8PPsf"),
    $0ee7fefa4c4c1110$var$load("jbxHq"),
    $0ee7fefa4c4c1110$var$load("5U3YO"),
    $0ee7fefa4c4c1110$var$load("8YSo7"),
    $0ee7fefa4c4c1110$var$load("g9CVe"),
    $0ee7fefa4c4c1110$var$load("5pvpJ"),
    $0ee7fefa4c4c1110$var$load("7FRNR"),
    $0ee7fefa4c4c1110$var$load("Wowvf"),
    $0ee7fefa4c4c1110$var$load("cyGuT"),
    $0ee7fefa4c4c1110$var$load("hhss7"),
    $0ee7fefa4c4c1110$var$load("kvhKJ"),
    $0ee7fefa4c4c1110$var$load("k5VqV"),
    $0ee7fefa4c4c1110$var$load("jXx9i"),
    $0ee7fefa4c4c1110$var$load("8m8aj"),
    $0ee7fefa4c4c1110$var$load("lT67w"),
    $0ee7fefa4c4c1110$var$load("iZU4p"),
    $0ee7fefa4c4c1110$var$load("flGQy"),
    $0ee7fefa4c4c1110$var$load("iL4mX"),
    $0ee7fefa4c4c1110$var$load("7u4WP"),
    $0ee7fefa4c4c1110$var$load("8lj0L"),
    $0ee7fefa4c4c1110$var$load("lY1AS"),
    $0ee7fefa4c4c1110$var$load("ffEVr"),
    $0ee7fefa4c4c1110$var$load("7q8Na"),
    $0ee7fefa4c4c1110$var$load("d6s42"),
    $0ee7fefa4c4c1110$var$load("gZGoR"),
    $0ee7fefa4c4c1110$var$load("iqKwT"),
    $0ee7fefa4c4c1110$var$load("efnul"),
    $0ee7fefa4c4c1110$var$load("75V2Q"),
    $0ee7fefa4c4c1110$var$load("9IeAj"),
    $0ee7fefa4c4c1110$var$load("18EHe"),
    $0ee7fefa4c4c1110$var$load("kT5Gk"),
    $0ee7fefa4c4c1110$var$load("8ublV"),
    $0ee7fefa4c4c1110$var$load("iZ4sC"),
    $0ee7fefa4c4c1110$var$load("kWSPH"),
    $0ee7fefa4c4c1110$var$load("4yA1q"),
    $0ee7fefa4c4c1110$var$load("5vIUN"),
    $0ee7fefa4c4c1110$var$load("7EorR"),
    $0ee7fefa4c4c1110$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});


//# sourceMappingURL=PageContentRendererFabric.4cce4bbf.js.map
